var data = {
    "Commit": {
        "All": {
            "data": [
                {
                    "color": "blanchedalmond",
                    "data": [
                        61.121,
                        70.694,
                        77.898,
                        87.252,
                        110.361,
                        113.237,
                        120.919,
                        147.405,
                        178.336,
                        189.375,
                        240.968,
                        281.012,
                        346.345,
                        418.815,
                        488.777,
                        547.489,
                        753.174,
                        795.452,
                        1064.79,
                        928.689,
                        1450.991,
                        1550.986,
                        1964.91,
                        2221.469,
                        2664.524,
                        2816.355,
                        3083.191,
                        3324.781,
                        4046.659,
                        4102.344,
                        4095.885,
                        4262.21,
                        4937.319,
                        4751.631,
                        4761.459,
                        4989.66,
                        5606.571,
                        5637.056,
                        5883.383,
                        5961.582,
                        6419.239,
                        6378.138,
                        6465.626,
                        6658.602,
                        6531.132
                    ],
                    "name": "All Unknown",
                    "type": "column"
                },
                {
                    "color": "#f29d4b",
                    "data": [
                        42.771,
                        53.241,
                        58.618,
                        65.885,
                        85.12,
                        89.196,
                        94.632,
                        114.969,
                        139.881,
                        147.852,
                        192.198,
                        220.198,
                        276.878,
                        329.225,
                        388.955,
                        437.265,
                        597.55,
                        636.808,
                        845.38,
                        741.225,
                        1150.984,
                        1217.887,
                        1524.687,
                        1719.814,
                        2060.815,
                        2187.387,
                        2391.805,
                        2558.435,
                        3105.123,
                        3126.477,
                        3117.818,
                        3214.944,
                        3685.448,
                        3538.168,
                        3480.617,
                        3678.228,
                        4144.103,
                        4097.663,
                        4231.291,
                        4283.489,
                        4624.897,
                        4554.694,
                        4573.615,
                        4671.429,
                        4560.289
                    ],
                    "name": "All Men",
                    "type": "column"
                },
                {
                    "color": "#de2d26",
                    "data": [
                        0.865,
                        1.29,
                        1.698,
                        1.03,
                        1.881,
                        2.044,
                        1.917,
                        2.317,
                        2.574,
                        3.644,
                        4.134,
                        5.234,
                        5.421,
                        5.949,
                        7.799,
                        8.093,
                        12.611,
                        13.116,
                        17.06,
                        14.509,
                        23.129,
                        26.803,
                        41.817,
                        43.136,
                        54.409,
                        58.301,
                        68.708,
                        76.442,
                        95.712,
                        101.929,
                        108.585,
                        101.901,
                        118.025,
                        126.566,
                        131.935,
                        137.761,
                        162.363,
                        175.716,
                        197.421,
                        175.117,
                        206.859,
                        216.615,
                        218.309,
                        222.962,
                        217.324
                    ],
                    "name": "All Women",
                    "type": "column"
                },
                {
                    "color": "darkblue",
                    "data": [
                        2.02,
                        2.42,
                        2.9,
                        1.56,
                        2.21,
                        2.29,
                        2.03,
                        2.02,
                        1.84,
                        2.46,
                        2.15,
                        2.38,
                        1.96,
                        1.81,
                        2.01,
                        1.85,
                        2.11,
                        2.06,
                        2.02,
                        1.96,
                        2.01,
                        2.2,
                        2.74,
                        2.51,
                        2.64,
                        2.67,
                        2.87,
                        2.99,
                        3.08,
                        3.26,
                        3.48,
                        3.17,
                        3.2,
                        3.58,
                        3.79,
                        3.75,
                        3.92,
                        4.29,
                        4.67,
                        4.09,
                        4.47,
                        4.76,
                        4.77,
                        4.77,
                        4.77
                    ],
                    "marker": {
                        "fillColor": "#FFFFFF",
                        "lineColor": "darkblue",
                        "lineWidth": 2,
                        "radius": 5
                    },
                    "name": "Among core",
                    "type": "spline",
                    "yAxis": 1
                }
            ],
            "height_ratio": 69.23076923076923,
            "label_x": "Time (quarter)",
            "label_y": "Commit Numbers (thousand)",
            "label_y_secondary": "Women Commit Ratio = F/(F + M)",
            "title": "Commits in All Public Projects",
            "x_categories": [
                "2008-3",
                "2008-6",
                "2008-9",
                "2008-12",
                "2009-3",
                "2009-6",
                "2009-9",
                "2009-12",
                "2010-3",
                "2010-6",
                "2010-9",
                "2010-12",
                "2011-3",
                "2011-6",
                "2011-9",
                "2011-12",
                "2012-3",
                "2012-6",
                "2012-9",
                "2012-12",
                "2013-3",
                "2013-6",
                "2013-9",
                "2013-12",
                "2014-3",
                "2014-6",
                "2014-9",
                "2014-12",
                "2015-3",
                "2015-6",
                "2015-9",
                "2015-12",
                "2016-3",
                "2016-6",
                "2016-9",
                "2016-12",
                "2017-3",
                "2017-6",
                "2017-9",
                "2017-12",
                "2018-3",
                "2018-6",
                "2018-9",
                "2018-12",
                "2019-3"
            ]
        },
        "Atom": {
            "data": [
                {
                    "color": "blanchedalmond",
                    "data": [
                        0.0,
                        0.0,
                        0.0,
                        0.0,
                        0.0,
                        0.0,
                        0.0,
                        0.0,
                        0.0,
                        0.0,
                        0.001,
                        0.0,
                        0.0,
                        0.0,
                        0.002,
                        0.0,
                        0.045,
                        0.492,
                        0.819,
                        0.754,
                        1.091,
                        0.979,
                        1.636,
                        2.723,
                        12.027,
                        12.421,
                        13.632,
                        12.706,
                        21.979,
                        29.654,
                        30.415,
                        26.66,
                        30.754,
                        30.306,
                        29.396,
                        29.67,
                        36.621,
                        29.269,
                        27.773,
                        24.525,
                        23.44,
                        20.041,
                        16.15,
                        15.238,
                        11.681
                    ],
                    "name": "All Unknown",
                    "type": "column"
                },
                {
                    "color": "#f29d4b",
                    "data": [
                        0.0,
                        0.0,
                        0.0,
                        0.0,
                        0.0,
                        0.0,
                        0.0,
                        0.0,
                        0.0,
                        0.0,
                        0.0,
                        0.0,
                        0.0,
                        0.0,
                        0.0,
                        0.0,
                        0.042,
                        0.488,
                        0.799,
                        0.702,
                        0.996,
                        0.901,
                        1.557,
                        2.673,
                        10.61,
                        9.922,
                        10.58,
                        9.774,
                        16.501,
                        21.503,
                        20.51,
                        18.664,
                        22.029,
                        20.968,
                        20.5,
                        20.313,
                        25.731,
                        21.725,
                        20.073,
                        18.063,
                        17.291,
                        14.859,
                        11.33,
                        11.034,
                        8.948
                    ],
                    "name": "All Men",
                    "type": "column"
                },
                {
                    "color": "#de2d26",
                    "data": [
                        0.0,
                        0.0,
                        0.0,
                        0.0,
                        0.0,
                        0.0,
                        0.0,
                        0.0,
                        0.0,
                        0.0,
                        0.0,
                        0.0,
                        0.0,
                        0.0,
                        0.0,
                        0.0,
                        0.009,
                        0.002,
                        0.001,
                        0.003,
                        0.005,
                        0.003,
                        0.02,
                        0.005,
                        0.172,
                        0.148,
                        0.289,
                        0.238,
                        0.45,
                        0.854,
                        0.563,
                        0.532,
                        0.723,
                        0.66,
                        0.548,
                        1.013,
                        0.839,
                        1.08,
                        1.097,
                        0.64,
                        0.768,
                        0.98,
                        0.541,
                        0.978,
                        0.541
                    ],
                    "name": "All Women",
                    "type": "column"
                },
                {
                    "color": "darkblue",
                    "data": [
                        0.0,
                        0.0,
                        0.0,
                        0.0,
                        0.0,
                        0.0,
                        0.0,
                        0.0,
                        0.0,
                        0.0,
                        0.0,
                        0.0,
                        0.0,
                        0.0,
                        0.0,
                        0.0,
                        0.0,
                        0.0,
                        0.0,
                        0.0,
                        0.0,
                        0.0,
                        1.28,
                        0.19,
                        1.62,
                        1.49,
                        2.73,
                        2.44,
                        2.73,
                        3.97,
                        2.75,
                        2.85,
                        3.28,
                        3.15,
                        2.67,
                        4.99,
                        3.26,
                        4.97,
                        5.47,
                        3.54,
                        4.44,
                        6.6,
                        4.77,
                        8.86,
                        6.05
                    ],
                    "marker": {
                        "fillColor": "#FFFFFF",
                        "lineColor": "darkblue",
                        "lineWidth": 2,
                        "radius": 5
                    },
                    "name": "Among core",
                    "type": "spline",
                    "yAxis": 1
                }
            ],
            "height_ratio": 69.23076923076923,
            "label_x": "Time (quarter)",
            "label_y": "Commit Numbers (thousand)",
            "label_y_secondary": "Women Commit Ratio = F/(F + M)",
            "title": "Commits in Atom Public Projects",
            "x_categories": [
                "2008-3",
                "2008-6",
                "2008-9",
                "2008-12",
                "2009-3",
                "2009-6",
                "2009-9",
                "2009-12",
                "2010-3",
                "2010-6",
                "2010-9",
                "2010-12",
                "2011-3",
                "2011-6",
                "2011-9",
                "2011-12",
                "2012-3",
                "2012-6",
                "2012-9",
                "2012-12",
                "2013-3",
                "2013-6",
                "2013-9",
                "2013-12",
                "2014-3",
                "2014-6",
                "2014-9",
                "2014-12",
                "2015-3",
                "2015-6",
                "2015-9",
                "2015-12",
                "2016-3",
                "2016-6",
                "2016-9",
                "2016-12",
                "2017-3",
                "2017-6",
                "2017-9",
                "2017-12",
                "2018-3",
                "2018-6",
                "2018-9",
                "2018-12",
                "2019-3"
            ]
        },
        "Bower": {
            "data": [
                {
                    "color": "blanchedalmond",
                    "data": [
                        3.463,
                        3.394,
                        3.819,
                        5.233,
                        5.826,
                        6.475,
                        6.038,
                        8.137,
                        11.418,
                        11.768,
                        16.024,
                        22.002,
                        27.513,
                        34.414,
                        38.718,
                        44.153,
                        62.028,
                        62.541,
                        86.007,
                        84.15,
                        136.154,
                        148.308,
                        189.619,
                        220.03,
                        265.462,
                        283.67,
                        300.008,
                        322.267,
                        373.344,
                        370.62,
                        360.241,
                        360.302,
                        395.029,
                        326.097,
                        298.734,
                        297.547,
                        306.25,
                        277.962,
                        255.918,
                        230.811,
                        236.026,
                        212.049,
                        189.038,
                        182.352,
                        174.245
                    ],
                    "name": "All Unknown",
                    "type": "column"
                },
                {
                    "color": "#f29d4b",
                    "data": [
                        3.027,
                        3.158,
                        3.071,
                        4.316,
                        4.507,
                        5.181,
                        4.025,
                        6.041,
                        8.316,
                        8.265,
                        12.291,
                        16.581,
                        21.191,
                        25.687,
                        29.548,
                        34.276,
                        47.718,
                        48.441,
                        68.213,
                        66.509,
                        107.968,
                        115.63,
                        146.891,
                        169.625,
                        202.124,
                        221.132,
                        229.687,
                        244.876,
                        283.414,
                        280.871,
                        269.666,
                        263.913,
                        282.156,
                        239.215,
                        220.178,
                        219.497,
                        223.829,
                        201.515,
                        182.141,
                        164.35,
                        170.775,
                        151.067,
                        136.453,
                        128.954,
                        122.596
                    ],
                    "name": "All Men",
                    "type": "column"
                },
                {
                    "color": "#de2d26",
                    "data": [
                        0.004,
                        0.007,
                        0.054,
                        0.088,
                        0.092,
                        0.175,
                        0.07,
                        0.097,
                        0.098,
                        0.323,
                        0.294,
                        0.567,
                        0.509,
                        0.712,
                        0.948,
                        1.001,
                        1.232,
                        1.216,
                        1.364,
                        1.027,
                        1.601,
                        2.273,
                        3.502,
                        3.307,
                        4.8,
                        5.617,
                        6.595,
                        7.056,
                        7.483,
                        8.492,
                        9.378,
                        7.887,
                        9.185,
                        8.853,
                        9.376,
                        7.75,
                        9.316,
                        10.176,
                        8.183,
                        6.404,
                        9.11,
                        8.848,
                        7.578,
                        6.962,
                        7.213
                    ],
                    "name": "All Women",
                    "type": "column"
                },
                {
                    "color": "darkblue",
                    "data": [
                        0.13,
                        0.22,
                        1.76,
                        2.04,
                        2.04,
                        3.38,
                        1.74,
                        1.61,
                        1.18,
                        3.91,
                        2.39,
                        3.42,
                        2.4,
                        2.77,
                        3.21,
                        2.92,
                        2.58,
                        2.51,
                        2.0,
                        1.54,
                        1.48,
                        1.97,
                        2.38,
                        1.95,
                        2.37,
                        2.54,
                        2.87,
                        2.88,
                        2.64,
                        3.02,
                        3.48,
                        2.99,
                        3.26,
                        3.7,
                        4.26,
                        3.53,
                        4.16,
                        5.05,
                        4.49,
                        3.9,
                        5.33,
                        5.86,
                        5.55,
                        5.4,
                        5.88
                    ],
                    "marker": {
                        "fillColor": "#FFFFFF",
                        "lineColor": "darkblue",
                        "lineWidth": 2,
                        "radius": 5
                    },
                    "name": "Among core",
                    "type": "spline",
                    "yAxis": 1
                }
            ],
            "height_ratio": 69.23076923076923,
            "label_x": "Time (quarter)",
            "label_y": "Commit Numbers (thousand)",
            "label_y_secondary": "Women Commit Ratio = F/(F + M)",
            "title": "Commits in Bower Public Projects",
            "x_categories": [
                "2008-3",
                "2008-6",
                "2008-9",
                "2008-12",
                "2009-3",
                "2009-6",
                "2009-9",
                "2009-12",
                "2010-3",
                "2010-6",
                "2010-9",
                "2010-12",
                "2011-3",
                "2011-6",
                "2011-9",
                "2011-12",
                "2012-3",
                "2012-6",
                "2012-9",
                "2012-12",
                "2013-3",
                "2013-6",
                "2013-9",
                "2013-12",
                "2014-3",
                "2014-6",
                "2014-9",
                "2014-12",
                "2015-3",
                "2015-6",
                "2015-9",
                "2015-12",
                "2016-3",
                "2016-6",
                "2016-9",
                "2016-12",
                "2017-3",
                "2017-6",
                "2017-9",
                "2017-12",
                "2018-3",
                "2018-6",
                "2018-9",
                "2018-12",
                "2019-3"
            ]
        },
        "CPAN": {
            "data": [
                {
                    "color": "blanchedalmond",
                    "data": [
                        1.264,
                        1.755,
                        1.771,
                        2.104,
                        2.867,
                        3.241,
                        3.988,
                        3.777,
                        5.338,
                        5.855,
                        5.258,
                        5.954,
                        7.317,
                        8.348,
                        9.147,
                        7.991,
                        8.897,
                        9.118,
                        11.85,
                        9.487,
                        14.284,
                        17.541,
                        23.129,
                        20.38,
                        20.977,
                        21.003,
                        29.203,
                        24.118,
                        30.881,
                        23.156,
                        20.224,
                        19.293,
                        22.492,
                        20.857,
                        15.66,
                        19.723,
                        20.779,
                        17.822,
                        19.992,
                        17.388,
                        16.675,
                        19.004,
                        14.061,
                        16.308,
                        14.956
                    ],
                    "name": "All Unknown",
                    "type": "column"
                },
                {
                    "color": "#f29d4b",
                    "data": [
                        0.932,
                        1.343,
                        1.414,
                        1.652,
                        2.308,
                        2.733,
                        3.307,
                        2.914,
                        4.702,
                        3.909,
                        4.058,
                        4.707,
                        6.101,
                        6.437,
                        7.434,
                        6.461,
                        7.593,
                        7.59,
                        9.824,
                        8.181,
                        12.106,
                        14.888,
                        18.746,
                        16.247,
                        16.832,
                        17.087,
                        24.56,
                        19.821,
                        26.381,
                        18.426,
                        15.492,
                        14.494,
                        16.177,
                        15.793,
                        12.181,
                        14.583,
                        13.997,
                        13.509,
                        11.897,
                        13.026,
                        12.081,
                        13.616,
                        9.698,
                        12.191,
                        9.699
                    ],
                    "name": "All Men",
                    "type": "column"
                },
                {
                    "color": "#de2d26",
                    "data": [
                        0.017,
                        0.014,
                        0.048,
                        0.011,
                        0.045,
                        0.161,
                        0.313,
                        0.188,
                        0.202,
                        0.199,
                        0.145,
                        0.077,
                        0.135,
                        0.134,
                        0.177,
                        0.16,
                        0.378,
                        0.516,
                        0.4,
                        0.448,
                        0.734,
                        1.153,
                        3.236,
                        1.788,
                        1.927,
                        1.495,
                        2.065,
                        2.092,
                        2.613,
                        1.975,
                        1.704,
                        0.682,
                        0.592,
                        1.216,
                        0.768,
                        0.516,
                        0.597,
                        0.98,
                        0.478,
                        0.695,
                        0.38,
                        0.695,
                        0.488,
                        0.961,
                        0.806
                    ],
                    "name": "All Women",
                    "type": "column"
                },
                {
                    "color": "darkblue",
                    "data": [
                        0.0,
                        1.04,
                        3.39,
                        0.67,
                        1.95,
                        5.89,
                        9.46,
                        6.45,
                        4.3,
                        5.09,
                        3.57,
                        1.64,
                        2.21,
                        2.08,
                        2.38,
                        2.48,
                        4.98,
                        6.8,
                        4.07,
                        5.48,
                        6.06,
                        7.74,
                        17.26,
                        11.01,
                        11.45,
                        8.75,
                        8.41,
                        10.55,
                        9.9,
                        10.72,
                        11.0,
                        4.71,
                        3.66,
                        7.7,
                        6.3,
                        3.54,
                        4.27,
                        7.25,
                        4.02,
                        5.34,
                        3.15,
                        5.1,
                        5.03,
                        7.88,
                        8.31
                    ],
                    "marker": {
                        "fillColor": "#FFFFFF",
                        "lineColor": "darkblue",
                        "lineWidth": 2,
                        "radius": 5
                    },
                    "name": "Among core",
                    "type": "spline",
                    "yAxis": 1
                }
            ],
            "height_ratio": 69.23076923076923,
            "label_x": "Time (quarter)",
            "label_y": "Commit Numbers (thousand)",
            "label_y_secondary": "Women Commit Ratio = F/(F + M)",
            "title": "Commits in CPAN Public Projects",
            "x_categories": [
                "2008-3",
                "2008-6",
                "2008-9",
                "2008-12",
                "2009-3",
                "2009-6",
                "2009-9",
                "2009-12",
                "2010-3",
                "2010-6",
                "2010-9",
                "2010-12",
                "2011-3",
                "2011-6",
                "2011-9",
                "2011-12",
                "2012-3",
                "2012-6",
                "2012-9",
                "2012-12",
                "2013-3",
                "2013-6",
                "2013-9",
                "2013-12",
                "2014-3",
                "2014-6",
                "2014-9",
                "2014-12",
                "2015-3",
                "2015-6",
                "2015-9",
                "2015-12",
                "2016-3",
                "2016-6",
                "2016-9",
                "2016-12",
                "2017-3",
                "2017-6",
                "2017-9",
                "2017-12",
                "2018-3",
                "2018-6",
                "2018-9",
                "2018-12",
                "2019-3"
            ]
        },
        "CRAN": {
            "data": [
                {
                    "color": "blanchedalmond",
                    "data": [
                        0.475,
                        0.382,
                        0.641,
                        0.455,
                        0.224,
                        0.49,
                        0.737,
                        0.843,
                        0.591,
                        0.781,
                        0.898,
                        0.938,
                        1.067,
                        1.234,
                        1.28,
                        1.529,
                        2.239,
                        3.226,
                        4.057,
                        2.782,
                        4.305,
                        5.146,
                        9.191,
                        10.346,
                        13.595,
                        13.657,
                        20.157,
                        22.074,
                        29.482,
                        35.11,
                        30.118,
                        30.715,
                        36.794,
                        36.555,
                        41.044,
                        42.038,
                        47.385,
                        53.085,
                        58.412,
                        56.85,
                        64.016,
                        62.805,
                        64.318,
                        65.886,
                        66.413
                    ],
                    "name": "All Unknown",
                    "type": "column"
                },
                {
                    "color": "#f29d4b",
                    "data": [
                        0.244,
                        0.324,
                        0.523,
                        0.197,
                        0.164,
                        0.372,
                        0.448,
                        0.717,
                        0.47,
                        0.595,
                        0.587,
                        0.552,
                        0.578,
                        0.848,
                        0.822,
                        1.022,
                        1.768,
                        2.425,
                        3.297,
                        2.24,
                        3.642,
                        4.012,
                        6.928,
                        8.157,
                        11.284,
                        11.412,
                        15.199,
                        17.373,
                        24.062,
                        27.089,
                        22.939,
                        23.948,
                        27.145,
                        28.669,
                        32.145,
                        32.861,
                        38.204,
                        42.845,
                        46.943,
                        43.265,
                        47.36,
                        48.6,
                        47.68,
                        48.384,
                        49.886
                    ],
                    "name": "All Men",
                    "type": "column"
                },
                {
                    "color": "#de2d26",
                    "data": [
                        0.0,
                        0.0,
                        0.0,
                        0.0,
                        0.0,
                        0.0,
                        0.0,
                        0.0,
                        0.0,
                        0.0,
                        0.0,
                        0.0,
                        0.001,
                        0.001,
                        0.001,
                        0.013,
                        0.021,
                        0.034,
                        0.073,
                        0.047,
                        0.192,
                        0.101,
                        0.091,
                        0.085,
                        0.117,
                        0.288,
                        0.48,
                        1.012,
                        1.134,
                        1.082,
                        0.961,
                        0.769,
                        1.359,
                        1.916,
                        0.967,
                        1.264,
                        1.589,
                        2.429,
                        1.745,
                        1.973,
                        2.663,
                        2.843,
                        2.93,
                        2.25,
                        2.82
                    ],
                    "name": "All Women",
                    "type": "column"
                },
                {
                    "color": "darkblue",
                    "data": [
                        0.0,
                        0.0,
                        0.0,
                        0.0,
                        0.0,
                        0.0,
                        0.0,
                        0.0,
                        0.0,
                        0.0,
                        0.0,
                        0.0,
                        0.0,
                        0.0,
                        0.0,
                        1.27,
                        1.19,
                        1.4,
                        2.21,
                        2.1,
                        5.27,
                        2.52,
                        1.31,
                        1.04,
                        1.04,
                        2.52,
                        3.16,
                        5.83,
                        4.71,
                        3.99,
                        4.19,
                        3.21,
                        5.01,
                        6.68,
                        3.01,
                        3.85,
                        4.16,
                        5.67,
                        3.72,
                        4.56,
                        5.62,
                        5.85,
                        6.15,
                        4.65,
                        5.65
                    ],
                    "marker": {
                        "fillColor": "#FFFFFF",
                        "lineColor": "darkblue",
                        "lineWidth": 2,
                        "radius": 5
                    },
                    "name": "Among core",
                    "type": "spline",
                    "yAxis": 1
                }
            ],
            "height_ratio": 69.23076923076923,
            "label_x": "Time (quarter)",
            "label_y": "Commit Numbers (thousand)",
            "label_y_secondary": "Women Commit Ratio = F/(F + M)",
            "title": "Commits in CRAN Public Projects",
            "x_categories": [
                "2008-3",
                "2008-6",
                "2008-9",
                "2008-12",
                "2009-3",
                "2009-6",
                "2009-9",
                "2009-12",
                "2010-3",
                "2010-6",
                "2010-9",
                "2010-12",
                "2011-3",
                "2011-6",
                "2011-9",
                "2011-12",
                "2012-3",
                "2012-6",
                "2012-9",
                "2012-12",
                "2013-3",
                "2013-6",
                "2013-9",
                "2013-12",
                "2014-3",
                "2014-6",
                "2014-9",
                "2014-12",
                "2015-3",
                "2015-6",
                "2015-9",
                "2015-12",
                "2016-3",
                "2016-6",
                "2016-9",
                "2016-12",
                "2017-3",
                "2017-6",
                "2017-9",
                "2017-12",
                "2018-3",
                "2018-6",
                "2018-9",
                "2018-12",
                "2019-3"
            ]
        },
        "Cargo": {
            "data": [
                {
                    "color": "blanchedalmond",
                    "data": [
                        0.0,
                        0.0,
                        0.0,
                        0.009,
                        0.087,
                        0.104,
                        0.127,
                        0.206,
                        0.171,
                        0.333,
                        0.216,
                        0.113,
                        0.364,
                        0.699,
                        0.578,
                        0.56,
                        0.857,
                        0.96,
                        1.341,
                        0.602,
                        0.664,
                        0.866,
                        2.443,
                        2.461,
                        3.385,
                        9.271,
                        15.801,
                        22.006,
                        35.691,
                        39.379,
                        36.542,
                        36.827,
                        52.59,
                        49.255,
                        56.112,
                        66.705,
                        85.549,
                        94.691,
                        95.595,
                        100.647,
                        121.308,
                        132.81,
                        149.476,
                        178.453,
                        188.732
                    ],
                    "name": "All Unknown",
                    "type": "column"
                },
                {
                    "color": "#f29d4b",
                    "data": [
                        0.0,
                        0.0,
                        0.0,
                        0.0,
                        0.0,
                        0.0,
                        0.0,
                        0.089,
                        0.078,
                        0.237,
                        0.148,
                        0.043,
                        0.011,
                        0.042,
                        0.008,
                        0.034,
                        0.262,
                        0.193,
                        0.271,
                        0.288,
                        0.561,
                        0.601,
                        1.684,
                        1.954,
                        2.829,
                        8.135,
                        13.887,
                        18.853,
                        29.63,
                        31.061,
                        29.309,
                        29.193,
                        40.253,
                        37.663,
                        42.711,
                        52.055,
                        66.384,
                        74.266,
                        72.737,
                        76.367,
                        94.175,
                        103.075,
                        113.975,
                        135.806,
                        141.835
                    ],
                    "name": "All Men",
                    "type": "column"
                },
                {
                    "color": "#de2d26",
                    "data": [
                        0.0,
                        0.0,
                        0.0,
                        0.0,
                        0.0,
                        0.0,
                        0.0,
                        0.0,
                        0.0,
                        0.0,
                        0.0,
                        0.0,
                        0.0,
                        0.0,
                        0.0,
                        0.0,
                        0.0,
                        0.001,
                        0.0,
                        0.0,
                        0.0,
                        0.0,
                        0.003,
                        0.121,
                        0.065,
                        0.228,
                        0.132,
                        0.527,
                        0.988,
                        1.283,
                        1.282,
                        0.737,
                        0.823,
                        0.896,
                        1.34,
                        1.452,
                        1.943,
                        2.546,
                        2.67,
                        2.458,
                        2.272,
                        3.043,
                        4.022,
                        3.866,
                        5.319
                    ],
                    "name": "All Women",
                    "type": "column"
                },
                {
                    "color": "darkblue",
                    "data": [
                        0.0,
                        0.0,
                        0.0,
                        0.0,
                        0.0,
                        0.0,
                        0.0,
                        0.0,
                        0.0,
                        0.0,
                        0.0,
                        0.0,
                        0.0,
                        0.0,
                        0.0,
                        0.0,
                        0.0,
                        0.0,
                        0.0,
                        0.0,
                        0.0,
                        0.0,
                        0.18,
                        6.19,
                        2.3,
                        2.8,
                        0.95,
                        2.8,
                        3.33,
                        4.13,
                        4.37,
                        2.52,
                        2.04,
                        2.38,
                        3.14,
                        2.79,
                        2.93,
                        3.43,
                        3.67,
                        3.22,
                        2.41,
                        2.95,
                        3.53,
                        2.85,
                        3.75
                    ],
                    "marker": {
                        "fillColor": "#FFFFFF",
                        "lineColor": "darkblue",
                        "lineWidth": 2,
                        "radius": 5
                    },
                    "name": "Among core",
                    "type": "spline",
                    "yAxis": 1
                }
            ],
            "height_ratio": 69.23076923076923,
            "label_x": "Time (quarter)",
            "label_y": "Commit Numbers (thousand)",
            "label_y_secondary": "Women Commit Ratio = F/(F + M)",
            "title": "Commits in Cargo Public Projects",
            "x_categories": [
                "2008-3",
                "2008-6",
                "2008-9",
                "2008-12",
                "2009-3",
                "2009-6",
                "2009-9",
                "2009-12",
                "2010-3",
                "2010-6",
                "2010-9",
                "2010-12",
                "2011-3",
                "2011-6",
                "2011-9",
                "2011-12",
                "2012-3",
                "2012-6",
                "2012-9",
                "2012-12",
                "2013-3",
                "2013-6",
                "2013-9",
                "2013-12",
                "2014-3",
                "2014-6",
                "2014-9",
                "2014-12",
                "2015-3",
                "2015-6",
                "2015-9",
                "2015-12",
                "2016-3",
                "2016-6",
                "2016-9",
                "2016-12",
                "2017-3",
                "2017-6",
                "2017-9",
                "2017-12",
                "2018-3",
                "2018-6",
                "2018-9",
                "2018-12",
                "2019-3"
            ]
        },
        "Clojars": {
            "data": [
                {
                    "color": "blanchedalmond",
                    "data": [
                        1.7,
                        1.917,
                        1.894,
                        1.748,
                        2.516,
                        2.505,
                        2.528,
                        3.931,
                        5.859,
                        5.756,
                        6.603,
                        7.746,
                        8.911,
                        7.972,
                        9.808,
                        13.629,
                        17.568,
                        17.789,
                        20.33,
                        18.928,
                        28.651,
                        27.286,
                        30.261,
                        33.266,
                        38.633,
                        37.34,
                        38.79,
                        42.456,
                        50.969,
                        48.159,
                        48.857,
                        48.071,
                        58.416,
                        55.014,
                        50.116,
                        49.759,
                        51.201,
                        46.982,
                        50.096,
                        51.467,
                        49.742,
                        47.991,
                        45.344,
                        46.424,
                        42.983
                    ],
                    "name": "All Unknown",
                    "type": "column"
                },
                {
                    "color": "#f29d4b",
                    "data": [
                        0.82,
                        0.769,
                        1.21,
                        1.019,
                        1.735,
                        1.746,
                        1.765,
                        2.968,
                        4.733,
                        4.712,
                        5.386,
                        5.827,
                        6.751,
                        6.97,
                        8.041,
                        11.171,
                        14.004,
                        14.988,
                        17.259,
                        15.464,
                        23.879,
                        22.643,
                        25.033,
                        27.306,
                        32.518,
                        31.079,
                        32.456,
                        35.586,
                        41.704,
                        39.353,
                        39.479,
                        38.157,
                        46.761,
                        42.907,
                        40.872,
                        40.044,
                        40.876,
                        36.619,
                        39.57,
                        40.191,
                        37.961,
                        36.615,
                        33.732,
                        34.584,
                        31.317
                    ],
                    "name": "All Men",
                    "type": "column"
                },
                {
                    "color": "#de2d26",
                    "data": [
                        0.0,
                        0.0,
                        0.0,
                        0.0,
                        0.032,
                        0.013,
                        0.035,
                        0.033,
                        0.04,
                        0.107,
                        0.083,
                        0.099,
                        0.116,
                        0.102,
                        0.078,
                        0.205,
                        0.221,
                        0.189,
                        0.293,
                        0.356,
                        0.67,
                        0.567,
                        0.418,
                        0.259,
                        0.49,
                        0.381,
                        0.458,
                        0.38,
                        0.423,
                        0.574,
                        0.61,
                        0.537,
                        0.766,
                        1.32,
                        1.092,
                        0.796,
                        0.853,
                        0.714,
                        0.76,
                        0.994,
                        0.887,
                        0.912,
                        0.975,
                        0.89,
                        0.992
                    ],
                    "name": "All Women",
                    "type": "column"
                },
                {
                    "color": "darkblue",
                    "data": [
                        0.0,
                        0.0,
                        0.0,
                        0.0,
                        1.84,
                        0.74,
                        1.98,
                        1.11,
                        0.85,
                        2.27,
                        1.54,
                        1.7,
                        1.72,
                        1.46,
                        0.97,
                        1.84,
                        1.58,
                        1.26,
                        1.7,
                        2.3,
                        2.81,
                        2.5,
                        1.67,
                        0.95,
                        1.51,
                        1.23,
                        1.41,
                        1.07,
                        1.01,
                        1.46,
                        1.55,
                        1.41,
                        1.64,
                        3.08,
                        2.67,
                        1.99,
                        2.09,
                        1.95,
                        1.92,
                        2.47,
                        2.34,
                        2.49,
                        2.89,
                        2.57,
                        3.17
                    ],
                    "marker": {
                        "fillColor": "#FFFFFF",
                        "lineColor": "darkblue",
                        "lineWidth": 2,
                        "radius": 5
                    },
                    "name": "Among core",
                    "type": "spline",
                    "yAxis": 1
                }
            ],
            "height_ratio": 69.23076923076923,
            "label_x": "Time (quarter)",
            "label_y": "Commit Numbers (thousand)",
            "label_y_secondary": "Women Commit Ratio = F/(F + M)",
            "title": "Commits in Clojars Public Projects",
            "x_categories": [
                "2008-3",
                "2008-6",
                "2008-9",
                "2008-12",
                "2009-3",
                "2009-6",
                "2009-9",
                "2009-12",
                "2010-3",
                "2010-6",
                "2010-9",
                "2010-12",
                "2011-3",
                "2011-6",
                "2011-9",
                "2011-12",
                "2012-3",
                "2012-6",
                "2012-9",
                "2012-12",
                "2013-3",
                "2013-6",
                "2013-9",
                "2013-12",
                "2014-3",
                "2014-6",
                "2014-9",
                "2014-12",
                "2015-3",
                "2015-6",
                "2015-9",
                "2015-12",
                "2016-3",
                "2016-6",
                "2016-9",
                "2016-12",
                "2017-3",
                "2017-6",
                "2017-9",
                "2017-12",
                "2018-3",
                "2018-6",
                "2018-9",
                "2018-12",
                "2019-3"
            ]
        },
        "CocoaPods": {
            "data": [
                {
                    "color": "blanchedalmond",
                    "data": [
                        0.129,
                        0.469,
                        0.768,
                        0.782,
                        1.132,
                        1.467,
                        1.808,
                        2.223,
                        1.809,
                        2.108,
                        3.082,
                        3.918,
                        5.298,
                        6.666,
                        8.798,
                        9.531,
                        14.247,
                        16.355,
                        22.819,
                        23.05,
                        31.555,
                        35.855,
                        44.896,
                        55.925,
                        64.648,
                        72.815,
                        70.102,
                        72.081,
                        95.134,
                        112.907,
                        117.375,
                        125.295,
                        145.725,
                        150.687,
                        169.422,
                        161.872,
                        160.717,
                        156.824,
                        165.487,
                        164.336,
                        156.12,
                        161.073,
                        161.119,
                        160.876,
                        144.217
                    ],
                    "name": "All Unknown",
                    "type": "column"
                },
                {
                    "color": "#f29d4b",
                    "data": [
                        0.011,
                        0.418,
                        0.68,
                        0.638,
                        1.042,
                        1.325,
                        1.616,
                        1.955,
                        1.503,
                        1.452,
                        2.631,
                        3.103,
                        4.192,
                        5.155,
                        6.511,
                        7.599,
                        11.264,
                        12.794,
                        17.39,
                        18.139,
                        25.076,
                        27.829,
                        34.906,
                        44.472,
                        50.102,
                        55.916,
                        53.917,
                        54.493,
                        73.813,
                        84.161,
                        85.732,
                        88.9,
                        101.564,
                        97.212,
                        108.733,
                        105.849,
                        104.484,
                        98.265,
                        102.08,
                        100.042,
                        97.752,
                        94.694,
                        97.993,
                        96.926,
                        88.632
                    ],
                    "name": "All Men",
                    "type": "column"
                },
                {
                    "color": "#de2d26",
                    "data": [
                        0.0,
                        0.0,
                        0.0,
                        0.0,
                        0.0,
                        0.0,
                        0.002,
                        0.016,
                        0.014,
                        0.004,
                        0.022,
                        0.035,
                        0.084,
                        0.087,
                        0.04,
                        0.085,
                        0.143,
                        0.164,
                        0.277,
                        0.256,
                        0.252,
                        0.301,
                        0.519,
                        0.979,
                        1.172,
                        1.375,
                        1.243,
                        1.904,
                        2.143,
                        2.116,
                        2.348,
                        2.359,
                        3.004,
                        3.037,
                        3.772,
                        3.913,
                        4.469,
                        3.839,
                        3.171,
                        3.079,
                        3.22,
                        4.432,
                        4.543,
                        4.831,
                        3.535
                    ],
                    "name": "All Women",
                    "type": "column"
                },
                {
                    "color": "darkblue",
                    "data": [
                        0.0,
                        0.0,
                        0.0,
                        0.0,
                        0.0,
                        0.0,
                        0.12,
                        0.82,
                        0.93,
                        0.28,
                        0.84,
                        1.13,
                        2.0,
                        1.69,
                        0.61,
                        1.12,
                        1.27,
                        1.28,
                        1.59,
                        1.41,
                        1.0,
                        1.08,
                        1.49,
                        2.2,
                        2.34,
                        2.46,
                        2.31,
                        3.49,
                        2.9,
                        2.51,
                        2.74,
                        2.65,
                        2.96,
                        3.12,
                        3.47,
                        3.7,
                        4.28,
                        3.91,
                        3.11,
                        3.08,
                        3.29,
                        4.68,
                        4.64,
                        4.98,
                        3.99
                    ],
                    "marker": {
                        "fillColor": "#FFFFFF",
                        "lineColor": "darkblue",
                        "lineWidth": 2,
                        "radius": 5
                    },
                    "name": "Among core",
                    "type": "spline",
                    "yAxis": 1
                }
            ],
            "height_ratio": 69.23076923076923,
            "label_x": "Time (quarter)",
            "label_y": "Commit Numbers (thousand)",
            "label_y_secondary": "Women Commit Ratio = F/(F + M)",
            "title": "Commits in CocoaPods Public Projects",
            "x_categories": [
                "2008-3",
                "2008-6",
                "2008-9",
                "2008-12",
                "2009-3",
                "2009-6",
                "2009-9",
                "2009-12",
                "2010-3",
                "2010-6",
                "2010-9",
                "2010-12",
                "2011-3",
                "2011-6",
                "2011-9",
                "2011-12",
                "2012-3",
                "2012-6",
                "2012-9",
                "2012-12",
                "2013-3",
                "2013-6",
                "2013-9",
                "2013-12",
                "2014-3",
                "2014-6",
                "2014-9",
                "2014-12",
                "2015-3",
                "2015-6",
                "2015-9",
                "2015-12",
                "2016-3",
                "2016-6",
                "2016-9",
                "2016-12",
                "2017-3",
                "2017-6",
                "2017-9",
                "2017-12",
                "2018-3",
                "2018-6",
                "2018-9",
                "2018-12",
                "2019-3"
            ]
        },
        "Go": {
            "data": [
                {
                    "color": "blanchedalmond",
                    "data": [
                        0.168,
                        0.346,
                        1.018,
                        0.773,
                        0.899,
                        1.141,
                        2.381,
                        4.92,
                        3.648,
                        3.021,
                        5.62,
                        5.09,
                        8.077,
                        9.141,
                        10.294,
                        14.194,
                        19.981,
                        19.187,
                        37.481,
                        35.402,
                        52.308,
                        72.235,
                        106.712,
                        127.979,
                        174.459,
                        205.23,
                        250.841,
                        288.666,
                        377.64,
                        384.563,
                        384.14,
                        431.75,
                        491.911,
                        419.984,
                        401.155,
                        418.067,
                        482.117,
                        485.78,
                        510.243,
                        507.983,
                        564.775,
                        575.52,
                        615.764,
                        600.115,
                        568.079
                    ],
                    "name": "All Unknown",
                    "type": "column"
                },
                {
                    "color": "#f29d4b",
                    "data": [
                        0.154,
                        0.344,
                        0.781,
                        0.719,
                        0.849,
                        1.049,
                        2.085,
                        4.235,
                        3.187,
                        2.478,
                        4.555,
                        3.726,
                        6.504,
                        7.345,
                        8.209,
                        10.793,
                        15.8,
                        14.869,
                        29.145,
                        26.651,
                        37.949,
                        53.524,
                        76.993,
                        94.243,
                        123.512,
                        152.781,
                        188.141,
                        214.825,
                        283.639,
                        289.143,
                        289.966,
                        317.666,
                        364.133,
                        308.718,
                        290.025,
                        307.456,
                        357.453,
                        358.163,
                        370.242,
                        363.769,
                        408.781,
                        420.479,
                        445.025,
                        417.629,
                        392.75
                    ],
                    "name": "All Men",
                    "type": "column"
                },
                {
                    "color": "#de2d26",
                    "data": [
                        0.012,
                        0.0,
                        0.007,
                        0.0,
                        0.0,
                        0.005,
                        0.0,
                        0.009,
                        0.101,
                        0.179,
                        0.277,
                        0.208,
                        0.613,
                        0.132,
                        0.401,
                        0.315,
                        0.892,
                        0.577,
                        1.293,
                        1.039,
                        1.505,
                        1.407,
                        2.088,
                        2.111,
                        2.746,
                        3.208,
                        4.496,
                        5.842,
                        8.327,
                        8.124,
                        7.693,
                        9.942,
                        11.109,
                        10.112,
                        10.109,
                        9.496,
                        11.317,
                        12.634,
                        16.983,
                        13.288,
                        16.706,
                        20.35,
                        20.077,
                        19.494,
                        16.974
                    ],
                    "name": "All Women",
                    "type": "column"
                },
                {
                    "color": "darkblue",
                    "data": [
                        0.0,
                        0.0,
                        0.0,
                        0.0,
                        0.0,
                        0.48,
                        0.0,
                        0.21,
                        3.17,
                        7.22,
                        6.08,
                        5.58,
                        9.42,
                        1.8,
                        4.88,
                        2.92,
                        5.65,
                        3.88,
                        4.44,
                        3.9,
                        3.97,
                        2.63,
                        2.71,
                        2.24,
                        2.22,
                        2.1,
                        2.39,
                        2.72,
                        2.94,
                        2.81,
                        2.65,
                        3.13,
                        3.05,
                        3.28,
                        3.49,
                        3.09,
                        3.17,
                        3.53,
                        4.59,
                        3.65,
                        4.09,
                        4.84,
                        4.51,
                        4.67,
                        4.32
                    ],
                    "marker": {
                        "fillColor": "#FFFFFF",
                        "lineColor": "darkblue",
                        "lineWidth": 2,
                        "radius": 5
                    },
                    "name": "Among core",
                    "type": "spline",
                    "yAxis": 1
                }
            ],
            "height_ratio": 69.23076923076923,
            "label_x": "Time (quarter)",
            "label_y": "Commit Numbers (thousand)",
            "label_y_secondary": "Women Commit Ratio = F/(F + M)",
            "title": "Commits in Go Public Projects",
            "x_categories": [
                "2008-3",
                "2008-6",
                "2008-9",
                "2008-12",
                "2009-3",
                "2009-6",
                "2009-9",
                "2009-12",
                "2010-3",
                "2010-6",
                "2010-9",
                "2010-12",
                "2011-3",
                "2011-6",
                "2011-9",
                "2011-12",
                "2012-3",
                "2012-6",
                "2012-9",
                "2012-12",
                "2013-3",
                "2013-6",
                "2013-9",
                "2013-12",
                "2014-3",
                "2014-6",
                "2014-9",
                "2014-12",
                "2015-3",
                "2015-6",
                "2015-9",
                "2015-12",
                "2016-3",
                "2016-6",
                "2016-9",
                "2016-12",
                "2017-3",
                "2017-6",
                "2017-9",
                "2017-12",
                "2018-3",
                "2018-6",
                "2018-9",
                "2018-12",
                "2019-3"
            ]
        },
        "Hackage": {
            "data": [
                {
                    "color": "blanchedalmond",
                    "data": [
                        1.735,
                        1.478,
                        2.121,
                        1.905,
                        2.658,
                        1.872,
                        2.544,
                        1.809,
                        2.933,
                        2.63,
                        4.059,
                        4.654,
                        5.573,
                        4.733,
                        6.654,
                        7.475,
                        10.665,
                        9.861,
                        13.891,
                        12.81,
                        16.151,
                        15.724,
                        19.23,
                        19.203,
                        25.67,
                        29.454,
                        28.753,
                        31.766,
                        35.742,
                        38.18,
                        38.131,
                        32.549,
                        32.915,
                        34.204,
                        31.915,
                        31.602,
                        35.716,
                        33.497,
                        36.95,
                        39.442,
                        43.414,
                        41.085,
                        34.841,
                        34.164,
                        31.898
                    ],
                    "name": "All Unknown",
                    "type": "column"
                },
                {
                    "color": "#f29d4b",
                    "data": [
                        1.331,
                        1.294,
                        1.818,
                        1.678,
                        2.403,
                        1.635,
                        2.332,
                        1.461,
                        2.62,
                        2.475,
                        3.72,
                        4.179,
                        5.021,
                        4.118,
                        5.791,
                        6.796,
                        9.642,
                        9.015,
                        12.138,
                        11.402,
                        14.216,
                        13.928,
                        16.697,
                        16.813,
                        21.661,
                        24.425,
                        24.87,
                        26.781,
                        31.635,
                        33.13,
                        32.146,
                        28.619,
                        28.043,
                        29.081,
                        26.613,
                        26.558,
                        29.18,
                        28.382,
                        31.167,
                        32.054,
                        36.54,
                        33.77,
                        28.556,
                        28.035,
                        26.058
                    ],
                    "name": "All Men",
                    "type": "column"
                },
                {
                    "color": "#de2d26",
                    "data": [
                        0.025,
                        0.299,
                        0.757,
                        0.014,
                        0.002,
                        0.014,
                        0.017,
                        0.005,
                        0.0,
                        0.003,
                        0.117,
                        0.407,
                        0.004,
                        0.019,
                        0.011,
                        0.004,
                        0.044,
                        0.077,
                        0.108,
                        0.283,
                        0.409,
                        0.242,
                        0.306,
                        0.561,
                        0.469,
                        0.397,
                        0.247,
                        0.391,
                        0.845,
                        0.626,
                        0.552,
                        0.601,
                        0.751,
                        0.748,
                        0.674,
                        0.582,
                        0.802,
                        0.755,
                        0.435,
                        1.005,
                        1.848,
                        1.105,
                        0.852,
                        1.164,
                        0.919
                    ],
                    "name": "All Women",
                    "type": "column"
                },
                {
                    "color": "darkblue",
                    "data": [
                        1.88,
                        23.11,
                        41.64,
                        0.83,
                        0.08,
                        0.86,
                        0.73,
                        0.34,
                        0.0,
                        0.12,
                        3.15,
                        9.74,
                        0.08,
                        0.46,
                        0.19,
                        0.06,
                        0.46,
                        0.85,
                        0.89,
                        2.48,
                        2.88,
                        1.74,
                        1.83,
                        3.34,
                        2.17,
                        1.63,
                        0.99,
                        1.46,
                        2.67,
                        1.89,
                        1.72,
                        2.1,
                        2.68,
                        2.57,
                        2.53,
                        2.19,
                        2.75,
                        2.66,
                        1.4,
                        3.14,
                        5.06,
                        3.27,
                        2.98,
                        4.15,
                        3.53
                    ],
                    "marker": {
                        "fillColor": "#FFFFFF",
                        "lineColor": "darkblue",
                        "lineWidth": 2,
                        "radius": 5
                    },
                    "name": "Among core",
                    "type": "spline",
                    "yAxis": 1
                }
            ],
            "height_ratio": 69.23076923076923,
            "label_x": "Time (quarter)",
            "label_y": "Commit Numbers (thousand)",
            "label_y_secondary": "Women Commit Ratio = F/(F + M)",
            "title": "Commits in Hackage Public Projects",
            "x_categories": [
                "2008-3",
                "2008-6",
                "2008-9",
                "2008-12",
                "2009-3",
                "2009-6",
                "2009-9",
                "2009-12",
                "2010-3",
                "2010-6",
                "2010-9",
                "2010-12",
                "2011-3",
                "2011-6",
                "2011-9",
                "2011-12",
                "2012-3",
                "2012-6",
                "2012-9",
                "2012-12",
                "2013-3",
                "2013-6",
                "2013-9",
                "2013-12",
                "2014-3",
                "2014-6",
                "2014-9",
                "2014-12",
                "2015-3",
                "2015-6",
                "2015-9",
                "2015-12",
                "2016-3",
                "2016-6",
                "2016-9",
                "2016-12",
                "2017-3",
                "2017-6",
                "2017-9",
                "2017-12",
                "2018-3",
                "2018-6",
                "2018-9",
                "2018-12",
                "2019-3"
            ]
        },
        "Hex": {
            "data": [
                {
                    "color": "blanchedalmond",
                    "data": [
                        0.072,
                        0.026,
                        0.028,
                        0.104,
                        0.076,
                        0.082,
                        0.149,
                        0.564,
                        0.43,
                        0.929,
                        1.07,
                        0.72,
                        1.498,
                        1.018,
                        0.948,
                        1.297,
                        1.997,
                        2.11,
                        2.525,
                        2.999,
                        3.118,
                        4.776,
                        5.818,
                        5.906,
                        6.374,
                        8.309,
                        10.623,
                        9.595,
                        11.148,
                        12.893,
                        16.887,
                        18.493,
                        24.112,
                        27.839,
                        31.07,
                        30.047,
                        34.906,
                        32.211,
                        35.433,
                        31.136,
                        35.553,
                        34.536,
                        35.0,
                        34.945,
                        32.339
                    ],
                    "name": "All Unknown",
                    "type": "column"
                },
                {
                    "color": "#f29d4b",
                    "data": [
                        0.009,
                        0.025,
                        0.028,
                        0.104,
                        0.075,
                        0.075,
                        0.125,
                        0.518,
                        0.424,
                        0.913,
                        1.049,
                        0.694,
                        0.911,
                        0.727,
                        0.898,
                        0.921,
                        1.287,
                        1.498,
                        1.935,
                        2.441,
                        2.406,
                        3.029,
                        3.715,
                        3.947,
                        4.623,
                        5.936,
                        7.699,
                        7.184,
                        7.922,
                        10.208,
                        12.948,
                        14.148,
                        18.519,
                        21.598,
                        24.981,
                        23.158,
                        27.242,
                        24.071,
                        28.038,
                        24.129,
                        27.959,
                        27.316,
                        27.243,
                        27.406,
                        25.063
                    ],
                    "name": "All Men",
                    "type": "column"
                },
                {
                    "color": "#de2d26",
                    "data": [
                        0.0,
                        0.0,
                        0.0,
                        0.0,
                        0.0,
                        0.0,
                        0.0,
                        0.0,
                        0.013,
                        0.051,
                        0.04,
                        0.0,
                        0.004,
                        0.006,
                        0.01,
                        0.0,
                        0.001,
                        0.005,
                        0.047,
                        0.011,
                        0.062,
                        0.02,
                        0.009,
                        0.017,
                        0.012,
                        0.033,
                        0.034,
                        0.012,
                        0.112,
                        0.115,
                        0.149,
                        0.142,
                        0.309,
                        0.772,
                        0.755,
                        0.592,
                        0.258,
                        0.223,
                        0.531,
                        0.585,
                        0.849,
                        0.676,
                        0.668,
                        0.443,
                        0.338
                    ],
                    "name": "All Women",
                    "type": "column"
                },
                {
                    "color": "darkblue",
                    "data": [
                        0.0,
                        0.0,
                        0.0,
                        0.0,
                        0.0,
                        0.0,
                        0.0,
                        0.0,
                        0.0,
                        0.0,
                        3.81,
                        0.0,
                        0.0,
                        0.0,
                        0.0,
                        0.0,
                        0.08,
                        0.33,
                        2.43,
                        0.45,
                        2.58,
                        0.66,
                        0.24,
                        0.43,
                        0.26,
                        0.56,
                        0.44,
                        0.17,
                        1.41,
                        1.13,
                        1.15,
                        1.0,
                        1.67,
                        3.57,
                        3.02,
                        2.56,
                        0.95,
                        0.93,
                        1.89,
                        2.42,
                        3.04,
                        2.47,
                        2.45,
                        1.62,
                        1.35
                    ],
                    "marker": {
                        "fillColor": "#FFFFFF",
                        "lineColor": "darkblue",
                        "lineWidth": 2,
                        "radius": 5
                    },
                    "name": "Among core",
                    "type": "spline",
                    "yAxis": 1
                }
            ],
            "height_ratio": 69.23076923076923,
            "label_x": "Time (quarter)",
            "label_y": "Commit Numbers (thousand)",
            "label_y_secondary": "Women Commit Ratio = F/(F + M)",
            "title": "Commits in Hex Public Projects",
            "x_categories": [
                "2008-3",
                "2008-6",
                "2008-9",
                "2008-12",
                "2009-3",
                "2009-6",
                "2009-9",
                "2009-12",
                "2010-3",
                "2010-6",
                "2010-9",
                "2010-12",
                "2011-3",
                "2011-6",
                "2011-9",
                "2011-12",
                "2012-3",
                "2012-6",
                "2012-9",
                "2012-12",
                "2013-3",
                "2013-6",
                "2013-9",
                "2013-12",
                "2014-3",
                "2014-6",
                "2014-9",
                "2014-12",
                "2015-3",
                "2015-6",
                "2015-9",
                "2015-12",
                "2016-3",
                "2016-6",
                "2016-9",
                "2016-12",
                "2017-3",
                "2017-6",
                "2017-9",
                "2017-12",
                "2018-3",
                "2018-6",
                "2018-9",
                "2018-12",
                "2019-3"
            ]
        },
        "Maven": {
            "data": [
                {
                    "color": "blanchedalmond",
                    "data": [
                        14.035,
                        15.057,
                        14.916,
                        16.943,
                        19.89,
                        21.764,
                        20.658,
                        26.921,
                        32.017,
                        32.338,
                        43.232,
                        52.061,
                        59.723,
                        71.937,
                        79.333,
                        88.053,
                        112.612,
                        113.604,
                        152.343,
                        135.554,
                        201.655,
                        206.661,
                        256.568,
                        281.161,
                        327.873,
                        350.414,
                        378.781,
                        399.009,
                        460.876,
                        471.768,
                        471.133,
                        466.168,
                        530.3,
                        506.256,
                        555.366,
                        544.27,
                        594.628,
                        602.29,
                        589.359,
                        595.723,
                        607.377,
                        575.486,
                        550.666,
                        539.146,
                        532.359
                    ],
                    "name": "All Unknown",
                    "type": "column"
                },
                {
                    "color": "#f29d4b",
                    "data": [
                        8.734,
                        9.747,
                        10.19,
                        11.668,
                        13.652,
                        15.047,
                        14.784,
                        19.276,
                        23.419,
                        23.102,
                        31.833,
                        39.652,
                        45.191,
                        54.906,
                        60.897,
                        67.433,
                        86.661,
                        89.047,
                        120.294,
                        107.258,
                        159.511,
                        163.438,
                        199.81,
                        217.041,
                        256.094,
                        273.165,
                        296.915,
                        306.34,
                        351.23,
                        359.058,
                        363.435,
                        359.496,
                        403.506,
                        380.823,
                        372.005,
                        403.093,
                        447.821,
                        428.991,
                        427.594,
                        438.15,
                        442.716,
                        416.725,
                        400.946,
                        389.818,
                        380.994
                    ],
                    "name": "All Men",
                    "type": "column"
                },
                {
                    "color": "#de2d26",
                    "data": [
                        0.114,
                        0.084,
                        0.117,
                        0.104,
                        0.172,
                        0.161,
                        0.238,
                        0.285,
                        0.387,
                        0.579,
                        0.635,
                        1.028,
                        1.42,
                        1.103,
                        1.371,
                        1.366,
                        2.426,
                        1.965,
                        2.388,
                        1.757,
                        2.932,
                        3.502,
                        5.542,
                        5.713,
                        8.142,
                        7.945,
                        8.198,
                        7.772,
                        9.892,
                        11.757,
                        12.945,
                        11.52,
                        14.425,
                        14.923,
                        14.619,
                        15.78,
                        18.141,
                        19.694,
                        19.832,
                        18.45,
                        22.764,
                        23.173,
                        22.756,
                        21.306,
                        22.263
                    ],
                    "name": "All Women",
                    "type": "column"
                },
                {
                    "color": "darkblue",
                    "data": [
                        1.31,
                        0.86,
                        1.15,
                        0.89,
                        1.26,
                        1.07,
                        1.61,
                        1.48,
                        1.65,
                        2.51,
                        1.99,
                        2.59,
                        3.14,
                        2.01,
                        2.25,
                        2.03,
                        2.8,
                        2.21,
                        1.99,
                        1.64,
                        1.84,
                        2.14,
                        2.77,
                        2.63,
                        3.18,
                        2.91,
                        2.76,
                        2.54,
                        2.82,
                        3.27,
                        3.56,
                        3.2,
                        3.57,
                        3.92,
                        3.93,
                        3.91,
                        4.05,
                        4.59,
                        4.64,
                        4.21,
                        5.14,
                        5.56,
                        5.68,
                        5.47,
                        5.84
                    ],
                    "marker": {
                        "fillColor": "#FFFFFF",
                        "lineColor": "darkblue",
                        "lineWidth": 2,
                        "radius": 5
                    },
                    "name": "Among core",
                    "type": "spline",
                    "yAxis": 1
                }
            ],
            "height_ratio": 69.23076923076923,
            "label_x": "Time (quarter)",
            "label_y": "Commit Numbers (thousand)",
            "label_y_secondary": "Women Commit Ratio = F/(F + M)",
            "title": "Commits in Maven Public Projects",
            "x_categories": [
                "2008-3",
                "2008-6",
                "2008-9",
                "2008-12",
                "2009-3",
                "2009-6",
                "2009-9",
                "2009-12",
                "2010-3",
                "2010-6",
                "2010-9",
                "2010-12",
                "2011-3",
                "2011-6",
                "2011-9",
                "2011-12",
                "2012-3",
                "2012-6",
                "2012-9",
                "2012-12",
                "2013-3",
                "2013-6",
                "2013-9",
                "2013-12",
                "2014-3",
                "2014-6",
                "2014-9",
                "2014-12",
                "2015-3",
                "2015-6",
                "2015-9",
                "2015-12",
                "2016-3",
                "2016-6",
                "2016-9",
                "2016-12",
                "2017-3",
                "2017-6",
                "2017-9",
                "2017-12",
                "2018-3",
                "2018-6",
                "2018-9",
                "2018-12",
                "2019-3"
            ]
        },
        "Meteor": {
            "data": [
                {
                    "color": "blanchedalmond",
                    "data": [
                        0.251,
                        0.405,
                        0.979,
                        0.948,
                        0.452,
                        1.317,
                        0.695,
                        0.413,
                        1.055,
                        0.902,
                        2.008,
                        1.984,
                        1.897,
                        2.269,
                        3.288,
                        3.533,
                        5.306,
                        5.098,
                        8.919,
                        7.403,
                        14.582,
                        16.286,
                        22.376,
                        27.664,
                        32.132,
                        30.161,
                        39.9,
                        48.383,
                        49.678,
                        49.027,
                        44.942,
                        40.733,
                        41.281,
                        31.836,
                        25.196,
                        24.597,
                        20.498,
                        14.542,
                        12.811,
                        13.001,
                        11.156,
                        8.861,
                        8.486,
                        7.956,
                        7.424
                    ],
                    "name": "All Unknown",
                    "type": "column"
                },
                {
                    "color": "#f29d4b",
                    "data": [
                        0.23,
                        0.384,
                        0.828,
                        0.857,
                        0.403,
                        1.268,
                        0.664,
                        0.393,
                        0.917,
                        0.695,
                        1.67,
                        1.851,
                        1.517,
                        2.057,
                        2.953,
                        3.215,
                        4.874,
                        4.375,
                        7.686,
                        6.383,
                        11.623,
                        13.037,
                        17.285,
                        21.772,
                        24.774,
                        24.478,
                        31.97,
                        38.942,
                        37.949,
                        37.314,
                        34.665,
                        31.704,
                        31.691,
                        24.348,
                        18.97,
                        18.786,
                        15.189,
                        10.843,
                        9.55,
                        9.824,
                        8.31,
                        6.915,
                        6.05,
                        5.702,
                        5.132
                    ],
                    "name": "All Men",
                    "type": "column"
                },
                {
                    "color": "#de2d26",
                    "data": [
                        0.0,
                        0.0,
                        0.0,
                        0.018,
                        0.044,
                        0.107,
                        0.006,
                        0.004,
                        0.006,
                        0.01,
                        0.049,
                        0.053,
                        0.018,
                        0.004,
                        0.039,
                        0.003,
                        0.005,
                        0.117,
                        0.155,
                        0.466,
                        0.602,
                        0.637,
                        1.048,
                        1.548,
                        1.611,
                        1.611,
                        1.747,
                        1.866,
                        1.849,
                        1.626,
                        1.023,
                        1.06,
                        1.864,
                        1.343,
                        0.915,
                        0.922,
                        0.876,
                        0.749,
                        0.533,
                        0.436,
                        0.553,
                        0.83,
                        0.883,
                        0.333,
                        0.247
                    ],
                    "name": "All Women",
                    "type": "column"
                },
                {
                    "color": "darkblue",
                    "data": [
                        0.0,
                        0.0,
                        0.0,
                        0.0,
                        0.0,
                        8.44,
                        0.0,
                        0.0,
                        0.0,
                        0.0,
                        2.93,
                        2.86,
                        1.19,
                        0.19,
                        1.32,
                        0.09,
                        0.1,
                        2.67,
                        2.02,
                        7.3,
                        5.18,
                        4.89,
                        6.06,
                        7.11,
                        6.5,
                        6.58,
                        5.46,
                        4.79,
                        4.87,
                        4.36,
                        2.95,
                        3.34,
                        5.88,
                        5.52,
                        4.82,
                        4.91,
                        5.77,
                        6.91,
                        5.58,
                        4.44,
                        6.65,
                        12.0,
                        14.6,
                        5.84,
                        4.81
                    ],
                    "marker": {
                        "fillColor": "#FFFFFF",
                        "lineColor": "darkblue",
                        "lineWidth": 2,
                        "radius": 5
                    },
                    "name": "Among core",
                    "type": "spline",
                    "yAxis": 1
                }
            ],
            "height_ratio": 69.23076923076923,
            "label_x": "Time (quarter)",
            "label_y": "Commit Numbers (thousand)",
            "label_y_secondary": "Women Commit Ratio = F/(F + M)",
            "title": "Commits in Meteor Public Projects",
            "x_categories": [
                "2008-3",
                "2008-6",
                "2008-9",
                "2008-12",
                "2009-3",
                "2009-6",
                "2009-9",
                "2009-12",
                "2010-3",
                "2010-6",
                "2010-9",
                "2010-12",
                "2011-3",
                "2011-6",
                "2011-9",
                "2011-12",
                "2012-3",
                "2012-6",
                "2012-9",
                "2012-12",
                "2013-3",
                "2013-6",
                "2013-9",
                "2013-12",
                "2014-3",
                "2014-6",
                "2014-9",
                "2014-12",
                "2015-3",
                "2015-6",
                "2015-9",
                "2015-12",
                "2016-3",
                "2016-6",
                "2016-9",
                "2016-12",
                "2017-3",
                "2017-6",
                "2017-9",
                "2017-12",
                "2018-3",
                "2018-6",
                "2018-9",
                "2018-12",
                "2019-3"
            ]
        },
        "NPM": {
            "data": [
                {
                    "color": "blanchedalmond",
                    "data": [
                        8.122,
                        9.827,
                        10.575,
                        9.992,
                        12.178,
                        12.062,
                        11.898,
                        14.474,
                        19.962,
                        20.886,
                        29.217,
                        37.221,
                        50.808,
                        71.935,
                        83.774,
                        95.468,
                        139.936,
                        152.712,
                        206.631,
                        187.646,
                        294.952,
                        331.418,
                        439.909,
                        516.388,
                        624.944,
                        685.041,
                        774.999,
                        840.195,
                        1031.177,
                        1061.511,
                        1108.549,
                        1192.459,
                        1479.089,
                        1475.078,
                        1457.389,
                        1605.035,
                        1792.626,
                        1889.405,
                        2019.315,
                        2094.54,
                        2290.645,
                        2308.658,
                        2359.491,
                        2430.683,
                        2376.552
                    ],
                    "name": "All Unknown",
                    "type": "column"
                },
                {
                    "color": "#f29d4b",
                    "data": [
                        7.26,
                        8.936,
                        9.36,
                        8.654,
                        10.499,
                        10.542,
                        10.026,
                        12.156,
                        16.439,
                        17.149,
                        23.772,
                        29.988,
                        41.67,
                        55.33,
                        65.628,
                        76.267,
                        112.014,
                        121.258,
                        162.251,
                        146.464,
                        229.397,
                        256.167,
                        339.755,
                        397.502,
                        480.792,
                        523.605,
                        598.172,
                        645.575,
                        787.315,
                        811.454,
                        844.711,
                        905.538,
                        1104.756,
                        1109.103,
                        1086.744,
                        1183.59,
                        1327.124,
                        1374.57,
                        1443.908,
                        1501.435,
                        1650.251,
                        1645.671,
                        1660.113,
                        1701.007,
                        1651.925
                    ],
                    "name": "All Men",
                    "type": "column"
                },
                {
                    "color": "#de2d26",
                    "data": [
                        0.11,
                        0.195,
                        0.168,
                        0.238,
                        0.382,
                        0.282,
                        0.126,
                        0.169,
                        0.214,
                        0.324,
                        0.367,
                        0.735,
                        0.689,
                        1.242,
                        1.15,
                        1.41,
                        1.905,
                        2.414,
                        3.276,
                        2.552,
                        4.663,
                        5.092,
                        9.03,
                        9.501,
                        11.665,
                        14.288,
                        17.871,
                        20.713,
                        25.24,
                        27.475,
                        30.285,
                        28.803,
                        35.888,
                        42.601,
                        44.922,
                        49.837,
                        59.544,
                        67.32,
                        69.738,
                        70.452,
                        78.566,
                        83.917,
                        86.309,
                        92.176,
                        88.716
                    ],
                    "name": "All Women",
                    "type": "column"
                },
                {
                    "color": "darkblue",
                    "data": [
                        1.52,
                        2.18,
                        1.79,
                        2.75,
                        3.64,
                        2.68,
                        1.26,
                        1.39,
                        1.3,
                        1.89,
                        1.54,
                        2.45,
                        1.65,
                        2.24,
                        1.75,
                        1.85,
                        1.7,
                        1.99,
                        2.02,
                        1.74,
                        2.03,
                        1.99,
                        2.66,
                        2.39,
                        2.43,
                        2.73,
                        2.99,
                        3.21,
                        3.21,
                        3.39,
                        3.59,
                        3.18,
                        3.25,
                        3.84,
                        4.13,
                        4.21,
                        4.49,
                        4.9,
                        4.83,
                        4.69,
                        4.76,
                        5.1,
                        5.2,
                        5.42,
                        5.37
                    ],
                    "marker": {
                        "fillColor": "#FFFFFF",
                        "lineColor": "darkblue",
                        "lineWidth": 2,
                        "radius": 5
                    },
                    "name": "Among core",
                    "type": "spline",
                    "yAxis": 1
                }
            ],
            "height_ratio": 69.23076923076923,
            "label_x": "Time (quarter)",
            "label_y": "Commit Numbers (thousand)",
            "label_y_secondary": "Women Commit Ratio = F/(F + M)",
            "title": "Commits in NPM Public Projects",
            "x_categories": [
                "2008-3",
                "2008-6",
                "2008-9",
                "2008-12",
                "2009-3",
                "2009-6",
                "2009-9",
                "2009-12",
                "2010-3",
                "2010-6",
                "2010-9",
                "2010-12",
                "2011-3",
                "2011-6",
                "2011-9",
                "2011-12",
                "2012-3",
                "2012-6",
                "2012-9",
                "2012-12",
                "2013-3",
                "2013-6",
                "2013-9",
                "2013-12",
                "2014-3",
                "2014-6",
                "2014-9",
                "2014-12",
                "2015-3",
                "2015-6",
                "2015-9",
                "2015-12",
                "2016-3",
                "2016-6",
                "2016-9",
                "2016-12",
                "2017-3",
                "2017-6",
                "2017-9",
                "2017-12",
                "2018-3",
                "2018-6",
                "2018-9",
                "2018-12",
                "2019-3"
            ]
        },
        "NuGet": {
            "data": [
                {
                    "color": "blanchedalmond",
                    "data": [
                        4.672,
                        4.415,
                        4.13,
                        5.63,
                        6.848,
                        5.083,
                        5.883,
                        6.699,
                        8.71,
                        9.45,
                        10.19,
                        13.861,
                        18.066,
                        20.273,
                        22.776,
                        25.135,
                        32.496,
                        32.396,
                        41.472,
                        40.036,
                        62.612,
                        65.643,
                        90.775,
                        100.547,
                        122.206,
                        130.107,
                        133.152,
                        139.819,
                        178.572,
                        174.119,
                        176.468,
                        188.022,
                        214.584,
                        224.003,
                        224.187,
                        243.347,
                        279.684,
                        283.976,
                        288.336,
                        287.698,
                        295.664,
                        295.775,
                        298.296,
                        312.183,
                        317.236
                    ],
                    "name": "All Unknown",
                    "type": "column"
                },
                {
                    "color": "#f29d4b",
                    "data": [
                        3.292,
                        3.452,
                        2.699,
                        3.554,
                        4.659,
                        3.328,
                        4.279,
                        4.541,
                        5.999,
                        6.862,
                        7.092,
                        9.769,
                        14.23,
                        14.559,
                        16.627,
                        19.476,
                        24.097,
                        25.513,
                        33.31,
                        31.697,
                        51.357,
                        52.454,
                        72.13,
                        80.052,
                        94.778,
                        102.835,
                        105.22,
                        106.91,
                        137.633,
                        134.345,
                        135.983,
                        145.413,
                        163.599,
                        165.16,
                        161.231,
                        179.326,
                        208.882,
                        212.466,
                        211.441,
                        212.283,
                        218.634,
                        215.44,
                        214.655,
                        219.881,
                        218.833
                    ],
                    "name": "All Men",
                    "type": "column"
                },
                {
                    "color": "#de2d26",
                    "data": [
                        0.212,
                        0.156,
                        0.081,
                        0.232,
                        0.37,
                        0.168,
                        0.26,
                        0.36,
                        0.309,
                        0.355,
                        0.394,
                        0.416,
                        0.274,
                        0.282,
                        0.363,
                        0.395,
                        0.212,
                        0.144,
                        0.532,
                        0.829,
                        0.902,
                        0.802,
                        2.155,
                        1.476,
                        2.249,
                        2.185,
                        2.354,
                        2.626,
                        4.18,
                        4.869,
                        4.82,
                        5.249,
                        5.011,
                        4.08,
                        3.983,
                        5.258,
                        5.602,
                        5.913,
                        6.589,
                        5.829,
                        5.889,
                        6.62,
                        5.72,
                        6.528,
                        6.7
                    ],
                    "name": "All Women",
                    "type": "column"
                },
                {
                    "color": "darkblue",
                    "data": [
                        6.44,
                        4.52,
                        3.0,
                        6.53,
                        7.94,
                        5.05,
                        6.08,
                        7.93,
                        5.15,
                        5.17,
                        5.56,
                        4.26,
                        1.93,
                        1.94,
                        2.18,
                        2.03,
                        0.88,
                        0.56,
                        1.6,
                        2.62,
                        1.76,
                        1.53,
                        2.99,
                        1.84,
                        2.37,
                        2.12,
                        2.24,
                        2.46,
                        3.04,
                        3.62,
                        3.54,
                        3.61,
                        3.06,
                        2.47,
                        2.47,
                        2.93,
                        2.68,
                        2.78,
                        3.12,
                        2.75,
                        2.69,
                        3.07,
                        2.66,
                        2.97,
                        3.06
                    ],
                    "marker": {
                        "fillColor": "#FFFFFF",
                        "lineColor": "darkblue",
                        "lineWidth": 2,
                        "radius": 5
                    },
                    "name": "Among core",
                    "type": "spline",
                    "yAxis": 1
                }
            ],
            "height_ratio": 69.23076923076923,
            "label_x": "Time (quarter)",
            "label_y": "Commit Numbers (thousand)",
            "label_y_secondary": "Women Commit Ratio = F/(F + M)",
            "title": "Commits in NuGet Public Projects",
            "x_categories": [
                "2008-3",
                "2008-6",
                "2008-9",
                "2008-12",
                "2009-3",
                "2009-6",
                "2009-9",
                "2009-12",
                "2010-3",
                "2010-6",
                "2010-9",
                "2010-12",
                "2011-3",
                "2011-6",
                "2011-9",
                "2011-12",
                "2012-3",
                "2012-6",
                "2012-9",
                "2012-12",
                "2013-3",
                "2013-6",
                "2013-9",
                "2013-12",
                "2014-3",
                "2014-6",
                "2014-9",
                "2014-12",
                "2015-3",
                "2015-6",
                "2015-9",
                "2015-12",
                "2016-3",
                "2016-6",
                "2016-9",
                "2016-12",
                "2017-3",
                "2017-6",
                "2017-9",
                "2017-12",
                "2018-3",
                "2018-6",
                "2018-9",
                "2018-12",
                "2019-3"
            ]
        },
        "Packagist": {
            "data": [
                {
                    "color": "blanchedalmond",
                    "data": [
                        8.607,
                        9.39,
                        9.723,
                        10.092,
                        11.911,
                        13.272,
                        15.381,
                        15.163,
                        19.058,
                        21.062,
                        25.398,
                        30.482,
                        36.597,
                        44.022,
                        57.198,
                        65.658,
                        91.438,
                        113.42,
                        146.964,
                        119.142,
                        198.749,
                        209.831,
                        245.724,
                        284.132,
                        346.076,
                        337.727,
                        364.489,
                        404.903,
                        500.265,
                        482.054,
                        463.444,
                        483.635,
                        537.143,
                        538.412,
                        539.224,
                        553.521,
                        638.901,
                        578.775,
                        607.622,
                        624.905,
                        665.005,
                        596.962,
                        588.466,
                        618.47,
                        620.056
                    ],
                    "name": "All Unknown",
                    "type": "column"
                },
                {
                    "color": "#f29d4b",
                    "data": [
                        5.542,
                        6.371,
                        6.878,
                        7.524,
                        8.889,
                        10.739,
                        11.507,
                        11.588,
                        14.823,
                        16.307,
                        20.361,
                        23.645,
                        28.951,
                        34.236,
                        46.933,
                        53.429,
                        71.421,
                        93.439,
                        116.694,
                        95.204,
                        154.354,
                        159.873,
                        181.706,
                        209.189,
                        260.048,
                        252.775,
                        271.106,
                        304.525,
                        374.435,
                        352.858,
                        338.583,
                        345.947,
                        384.253,
                        384.502,
                        382.436,
                        388.943,
                        444.354,
                        392.342,
                        417.536,
                        418.89,
                        454.79,
                        402.009,
                        385.399,
                        409.454,
                        419.451
                    ],
                    "name": "All Men",
                    "type": "column"
                },
                {
                    "color": "#de2d26",
                    "data": [
                        0.002,
                        0.0,
                        0.004,
                        0.029,
                        0.07,
                        0.074,
                        0.131,
                        0.079,
                        0.107,
                        0.098,
                        0.145,
                        0.102,
                        0.052,
                        0.224,
                        0.461,
                        0.41,
                        1.242,
                        1.769,
                        1.97,
                        1.302,
                        2.297,
                        2.892,
                        4.172,
                        4.405,
                        5.406,
                        5.401,
                        5.579,
                        6.882,
                        8.54,
                        8.807,
                        9.682,
                        8.858,
                        9.773,
                        10.616,
                        11.754,
                        10.378,
                        11.776,
                        11.596,
                        11.816,
                        11.309,
                        12.711,
                        10.548,
                        11.593,
                        12.682,
                        10.982
                    ],
                    "name": "All Women",
                    "type": "column"
                },
                {
                    "color": "darkblue",
                    "data": [
                        0.04,
                        0.0,
                        0.06,
                        0.39,
                        0.79,
                        0.69,
                        1.14,
                        0.68,
                        0.72,
                        0.6,
                        0.71,
                        0.43,
                        0.18,
                        0.65,
                        0.98,
                        0.77,
                        1.74,
                        1.89,
                        1.69,
                        1.37,
                        1.49,
                        1.81,
                        2.3,
                        2.11,
                        2.08,
                        2.14,
                        2.06,
                        2.26,
                        2.28,
                        2.5,
                        2.86,
                        2.56,
                        2.54,
                        2.76,
                        3.07,
                        2.67,
                        2.65,
                        2.96,
                        2.83,
                        2.7,
                        2.79,
                        2.62,
                        3.01,
                        3.1,
                        2.62
                    ],
                    "marker": {
                        "fillColor": "#FFFFFF",
                        "lineColor": "darkblue",
                        "lineWidth": 2,
                        "radius": 5
                    },
                    "name": "Among core",
                    "type": "spline",
                    "yAxis": 1
                }
            ],
            "height_ratio": 69.23076923076923,
            "label_x": "Time (quarter)",
            "label_y": "Commit Numbers (thousand)",
            "label_y_secondary": "Women Commit Ratio = F/(F + M)",
            "title": "Commits in Packagist Public Projects",
            "x_categories": [
                "2008-3",
                "2008-6",
                "2008-9",
                "2008-12",
                "2009-3",
                "2009-6",
                "2009-9",
                "2009-12",
                "2010-3",
                "2010-6",
                "2010-9",
                "2010-12",
                "2011-3",
                "2011-6",
                "2011-9",
                "2011-12",
                "2012-3",
                "2012-6",
                "2012-9",
                "2012-12",
                "2013-3",
                "2013-6",
                "2013-9",
                "2013-12",
                "2014-3",
                "2014-6",
                "2014-9",
                "2014-12",
                "2015-3",
                "2015-6",
                "2015-9",
                "2015-12",
                "2016-3",
                "2016-6",
                "2016-9",
                "2016-12",
                "2017-3",
                "2017-6",
                "2017-9",
                "2017-12",
                "2018-3",
                "2018-6",
                "2018-9",
                "2018-12",
                "2019-3"
            ]
        },
        "PlatformIO": {
            "data": [
                {
                    "color": "blanchedalmond",
                    "data": [
                        0.0,
                        0.002,
                        0.0,
                        0.001,
                        0.008,
                        0.015,
                        0.035,
                        0.043,
                        0.096,
                        0.027,
                        0.115,
                        0.187,
                        0.133,
                        0.148,
                        0.262,
                        0.377,
                        0.453,
                        0.706,
                        0.643,
                        0.644,
                        1.12,
                        1.109,
                        1.573,
                        1.86,
                        2.519,
                        2.525,
                        2.731,
                        3.367,
                        4.508,
                        6.226,
                        6.38,
                        6.942,
                        9.264,
                        9.105,
                        9.179,
                        10.592,
                        11.146,
                        9.387,
                        12.814,
                        13.394,
                        16.704,
                        16.558,
                        16.558,
                        16.371,
                        20.025
                    ],
                    "name": "All Unknown",
                    "type": "column"
                },
                {
                    "color": "#f29d4b",
                    "data": [
                        0.0,
                        0.002,
                        0.0,
                        0.001,
                        0.005,
                        0.01,
                        0.001,
                        0.016,
                        0.055,
                        0.025,
                        0.026,
                        0.135,
                        0.08,
                        0.097,
                        0.175,
                        0.294,
                        0.308,
                        0.52,
                        0.443,
                        0.4,
                        0.909,
                        0.789,
                        1.2,
                        1.452,
                        1.904,
                        2.062,
                        1.772,
                        2.439,
                        3.586,
                        5.077,
                        4.991,
                        5.14,
                        6.35,
                        5.847,
                        6.087,
                        6.887,
                        6.828,
                        5.506,
                        8.309,
                        9.116,
                        10.928,
                        10.689,
                        10.078,
                        9.752,
                        11.566
                    ],
                    "name": "All Men",
                    "type": "column"
                },
                {
                    "color": "#de2d26",
                    "data": [
                        0.0,
                        0.0,
                        0.0,
                        0.0,
                        0.0,
                        0.0,
                        0.0,
                        0.0,
                        0.0,
                        0.0,
                        0.0,
                        0.0,
                        0.0,
                        0.0,
                        0.0,
                        0.001,
                        0.0,
                        0.018,
                        0.007,
                        0.005,
                        0.005,
                        0.006,
                        0.004,
                        0.051,
                        0.013,
                        0.009,
                        0.025,
                        0.008,
                        0.041,
                        0.062,
                        0.088,
                        0.109,
                        0.091,
                        0.135,
                        0.031,
                        0.38,
                        0.388,
                        0.458,
                        0.163,
                        0.167,
                        0.407,
                        0.445,
                        0.196,
                        0.286,
                        0.471
                    ],
                    "name": "All Women",
                    "type": "column"
                },
                {
                    "color": "darkblue",
                    "data": [
                        0.0,
                        0.0,
                        0.0,
                        0.0,
                        0.0,
                        0.0,
                        0.0,
                        0.0,
                        0.0,
                        0.0,
                        0.0,
                        0.0,
                        0.0,
                        0.0,
                        0.0,
                        0.0,
                        0.0,
                        0.0,
                        0.0,
                        0.0,
                        0.0,
                        0.0,
                        0.33,
                        3.51,
                        0.68,
                        0.44,
                        1.41,
                        0.33,
                        1.14,
                        1.22,
                        1.76,
                        2.12,
                        1.43,
                        2.31,
                        0.51,
                        5.52,
                        5.68,
                        8.32,
                        1.96,
                        1.83,
                        3.72,
                        4.16,
                        1.94,
                        2.93,
                        4.07
                    ],
                    "marker": {
                        "fillColor": "#FFFFFF",
                        "lineColor": "darkblue",
                        "lineWidth": 2,
                        "radius": 5
                    },
                    "name": "Among core",
                    "type": "spline",
                    "yAxis": 1
                }
            ],
            "height_ratio": 69.23076923076923,
            "label_x": "Time (quarter)",
            "label_y": "Commit Numbers (thousand)",
            "label_y_secondary": "Women Commit Ratio = F/(F + M)",
            "title": "Commits in PlatformIO Public Projects",
            "x_categories": [
                "2008-3",
                "2008-6",
                "2008-9",
                "2008-12",
                "2009-3",
                "2009-6",
                "2009-9",
                "2009-12",
                "2010-3",
                "2010-6",
                "2010-9",
                "2010-12",
                "2011-3",
                "2011-6",
                "2011-9",
                "2011-12",
                "2012-3",
                "2012-6",
                "2012-9",
                "2012-12",
                "2013-3",
                "2013-6",
                "2013-9",
                "2013-12",
                "2014-3",
                "2014-6",
                "2014-9",
                "2014-12",
                "2015-3",
                "2015-6",
                "2015-9",
                "2015-12",
                "2016-3",
                "2016-6",
                "2016-9",
                "2016-12",
                "2017-3",
                "2017-6",
                "2017-9",
                "2017-12",
                "2018-3",
                "2018-6",
                "2018-9",
                "2018-12",
                "2019-3"
            ]
        },
        "Pub": {
            "data": [
                {
                    "color": "blanchedalmond",
                    "data": [
                        0.004,
                        0.0,
                        0.0,
                        0.0,
                        0.0,
                        0.002,
                        0.0,
                        0.0,
                        0.0,
                        0.0,
                        0.0,
                        0.0,
                        0.0,
                        0.0,
                        0.0,
                        0.004,
                        0.1,
                        0.204,
                        1.241,
                        1.981,
                        3.794,
                        4.021,
                        4.239,
                        6.503,
                        7.341,
                        7.788,
                        8.07,
                        8.829,
                        13.021,
                        16.763,
                        14.933,
                        13.232,
                        11.37,
                        12.051,
                        11.312,
                        12.699,
                        17.208,
                        17.455,
                        17.342,
                        18.947,
                        23.808,
                        28.854,
                        34.841,
                        38.692,
                        50.967
                    ],
                    "name": "All Unknown",
                    "type": "column"
                },
                {
                    "color": "#f29d4b",
                    "data": [
                        0.0,
                        0.0,
                        0.0,
                        0.0,
                        0.0,
                        0.0,
                        0.0,
                        0.0,
                        0.0,
                        0.0,
                        0.0,
                        0.0,
                        0.0,
                        0.0,
                        0.0,
                        0.004,
                        0.1,
                        0.187,
                        1.126,
                        1.524,
                        3.271,
                        3.245,
                        3.459,
                        4.735,
                        5.528,
                        6.006,
                        5.584,
                        6.959,
                        10.372,
                        13.116,
                        12.029,
                        11.135,
                        9.201,
                        9.428,
                        8.838,
                        10.454,
                        13.729,
                        14.01,
                        13.696,
                        14.458,
                        18.562,
                        21.439,
                        25.248,
                        26.874,
                        34.898
                    ],
                    "name": "All Men",
                    "type": "column"
                },
                {
                    "color": "#de2d26",
                    "data": [
                        0.0,
                        0.0,
                        0.0,
                        0.0,
                        0.0,
                        0.0,
                        0.0,
                        0.0,
                        0.0,
                        0.0,
                        0.0,
                        0.0,
                        0.0,
                        0.0,
                        0.0,
                        0.0,
                        0.0,
                        0.0,
                        0.011,
                        0.039,
                        0.093,
                        0.085,
                        0.068,
                        0.257,
                        0.218,
                        0.224,
                        0.139,
                        0.249,
                        0.591,
                        0.608,
                        0.429,
                        0.482,
                        0.52,
                        0.399,
                        0.388,
                        0.462,
                        0.735,
                        1.234,
                        0.679,
                        0.721,
                        1.543,
                        1.962,
                        1.601,
                        1.74,
                        1.874
                    ],
                    "name": "All Women",
                    "type": "column"
                },
                {
                    "color": "darkblue",
                    "data": [
                        0.0,
                        0.0,
                        0.0,
                        0.0,
                        0.0,
                        0.0,
                        0.0,
                        0.0,
                        0.0,
                        0.0,
                        0.0,
                        0.0,
                        0.0,
                        0.0,
                        0.0,
                        0.0,
                        0.0,
                        0.0,
                        0.98,
                        2.56,
                        2.84,
                        2.62,
                        1.97,
                        5.43,
                        3.94,
                        3.73,
                        2.49,
                        3.58,
                        5.7,
                        4.64,
                        3.57,
                        4.33,
                        5.65,
                        4.23,
                        4.39,
                        4.42,
                        5.35,
                        8.81,
                        4.96,
                        4.99,
                        8.31,
                        9.15,
                        6.34,
                        6.47,
                        5.37
                    ],
                    "marker": {
                        "fillColor": "#FFFFFF",
                        "lineColor": "darkblue",
                        "lineWidth": 2,
                        "radius": 5
                    },
                    "name": "Among core",
                    "type": "spline",
                    "yAxis": 1
                }
            ],
            "height_ratio": 69.23076923076923,
            "label_x": "Time (quarter)",
            "label_y": "Commit Numbers (thousand)",
            "label_y_secondary": "Women Commit Ratio = F/(F + M)",
            "title": "Commits in Pub Public Projects",
            "x_categories": [
                "2008-3",
                "2008-6",
                "2008-9",
                "2008-12",
                "2009-3",
                "2009-6",
                "2009-9",
                "2009-12",
                "2010-3",
                "2010-6",
                "2010-9",
                "2010-12",
                "2011-3",
                "2011-6",
                "2011-9",
                "2011-12",
                "2012-3",
                "2012-6",
                "2012-9",
                "2012-12",
                "2013-3",
                "2013-6",
                "2013-9",
                "2013-12",
                "2014-3",
                "2014-6",
                "2014-9",
                "2014-12",
                "2015-3",
                "2015-6",
                "2015-9",
                "2015-12",
                "2016-3",
                "2016-6",
                "2016-9",
                "2016-12",
                "2017-3",
                "2017-6",
                "2017-9",
                "2017-12",
                "2018-3",
                "2018-6",
                "2018-9",
                "2018-12",
                "2019-3"
            ]
        },
        "Puppet": {
            "data": [
                {
                    "color": "blanchedalmond",
                    "data": [
                        0.017,
                        0.002,
                        0.02,
                        0.016,
                        0.038,
                        0.041,
                        0.08,
                        0.054,
                        0.098,
                        0.087,
                        0.239,
                        0.16,
                        0.18,
                        0.809,
                        0.715,
                        0.973,
                        1.809,
                        2.376,
                        3.55,
                        3.821,
                        6.105,
                        7.326,
                        10.859,
                        12.133,
                        13.724,
                        13.832,
                        15.96,
                        20.875,
                        23.439,
                        23.357,
                        19.366,
                        18.82,
                        22.962,
                        19.643,
                        18.342,
                        19.144,
                        22.669,
                        21.287,
                        20.568,
                        18.085,
                        19.438,
                        18.371,
                        18.683,
                        18.589,
                        15.117
                    ],
                    "name": "All Unknown",
                    "type": "column"
                },
                {
                    "color": "#f29d4b",
                    "data": [
                        0.0,
                        0.001,
                        0.02,
                        0.011,
                        0.032,
                        0.026,
                        0.067,
                        0.033,
                        0.094,
                        0.05,
                        0.165,
                        0.071,
                        0.116,
                        0.629,
                        0.58,
                        0.827,
                        1.46,
                        1.989,
                        3.1,
                        3.248,
                        5.16,
                        5.802,
                        8.039,
                        9.582,
                        10.682,
                        10.651,
                        12.321,
                        15.755,
                        16.535,
                        17.81,
                        14.595,
                        14.855,
                        17.804,
                        15.891,
                        14.866,
                        15.541,
                        19.018,
                        17.511,
                        17.225,
                        14.658,
                        14.851,
                        13.784,
                        14.308,
                        14.344,
                        10.702
                    ],
                    "name": "All Men",
                    "type": "column"
                },
                {
                    "color": "#de2d26",
                    "data": [
                        0.0,
                        0.0,
                        0.0,
                        0.0,
                        0.0,
                        0.0,
                        0.0,
                        0.0,
                        0.0,
                        0.007,
                        0.005,
                        0.008,
                        0.011,
                        0.002,
                        0.008,
                        0.003,
                        0.024,
                        0.024,
                        0.012,
                        0.012,
                        0.051,
                        0.013,
                        0.064,
                        0.029,
                        0.064,
                        0.226,
                        0.241,
                        0.555,
                        0.667,
                        0.473,
                        0.209,
                        0.261,
                        0.386,
                        0.403,
                        0.431,
                        0.383,
                        0.459,
                        0.264,
                        0.445,
                        0.474,
                        0.591,
                        0.699,
                        0.827,
                        0.435,
                        0.601
                    ],
                    "name": "All Women",
                    "type": "column"
                },
                {
                    "color": "darkblue",
                    "data": [
                        0.0,
                        0.0,
                        0.0,
                        0.0,
                        0.0,
                        0.0,
                        0.0,
                        0.0,
                        0.0,
                        0.0,
                        0.0,
                        0.0,
                        0.0,
                        0.0,
                        0.0,
                        0.0,
                        1.64,
                        1.21,
                        0.39,
                        0.37,
                        0.99,
                        0.22,
                        0.8,
                        0.3,
                        0.6,
                        2.12,
                        1.96,
                        3.52,
                        4.03,
                        2.66,
                        1.43,
                        1.76,
                        2.17,
                        2.54,
                        2.9,
                        2.46,
                        2.41,
                        1.51,
                        2.58,
                        3.23,
                        3.98,
                        5.07,
                        5.78,
                        3.03,
                        5.62
                    ],
                    "marker": {
                        "fillColor": "#FFFFFF",
                        "lineColor": "darkblue",
                        "lineWidth": 2,
                        "radius": 5
                    },
                    "name": "Among core",
                    "type": "spline",
                    "yAxis": 1
                }
            ],
            "height_ratio": 69.23076923076923,
            "label_x": "Time (quarter)",
            "label_y": "Commit Numbers (thousand)",
            "label_y_secondary": "Women Commit Ratio = F/(F + M)",
            "title": "Commits in Puppet Public Projects",
            "x_categories": [
                "2008-3",
                "2008-6",
                "2008-9",
                "2008-12",
                "2009-3",
                "2009-6",
                "2009-9",
                "2009-12",
                "2010-3",
                "2010-6",
                "2010-9",
                "2010-12",
                "2011-3",
                "2011-6",
                "2011-9",
                "2011-12",
                "2012-3",
                "2012-6",
                "2012-9",
                "2012-12",
                "2013-3",
                "2013-6",
                "2013-9",
                "2013-12",
                "2014-3",
                "2014-6",
                "2014-9",
                "2014-12",
                "2015-3",
                "2015-6",
                "2015-9",
                "2015-12",
                "2016-3",
                "2016-6",
                "2016-9",
                "2016-12",
                "2017-3",
                "2017-6",
                "2017-9",
                "2017-12",
                "2018-3",
                "2018-6",
                "2018-9",
                "2018-12",
                "2019-3"
            ]
        },
        "Pypi": {
            "data": [
                {
                    "color": "blanchedalmond",
                    "data": [
                        7.782,
                        8.767,
                        10.163,
                        10.782,
                        15.716,
                        15.925,
                        15.584,
                        17.188,
                        20.816,
                        24.024,
                        35.28,
                        32.933,
                        39.07,
                        46.503,
                        59.381,
                        62.544,
                        86.244,
                        91.317,
                        119.571,
                        102.361,
                        162.93,
                        172.934,
                        215.271,
                        238.692,
                        291.459,
                        305.987,
                        332.369,
                        351.444,
                        423.707,
                        444.253,
                        452.919,
                        464.706,
                        520.944,
                        536.468,
                        561.182,
                        587.338,
                        709.158,
                        755.318,
                        824.383,
                        825.767,
                        931.68,
                        991.57,
                        1046.132,
                        1119.512,
                        1111.169
                    ],
                    "name": "All Unknown",
                    "type": "column"
                },
                {
                    "color": "#f29d4b",
                    "data": [
                        5.478,
                        6.667,
                        7.488,
                        8.145,
                        12.265,
                        12.232,
                        12.452,
                        13.544,
                        16.199,
                        19.677,
                        29.617,
                        25.356,
                        31.366,
                        38.671,
                        48.382,
                        50.791,
                        69.391,
                        73.468,
                        94.374,
                        83.16,
                        129.902,
                        136.857,
                        168.986,
                        186.495,
                        228.833,
                        241.238,
                        260.232,
                        270.372,
                        327.79,
                        339.659,
                        349.788,
                        354.054,
                        394.363,
                        403.641,
                        423.098,
                        442.696,
                        533.534,
                        554.555,
                        596.246,
                        604.214,
                        670.07,
                        705.611,
                        750.678,
                        786.156,
                        776.127
                    ],
                    "name": "All Men",
                    "type": "column"
                },
                {
                    "color": "#de2d26",
                    "data": [
                        0.04,
                        0.068,
                        0.024,
                        0.04,
                        0.045,
                        0.101,
                        0.128,
                        0.163,
                        0.197,
                        0.32,
                        0.592,
                        0.547,
                        0.517,
                        0.622,
                        0.821,
                        0.835,
                        1.06,
                        1.159,
                        1.803,
                        1.58,
                        2.715,
                        2.972,
                        4.263,
                        4.809,
                        6.921,
                        6.627,
                        8.451,
                        8.872,
                        11.13,
                        13.011,
                        14.471,
                        12.552,
                        12.73,
                        14.081,
                        16.8,
                        18.206,
                        23.909,
                        23.283,
                        42.214,
                        26.592,
                        33.281,
                        34.619,
                        37.054,
                        37.832,
                        38.581
                    ],
                    "name": "All Women",
                    "type": "column"
                },
                {
                    "color": "darkblue",
                    "data": [
                        0.73,
                        1.02,
                        0.32,
                        0.49,
                        0.37,
                        0.83,
                        1.03,
                        1.2,
                        1.22,
                        1.63,
                        2.0,
                        2.16,
                        1.65,
                        1.61,
                        1.7,
                        1.64,
                        1.53,
                        1.58,
                        1.91,
                        1.9,
                        2.09,
                        2.17,
                        2.52,
                        2.58,
                        3.02,
                        2.75,
                        3.25,
                        3.28,
                        3.4,
                        3.83,
                        4.14,
                        3.55,
                        3.23,
                        3.49,
                        3.97,
                        4.11,
                        4.48,
                        4.2,
                        7.08,
                        4.4,
                        4.97,
                        4.91,
                        4.94,
                        4.81,
                        4.97
                    ],
                    "marker": {
                        "fillColor": "#FFFFFF",
                        "lineColor": "darkblue",
                        "lineWidth": 2,
                        "radius": 5
                    },
                    "name": "Among core",
                    "type": "spline",
                    "yAxis": 1
                }
            ],
            "height_ratio": 69.23076923076923,
            "label_x": "Time (quarter)",
            "label_y": "Commit Numbers (thousand)",
            "label_y_secondary": "Women Commit Ratio = F/(F + M)",
            "title": "Commits in Pypi Public Projects",
            "x_categories": [
                "2008-3",
                "2008-6",
                "2008-9",
                "2008-12",
                "2009-3",
                "2009-6",
                "2009-9",
                "2009-12",
                "2010-3",
                "2010-6",
                "2010-9",
                "2010-12",
                "2011-3",
                "2011-6",
                "2011-9",
                "2011-12",
                "2012-3",
                "2012-6",
                "2012-9",
                "2012-12",
                "2013-3",
                "2013-6",
                "2013-9",
                "2013-12",
                "2014-3",
                "2014-6",
                "2014-9",
                "2014-12",
                "2015-3",
                "2015-6",
                "2015-9",
                "2015-12",
                "2016-3",
                "2016-6",
                "2016-9",
                "2016-12",
                "2017-3",
                "2017-6",
                "2017-9",
                "2017-12",
                "2018-3",
                "2018-6",
                "2018-9",
                "2018-12",
                "2019-3"
            ]
        },
        "RubyGems": {
            "data": [
                {
                    "color": "blanchedalmond",
                    "data": [
                        8.625,
                        13.062,
                        15.332,
                        19.735,
                        27.035,
                        26.379,
                        30.405,
                        40.04,
                        44.327,
                        47.418,
                        52.458,
                        60.988,
                        74.253,
                        86.694,
                        95.823,
                        105.385,
                        144.256,
                        141.98,
                        182.336,
                        139.137,
                        216.211,
                        207.041,
                        244.681,
                        254.17,
                        271.02,
                        259.603,
                        254.83,
                        260.222,
                        299.406,
                        278.645,
                        254.821,
                        257.538,
                        279.644,
                        247.981,
                        235.458,
                        242.087,
                        258.812,
                        236.498,
                        234.934,
                        244.937,
                        246.693,
                        230.129,
                        218.896,
                        222.239,
                        204.684
                    ],
                    "name": "All Unknown",
                    "type": "column"
                },
                {
                    "color": "#f29d4b",
                    "data": [
                        5.707,
                        10.006,
                        11.63,
                        15.148,
                        21.633,
                        21.888,
                        25.149,
                        32.524,
                        35.903,
                        38.949,
                        43.237,
                        50.319,
                        62.497,
                        71.411,
                        79.518,
                        86.456,
                        117.844,
                        114.711,
                        145.831,
                        113.87,
                        176.701,
                        169.24,
                        199.167,
                        206.557,
                        221.287,
                        212.747,
                        207.517,
                        211.052,
                        239.577,
                        220.841,
                        200.851,
                        203.96,
                        223.145,
                        197.601,
                        187.403,
                        186.538,
                        200.244,
                        187.509,
                        180.898,
                        185.205,
                        185.11,
                        172.32,
                        154.455,
                        167.492,
                        153.877
                    ],
                    "name": "All Men",
                    "type": "column"
                },
                {
                    "color": "#de2d26",
                    "data": [
                        0.329,
                        0.467,
                        0.438,
                        0.256,
                        0.627,
                        0.783,
                        0.591,
                        0.909,
                        0.886,
                        1.085,
                        0.969,
                        0.952,
                        0.974,
                        1.277,
                        1.92,
                        1.887,
                        2.796,
                        2.725,
                        3.05,
                        2.497,
                        3.439,
                        4.735,
                        5.279,
                        6.114,
                        6.15,
                        6.615,
                        8.064,
                        7.445,
                        9.064,
                        8.0,
                        9.393,
                        8.819,
                        8.716,
                        8.455,
                        8.691,
                        8.781,
                        8.95,
                        9.829,
                        9.359,
                        9.566,
                        11.851,
                        9.918,
                        8.696,
                        7.805,
                        7.432
                    ],
                    "name": "All Women",
                    "type": "column"
                },
                {
                    "color": "darkblue",
                    "data": [
                        5.76,
                        4.67,
                        3.77,
                        1.69,
                        2.9,
                        3.58,
                        2.35,
                        2.79,
                        2.47,
                        2.79,
                        2.24,
                        1.89,
                        1.56,
                        1.79,
                        2.41,
                        2.18,
                        2.37,
                        2.38,
                        2.09,
                        2.19,
                        1.95,
                        2.8,
                        2.65,
                        2.96,
                        2.78,
                        3.11,
                        3.89,
                        3.53,
                        3.78,
                        3.62,
                        4.68,
                        4.32,
                        3.91,
                        4.28,
                        4.64,
                        4.71,
                        4.47,
                        5.24,
                        5.17,
                        5.17,
                        6.4,
                        5.76,
                        5.63,
                        4.66,
                        4.83
                    ],
                    "marker": {
                        "fillColor": "#FFFFFF",
                        "lineColor": "darkblue",
                        "lineWidth": 2,
                        "radius": 5
                    },
                    "name": "Among core",
                    "type": "spline",
                    "yAxis": 1
                }
            ],
            "height_ratio": 69.23076923076923,
            "label_x": "Time (quarter)",
            "label_y": "Commit Numbers (thousand)",
            "label_y_secondary": "Women Commit Ratio = F/(F + M)",
            "title": "Commits in RubyGems Public Projects",
            "x_categories": [
                "2008-3",
                "2008-6",
                "2008-9",
                "2008-12",
                "2009-3",
                "2009-6",
                "2009-9",
                "2009-12",
                "2010-3",
                "2010-6",
                "2010-9",
                "2010-12",
                "2011-3",
                "2011-6",
                "2011-9",
                "2011-12",
                "2012-3",
                "2012-6",
                "2012-9",
                "2012-12",
                "2013-3",
                "2013-6",
                "2013-9",
                "2013-12",
                "2014-3",
                "2014-6",
                "2014-9",
                "2014-12",
                "2015-3",
                "2015-6",
                "2015-9",
                "2015-12",
                "2016-3",
                "2016-6",
                "2016-9",
                "2016-12",
                "2017-3",
                "2017-6",
                "2017-9",
                "2017-12",
                "2018-3",
                "2018-6",
                "2018-9",
                "2018-12",
                "2019-3"
            ]
        }
    },
    "Contributor": {
        "All": {
            "data": [
                {
                    "color": "blanchedalmond",
                    "data": [
                        2.019,
                        2.623,
                        3.161,
                        3.587,
                        4.462,
                        4.799,
                        5.313,
                        6.41,
                        7.761,
                        8.568,
                        10.582,
                        12.655,
                        15.719,
                        19.322,
                        22.699,
                        26.0,
                        34.694,
                        37.732,
                        45.687,
                        47.784,
                        62.482,
                        68.701,
                        79.598,
                        87.26,
                        101.064,
                        108.003,
                        117.407,
                        126.443,
                        146.048,
                        154.306,
                        158.627,
                        169.975,
                        186.41,
                        188.769,
                        191.718,
                        201.788,
                        217.325,
                        222.837,
                        231.208,
                        240.576,
                        251.201,
                        253.518,
                        256.027,
                        265.148,
                        262.382
                    ],
                    "name": "All Unknown",
                    "type": "column"
                },
                {
                    "color": "#f29d4b",
                    "data": [
                        1.348,
                        1.888,
                        2.29,
                        2.652,
                        3.337,
                        3.617,
                        4.028,
                        4.911,
                        6.009,
                        6.696,
                        8.302,
                        9.969,
                        12.581,
                        15.509,
                        18.245,
                        20.913,
                        27.638,
                        30.067,
                        35.786,
                        37.419,
                        48.363,
                        52.836,
                        60.387,
                        65.787,
                        76.274,
                        81.158,
                        87.185,
                        93.442,
                        107.212,
                        112.651,
                        115.324,
                        122.302,
                        134.097,
                        134.949,
                        136.063,
                        141.369,
                        152.488,
                        153.763,
                        157.887,
                        163.516,
                        170.143,
                        169.779,
                        168.62,
                        173.097,
                        170.536
                    ],
                    "name": "All Men",
                    "type": "column"
                },
                {
                    "color": "#de2d26",
                    "data": [
                        0.039,
                        0.04,
                        0.053,
                        0.05,
                        0.073,
                        0.08,
                        0.089,
                        0.095,
                        0.112,
                        0.155,
                        0.195,
                        0.216,
                        0.27,
                        0.321,
                        0.401,
                        0.449,
                        0.563,
                        0.661,
                        0.857,
                        0.851,
                        1.168,
                        1.319,
                        1.604,
                        1.776,
                        2.149,
                        2.413,
                        2.738,
                        2.942,
                        3.413,
                        3.821,
                        4.103,
                        4.336,
                        4.866,
                        5.13,
                        5.35,
                        5.654,
                        6.131,
                        6.572,
                        7.022,
                        7.34,
                        7.633,
                        7.992,
                        8.185,
                        8.408,
                        8.362
                    ],
                    "name": "All Women",
                    "type": "column"
                },
                {
                    "color": "darkblue",
                    "data": [
                        2.89,
                        2.12,
                        2.31,
                        1.89,
                        2.19,
                        2.21,
                        2.21,
                        1.93,
                        1.86,
                        2.31,
                        2.35,
                        2.17,
                        2.15,
                        2.07,
                        2.2,
                        2.15,
                        2.04,
                        2.2,
                        2.39,
                        2.27,
                        2.42,
                        2.5,
                        2.66,
                        2.7,
                        2.82,
                        2.97,
                        3.14,
                        3.15,
                        3.18,
                        3.39,
                        3.56,
                        3.55,
                        3.63,
                        3.8,
                        3.93,
                        4.0,
                        4.02,
                        4.27,
                        4.45,
                        4.49,
                        4.49,
                        4.71,
                        4.85,
                        4.86,
                        4.9
                    ],
                    "name": "Among all",
                    "type": "spline",
                    "yAxis": 1
                },
                {
                    "color": "darkblue",
                    "data": [
                        2.65,
                        1.89,
                        2.21,
                        1.94,
                        2.2,
                        2.25,
                        2.25,
                        2.02,
                        1.86,
                        2.39,
                        2.35,
                        2.17,
                        2.17,
                        2.07,
                        2.12,
                        2.06,
                        2.02,
                        2.14,
                        2.36,
                        2.28,
                        2.38,
                        2.45,
                        2.72,
                        2.71,
                        2.84,
                        2.99,
                        3.2,
                        3.18,
                        3.32,
                        3.5,
                        3.68,
                        3.65,
                        3.73,
                        3.94,
                        4.11,
                        4.18,
                        4.15,
                        4.46,
                        4.65,
                        4.73,
                        4.64,
                        4.96,
                        5.07,
                        5.12,
                        5.15
                    ],
                    "marker": {
                        "fillColor": "#FFFFFF",
                        "lineColor": "darkblue",
                        "lineWidth": 2,
                        "radius": 5
                    },
                    "name": "Among core",
                    "type": "spline",
                    "yAxis": 1
                }
            ],
            "height_ratio": 69.23076923076923,
            "label_x": "Time (quarter)",
            "label_y": "Number of Contributors (thousand)",
            "label_y_secondary": "% Women (of total m + w)",
            "title": "Active Contributors in All Public Projects",
            "x_categories": [
                "2008-3",
                "2008-6",
                "2008-9",
                "2008-12",
                "2009-3",
                "2009-6",
                "2009-9",
                "2009-12",
                "2010-3",
                "2010-6",
                "2010-9",
                "2010-12",
                "2011-3",
                "2011-6",
                "2011-9",
                "2011-12",
                "2012-3",
                "2012-6",
                "2012-9",
                "2012-12",
                "2013-3",
                "2013-6",
                "2013-9",
                "2013-12",
                "2014-3",
                "2014-6",
                "2014-9",
                "2014-12",
                "2015-3",
                "2015-6",
                "2015-9",
                "2015-12",
                "2016-3",
                "2016-6",
                "2016-9",
                "2016-12",
                "2017-3",
                "2017-6",
                "2017-9",
                "2017-12",
                "2018-3",
                "2018-6",
                "2018-9",
                "2018-12",
                "2019-3"
            ]
        },
        "All_line": {
            "data": [
                {
                    "color": "#52796F",
                    "data": [
                        2.89,
                        2.12,
                        2.31,
                        1.89,
                        2.19,
                        2.21,
                        2.21,
                        1.93,
                        1.86,
                        2.31,
                        2.35,
                        2.17,
                        2.15,
                        2.07,
                        2.2,
                        2.15,
                        2.04,
                        2.2,
                        2.39,
                        2.27,
                        2.42,
                        2.5,
                        2.66,
                        2.7,
                        2.82,
                        2.97,
                        3.14,
                        3.15,
                        3.18,
                        3.39,
                        3.56,
                        3.55,
                        3.63,
                        3.8,
                        3.93,
                        4.0,
                        4.02,
                        4.27,
                        4.45,
                        4.49,
                        4.49,
                        4.71,
                        4.85,
                        4.86,
                        4.9
                    ],
                    "name": "Among all",
                    "type": "spline",
                    "yAxis": 1
                }
            ],
            "height_ratio": 66.66666666666666,
            "label_x": "",
            "label_y": "",
            "label_y_secondary": "",
            "title": "",
            "x_categories": [
                "2008",
                "2008",
                "2008",
                "2008",
                "2009",
                "2009",
                "2009",
                "2009",
                "2010",
                "2010",
                "2010",
                "2010",
                "2011",
                "2011",
                "2011",
                "2011",
                "2012",
                "2012",
                "2012",
                "2012",
                "2013",
                "2013",
                "2013",
                "2013",
                "2014",
                "2014",
                "2014",
                "2014",
                "2015",
                "2015",
                "2015",
                "2015",
                "2016",
                "2016",
                "2016",
                "2016",
                "2017",
                "2017",
                "2017",
                "2017",
                "2018",
                "2018",
                "2018",
                "2018",
                "2019"
            ]
        },
        "All_women-bar": {
            "data": [
                {
                    "color": "#52796F",
                    "data": [
                        39,
                        40,
                        53,
                        50,
                        73,
                        80,
                        89,
                        95,
                        112,
                        155,
                        195,
                        216,
                        270,
                        321,
                        401,
                        449,
                        563,
                        661,
                        857,
                        851,
                        1168,
                        1319,
                        1604,
                        1776,
                        2149,
                        2413,
                        2738,
                        2942,
                        3413,
                        3821,
                        4103,
                        4336,
                        4866,
                        5130,
                        5350,
                        5654,
                        6131,
                        6572,
                        7022,
                        7340,
                        7633,
                        7992,
                        8185,
                        8408,
                        8362
                    ],
                    "name": "Women",
                    "type": "column",
                    "yAxis": 1
                }
            ],
            "height_ratio": 66.66666666666666,
            "label_x": "",
            "label_y": "",
            "label_y_secondary": "",
            "title": "",
            "x_categories": [
                "2008",
                "2008",
                "2008",
                "2008",
                "2009",
                "2009",
                "2009",
                "2009",
                "2010",
                "2010",
                "2010",
                "2010",
                "2011",
                "2011",
                "2011",
                "2011",
                "2012",
                "2012",
                "2012",
                "2012",
                "2013",
                "2013",
                "2013",
                "2013",
                "2014",
                "2014",
                "2014",
                "2014",
                "2015",
                "2015",
                "2015",
                "2015",
                "2016",
                "2016",
                "2016",
                "2016",
                "2017",
                "2017",
                "2017",
                "2017",
                "2018",
                "2018",
                "2018",
                "2018",
                "2019"
            ]
        },
        "Atom": {
            "data": [
                {
                    "color": "blanchedalmond",
                    "data": [
                        0.0,
                        0.0,
                        0.0,
                        0.0,
                        0.0,
                        0.0,
                        0.0,
                        0.0,
                        0.0,
                        0.0,
                        0.001,
                        0.0,
                        0.0,
                        0.0,
                        0.001,
                        0.0,
                        0.007,
                        0.014,
                        0.026,
                        0.065,
                        0.082,
                        0.078,
                        0.094,
                        0.085,
                        0.781,
                        0.912,
                        0.932,
                        0.9,
                        1.509,
                        2.138,
                        2.037,
                        2.086,
                        2.22,
                        2.181,
                        2.046,
                        2.106,
                        2.698,
                        2.309,
                        1.958,
                        1.893,
                        1.649,
                        1.484,
                        1.329,
                        1.199,
                        0.938
                    ],
                    "name": "All Unknown",
                    "type": "column"
                },
                {
                    "color": "#f29d4b",
                    "data": [
                        0.0,
                        0.0,
                        0.0,
                        0.0,
                        0.0,
                        0.0,
                        0.0,
                        0.0,
                        0.0,
                        0.0,
                        0.0,
                        0.0,
                        0.0,
                        0.0,
                        0.0,
                        0.0,
                        0.006,
                        0.013,
                        0.023,
                        0.054,
                        0.063,
                        0.065,
                        0.072,
                        0.071,
                        0.654,
                        0.742,
                        0.731,
                        0.71,
                        1.188,
                        1.661,
                        1.543,
                        1.588,
                        1.677,
                        1.597,
                        1.523,
                        1.555,
                        2.037,
                        1.73,
                        1.441,
                        1.38,
                        1.166,
                        1.055,
                        0.942,
                        0.804,
                        0.609
                    ],
                    "name": "All Men",
                    "type": "column"
                },
                {
                    "color": "#de2d26",
                    "data": [
                        0.0,
                        0.0,
                        0.0,
                        0.0,
                        0.0,
                        0.0,
                        0.0,
                        0.0,
                        0.0,
                        0.0,
                        0.0,
                        0.0,
                        0.0,
                        0.0,
                        0.0,
                        0.0,
                        0.001,
                        0.001,
                        0.001,
                        0.002,
                        0.001,
                        0.002,
                        0.002,
                        0.002,
                        0.014,
                        0.018,
                        0.014,
                        0.015,
                        0.029,
                        0.04,
                        0.036,
                        0.046,
                        0.04,
                        0.051,
                        0.035,
                        0.056,
                        0.07,
                        0.057,
                        0.049,
                        0.048,
                        0.043,
                        0.051,
                        0.038,
                        0.026,
                        0.023
                    ],
                    "name": "All Women",
                    "type": "column"
                },
                {
                    "color": "darkblue",
                    "data": [
                        0.0,
                        0.0,
                        0.0,
                        0.0,
                        0.0,
                        0.0,
                        0.0,
                        0.0,
                        0.0,
                        0.0,
                        0.0,
                        0.0,
                        0.0,
                        0.0,
                        0.0,
                        0.0,
                        16.67,
                        7.69,
                        4.35,
                        3.7,
                        1.59,
                        3.08,
                        2.78,
                        2.82,
                        2.14,
                        2.43,
                        1.92,
                        2.11,
                        2.44,
                        2.41,
                        2.33,
                        2.9,
                        2.39,
                        3.19,
                        2.3,
                        3.6,
                        3.44,
                        3.29,
                        3.4,
                        3.48,
                        3.69,
                        4.83,
                        4.03,
                        3.23,
                        3.78
                    ],
                    "name": "Among all",
                    "type": "spline",
                    "yAxis": 1
                },
                {
                    "color": "darkblue",
                    "data": [
                        0.0,
                        0.0,
                        0.0,
                        0.0,
                        0.0,
                        0.0,
                        0.0,
                        0.0,
                        0.0,
                        0.0,
                        0.0,
                        0.0,
                        0.0,
                        0.0,
                        0.0,
                        0.0,
                        0.0,
                        8.33,
                        4.76,
                        3.77,
                        1.67,
                        3.08,
                        2.78,
                        2.86,
                        1.89,
                        2.13,
                        2.0,
                        2.4,
                        2.27,
                        2.74,
                        2.37,
                        2.7,
                        2.08,
                        3.0,
                        2.43,
                        4.03,
                        2.73,
                        2.79,
                        3.57,
                        3.46,
                        4.1,
                        3.92,
                        4.19,
                        3.26,
                        5.0
                    ],
                    "marker": {
                        "fillColor": "#FFFFFF",
                        "lineColor": "darkblue",
                        "lineWidth": 2,
                        "radius": 5
                    },
                    "name": "Among core",
                    "type": "spline",
                    "yAxis": 1
                }
            ],
            "height_ratio": 69.23076923076923,
            "label_x": "Time (quarter)",
            "label_y": "Number of Contributors (thousand)",
            "label_y_secondary": "% Women (of total m + w)",
            "title": "Active Contributors in Atom Public Projects",
            "x_categories": [
                "2008-3",
                "2008-6",
                "2008-9",
                "2008-12",
                "2009-3",
                "2009-6",
                "2009-9",
                "2009-12",
                "2010-3",
                "2010-6",
                "2010-9",
                "2010-12",
                "2011-3",
                "2011-6",
                "2011-9",
                "2011-12",
                "2012-3",
                "2012-6",
                "2012-9",
                "2012-12",
                "2013-3",
                "2013-6",
                "2013-9",
                "2013-12",
                "2014-3",
                "2014-6",
                "2014-9",
                "2014-12",
                "2015-3",
                "2015-6",
                "2015-9",
                "2015-12",
                "2016-3",
                "2016-6",
                "2016-9",
                "2016-12",
                "2017-3",
                "2017-6",
                "2017-9",
                "2017-12",
                "2018-3",
                "2018-6",
                "2018-9",
                "2018-12",
                "2019-3"
            ]
        },
        "Atom_line": {
            "data": [
                {
                    "color": "#5FB57D",
                    "data": [
                        NaN,
                        NaN,
                        NaN,
                        NaN,
                        NaN,
                        NaN,
                        NaN,
                        NaN,
                        NaN,
                        NaN,
                        0.0,
                        NaN,
                        NaN,
                        NaN,
                        0.0,
                        NaN,
                        16.67,
                        7.69,
                        4.35,
                        3.7,
                        1.59,
                        3.08,
                        2.78,
                        2.82,
                        2.14,
                        2.43,
                        1.92,
                        2.11,
                        2.44,
                        2.41,
                        2.33,
                        2.9,
                        2.39,
                        3.19,
                        2.3,
                        3.6,
                        3.44,
                        3.29,
                        3.4,
                        3.48,
                        3.69,
                        4.83,
                        4.03,
                        3.23,
                        3.78
                    ],
                    "name": "Among all",
                    "type": "spline",
                    "yAxis": 1
                }
            ],
            "height_ratio": 66.66666666666666,
            "label_x": "",
            "label_y": "",
            "label_y_secondary": "",
            "title": "",
            "x_categories": [
                "2008",
                "2008",
                "2008",
                "2008",
                "2009",
                "2009",
                "2009",
                "2009",
                "2010",
                "2010",
                "2010",
                "2010",
                "2011",
                "2011",
                "2011",
                "2011",
                "2012",
                "2012",
                "2012",
                "2012",
                "2013",
                "2013",
                "2013",
                "2013",
                "2014",
                "2014",
                "2014",
                "2014",
                "2015",
                "2015",
                "2015",
                "2015",
                "2016",
                "2016",
                "2016",
                "2016",
                "2017",
                "2017",
                "2017",
                "2017",
                "2018",
                "2018",
                "2018",
                "2018",
                "2019"
            ]
        },
        "Atom_women-bar": {
            "data": [
                {
                    "color": "#5FB57D",
                    "data": [
                        0,
                        0,
                        0,
                        0,
                        0,
                        0,
                        0,
                        0,
                        0,
                        0,
                        0,
                        0,
                        0,
                        0,
                        0,
                        0,
                        1,
                        1,
                        1,
                        2,
                        1,
                        2,
                        2,
                        2,
                        14,
                        18,
                        14,
                        15,
                        29,
                        40,
                        36,
                        46,
                        40,
                        51,
                        35,
                        56,
                        70,
                        57,
                        49,
                        48,
                        43,
                        51,
                        38,
                        26,
                        23
                    ],
                    "name": "Women",
                    "type": "column",
                    "yAxis": 1
                }
            ],
            "height_ratio": 66.66666666666666,
            "label_x": "",
            "label_y": "",
            "label_y_secondary": "",
            "title": "",
            "x_categories": [
                "2008",
                "2008",
                "2008",
                "2008",
                "2009",
                "2009",
                "2009",
                "2009",
                "2010",
                "2010",
                "2010",
                "2010",
                "2011",
                "2011",
                "2011",
                "2011",
                "2012",
                "2012",
                "2012",
                "2012",
                "2013",
                "2013",
                "2013",
                "2013",
                "2014",
                "2014",
                "2014",
                "2014",
                "2015",
                "2015",
                "2015",
                "2015",
                "2016",
                "2016",
                "2016",
                "2016",
                "2017",
                "2017",
                "2017",
                "2017",
                "2018",
                "2018",
                "2018",
                "2018",
                "2019"
            ]
        },
        "Bower": {
            "data": [
                {
                    "color": "blanchedalmond",
                    "data": [
                        0.092,
                        0.128,
                        0.155,
                        0.184,
                        0.221,
                        0.235,
                        0.259,
                        0.363,
                        0.56,
                        0.722,
                        1.146,
                        1.474,
                        1.916,
                        2.608,
                        3.318,
                        3.857,
                        5.432,
                        5.606,
                        6.943,
                        7.773,
                        10.948,
                        12.134,
                        14.607,
                        15.981,
                        18.803,
                        19.963,
                        21.634,
                        23.165,
                        26.843,
                        27.47,
                        28.031,
                        28.155,
                        29.344,
                        27.317,
                        25.259,
                        25.429,
                        25.894,
                        24.059,
                        22.583,
                        21.35,
                        20.35,
                        18.387,
                        16.964,
                        16.741,
                        14.609
                    ],
                    "name": "All Unknown",
                    "type": "column"
                },
                {
                    "color": "#f29d4b",
                    "data": [
                        0.073,
                        0.106,
                        0.113,
                        0.137,
                        0.161,
                        0.171,
                        0.192,
                        0.278,
                        0.42,
                        0.532,
                        0.833,
                        1.114,
                        1.492,
                        2.035,
                        2.57,
                        3.073,
                        4.31,
                        4.423,
                        5.401,
                        6.051,
                        8.604,
                        9.436,
                        11.144,
                        12.12,
                        14.387,
                        15.197,
                        16.334,
                        17.438,
                        20.333,
                        20.557,
                        20.835,
                        20.63,
                        21.718,
                        20.062,
                        18.296,
                        18.323,
                        18.65,
                        17.1,
                        15.851,
                        14.839,
                        14.216,
                        12.751,
                        11.644,
                        11.377,
                        10.077
                    ],
                    "name": "All Men",
                    "type": "column"
                },
                {
                    "color": "#de2d26",
                    "data": [
                        0.001,
                        0.003,
                        0.003,
                        0.004,
                        0.005,
                        0.009,
                        0.005,
                        0.005,
                        0.006,
                        0.016,
                        0.022,
                        0.024,
                        0.033,
                        0.039,
                        0.058,
                        0.065,
                        0.073,
                        0.106,
                        0.111,
                        0.129,
                        0.202,
                        0.205,
                        0.289,
                        0.309,
                        0.379,
                        0.466,
                        0.512,
                        0.531,
                        0.646,
                        0.685,
                        0.726,
                        0.713,
                        0.771,
                        0.766,
                        0.716,
                        0.719,
                        0.731,
                        0.741,
                        0.667,
                        0.68,
                        0.62,
                        0.617,
                        0.571,
                        0.57,
                        0.524
                    ],
                    "name": "All Women",
                    "type": "column"
                },
                {
                    "color": "darkblue",
                    "data": [
                        1.37,
                        2.83,
                        2.65,
                        2.92,
                        3.11,
                        5.26,
                        2.6,
                        1.8,
                        1.43,
                        3.01,
                        2.64,
                        2.15,
                        2.21,
                        1.92,
                        2.26,
                        2.12,
                        1.69,
                        2.4,
                        2.06,
                        2.13,
                        2.35,
                        2.17,
                        2.59,
                        2.55,
                        2.63,
                        3.07,
                        3.13,
                        3.05,
                        3.18,
                        3.33,
                        3.48,
                        3.46,
                        3.55,
                        3.82,
                        3.91,
                        3.92,
                        3.92,
                        4.33,
                        4.21,
                        4.58,
                        4.36,
                        4.84,
                        4.9,
                        5.01,
                        5.2
                    ],
                    "name": "Among all",
                    "type": "spline",
                    "yAxis": 1
                },
                {
                    "color": "darkblue",
                    "data": [
                        1.45,
                        1.98,
                        2.78,
                        3.15,
                        3.42,
                        5.73,
                        2.78,
                        1.95,
                        1.5,
                        3.14,
                        2.75,
                        2.26,
                        2.32,
                        2.02,
                        2.3,
                        2.06,
                        1.64,
                        2.49,
                        2.08,
                        2.21,
                        2.37,
                        2.1,
                        2.74,
                        2.67,
                        2.74,
                        3.14,
                        3.18,
                        3.04,
                        3.19,
                        3.34,
                        3.51,
                        3.53,
                        3.69,
                        3.89,
                        3.85,
                        4.08,
                        4.0,
                        4.33,
                        4.3,
                        4.65,
                        4.49,
                        4.94,
                        5.12,
                        5.14,
                        5.34
                    ],
                    "marker": {
                        "fillColor": "#FFFFFF",
                        "lineColor": "darkblue",
                        "lineWidth": 2,
                        "radius": 5
                    },
                    "name": "Among core",
                    "type": "spline",
                    "yAxis": 1
                }
            ],
            "height_ratio": 69.23076923076923,
            "label_x": "Time (quarter)",
            "label_y": "Number of Contributors (thousand)",
            "label_y_secondary": "% Women (of total m + w)",
            "title": "Active Contributors in Bower Public Projects",
            "x_categories": [
                "2008-3",
                "2008-6",
                "2008-9",
                "2008-12",
                "2009-3",
                "2009-6",
                "2009-9",
                "2009-12",
                "2010-3",
                "2010-6",
                "2010-9",
                "2010-12",
                "2011-3",
                "2011-6",
                "2011-9",
                "2011-12",
                "2012-3",
                "2012-6",
                "2012-9",
                "2012-12",
                "2013-3",
                "2013-6",
                "2013-9",
                "2013-12",
                "2014-3",
                "2014-6",
                "2014-9",
                "2014-12",
                "2015-3",
                "2015-6",
                "2015-9",
                "2015-12",
                "2016-3",
                "2016-6",
                "2016-9",
                "2016-12",
                "2017-3",
                "2017-6",
                "2017-9",
                "2017-12",
                "2018-3",
                "2018-6",
                "2018-9",
                "2018-12",
                "2019-3"
            ]
        },
        "Bower_line": {
            "data": [
                {
                    "color": "#D13916",
                    "data": [
                        1.37,
                        2.83,
                        2.65,
                        2.92,
                        3.11,
                        5.26,
                        2.6,
                        1.8,
                        1.43,
                        3.01,
                        2.64,
                        2.15,
                        2.21,
                        1.92,
                        2.26,
                        2.12,
                        1.69,
                        2.4,
                        2.06,
                        2.13,
                        2.35,
                        2.17,
                        2.59,
                        2.55,
                        2.63,
                        3.07,
                        3.13,
                        3.05,
                        3.18,
                        3.33,
                        3.48,
                        3.46,
                        3.55,
                        3.82,
                        3.91,
                        3.92,
                        3.92,
                        4.33,
                        4.21,
                        4.58,
                        4.36,
                        4.84,
                        4.9,
                        5.01,
                        5.2
                    ],
                    "name": "Among all",
                    "type": "spline",
                    "yAxis": 1
                }
            ],
            "height_ratio": 66.66666666666666,
            "label_x": "",
            "label_y": "",
            "label_y_secondary": "",
            "title": "",
            "x_categories": [
                "2008",
                "2008",
                "2008",
                "2008",
                "2009",
                "2009",
                "2009",
                "2009",
                "2010",
                "2010",
                "2010",
                "2010",
                "2011",
                "2011",
                "2011",
                "2011",
                "2012",
                "2012",
                "2012",
                "2012",
                "2013",
                "2013",
                "2013",
                "2013",
                "2014",
                "2014",
                "2014",
                "2014",
                "2015",
                "2015",
                "2015",
                "2015",
                "2016",
                "2016",
                "2016",
                "2016",
                "2017",
                "2017",
                "2017",
                "2017",
                "2018",
                "2018",
                "2018",
                "2018",
                "2019"
            ]
        },
        "Bower_women-bar": {
            "data": [
                {
                    "color": "#D13916",
                    "data": [
                        1,
                        3,
                        3,
                        4,
                        5,
                        9,
                        5,
                        5,
                        6,
                        16,
                        22,
                        24,
                        33,
                        39,
                        58,
                        65,
                        73,
                        106,
                        111,
                        129,
                        202,
                        205,
                        289,
                        309,
                        379,
                        466,
                        512,
                        531,
                        646,
                        685,
                        726,
                        713,
                        771,
                        766,
                        716,
                        719,
                        731,
                        741,
                        667,
                        680,
                        620,
                        617,
                        571,
                        570,
                        524
                    ],
                    "name": "Women",
                    "type": "column",
                    "yAxis": 1
                }
            ],
            "height_ratio": 66.66666666666666,
            "label_x": "",
            "label_y": "",
            "label_y_secondary": "",
            "title": "",
            "x_categories": [
                "2008",
                "2008",
                "2008",
                "2008",
                "2009",
                "2009",
                "2009",
                "2009",
                "2010",
                "2010",
                "2010",
                "2010",
                "2011",
                "2011",
                "2011",
                "2011",
                "2012",
                "2012",
                "2012",
                "2012",
                "2013",
                "2013",
                "2013",
                "2013",
                "2014",
                "2014",
                "2014",
                "2014",
                "2015",
                "2015",
                "2015",
                "2015",
                "2016",
                "2016",
                "2016",
                "2016",
                "2017",
                "2017",
                "2017",
                "2017",
                "2018",
                "2018",
                "2018",
                "2018",
                "2019"
            ]
        },
        "CPAN": {
            "data": [
                {
                    "color": "blanchedalmond",
                    "data": [
                        0.096,
                        0.131,
                        0.143,
                        0.15,
                        0.175,
                        0.191,
                        0.224,
                        0.213,
                        0.26,
                        0.27,
                        0.285,
                        0.316,
                        0.373,
                        0.381,
                        0.401,
                        0.443,
                        0.5,
                        0.484,
                        0.491,
                        0.521,
                        0.626,
                        0.716,
                        0.754,
                        0.663,
                        0.766,
                        0.741,
                        0.784,
                        0.777,
                        0.945,
                        0.781,
                        0.762,
                        0.768,
                        0.756,
                        0.721,
                        0.732,
                        0.713,
                        0.72,
                        0.66,
                        0.658,
                        0.621,
                        0.622,
                        0.619,
                        0.555,
                        0.58,
                        0.504
                    ],
                    "name": "All Unknown",
                    "type": "column"
                },
                {
                    "color": "#f29d4b",
                    "data": [
                        0.067,
                        0.103,
                        0.096,
                        0.109,
                        0.126,
                        0.138,
                        0.16,
                        0.169,
                        0.202,
                        0.211,
                        0.232,
                        0.255,
                        0.3,
                        0.32,
                        0.33,
                        0.362,
                        0.415,
                        0.391,
                        0.398,
                        0.428,
                        0.497,
                        0.578,
                        0.598,
                        0.523,
                        0.611,
                        0.59,
                        0.616,
                        0.611,
                        0.741,
                        0.623,
                        0.609,
                        0.61,
                        0.609,
                        0.585,
                        0.593,
                        0.574,
                        0.568,
                        0.518,
                        0.522,
                        0.481,
                        0.493,
                        0.494,
                        0.439,
                        0.46,
                        0.399
                    ],
                    "name": "All Men",
                    "type": "column"
                },
                {
                    "color": "#de2d26",
                    "data": [
                        0.004,
                        0.003,
                        0.004,
                        0.003,
                        0.004,
                        0.004,
                        0.007,
                        0.009,
                        0.007,
                        0.006,
                        0.01,
                        0.01,
                        0.017,
                        0.012,
                        0.014,
                        0.019,
                        0.017,
                        0.017,
                        0.012,
                        0.016,
                        0.019,
                        0.024,
                        0.026,
                        0.023,
                        0.024,
                        0.024,
                        0.022,
                        0.021,
                        0.024,
                        0.025,
                        0.02,
                        0.02,
                        0.021,
                        0.022,
                        0.025,
                        0.021,
                        0.022,
                        0.019,
                        0.014,
                        0.015,
                        0.018,
                        0.021,
                        0.015,
                        0.014,
                        0.012
                    ],
                    "name": "All Women",
                    "type": "column"
                },
                {
                    "color": "darkblue",
                    "data": [
                        5.97,
                        2.91,
                        4.17,
                        2.75,
                        3.17,
                        2.9,
                        4.38,
                        5.33,
                        3.47,
                        2.84,
                        4.31,
                        3.92,
                        5.67,
                        3.75,
                        4.24,
                        5.25,
                        4.1,
                        4.35,
                        3.02,
                        3.74,
                        3.82,
                        4.15,
                        4.35,
                        4.4,
                        3.93,
                        4.07,
                        3.57,
                        3.44,
                        3.24,
                        4.01,
                        3.28,
                        3.28,
                        3.45,
                        3.76,
                        4.22,
                        3.66,
                        3.87,
                        3.67,
                        2.68,
                        3.12,
                        3.65,
                        4.25,
                        3.42,
                        3.04,
                        3.01
                    ],
                    "name": "Among all",
                    "type": "spline",
                    "yAxis": 1
                },
                {
                    "color": "darkblue",
                    "data": [
                        3.92,
                        3.57,
                        3.9,
                        4.35,
                        1.83,
                        2.73,
                        5.22,
                        4.17,
                        3.43,
                        3.39,
                        5.45,
                        3.69,
                        5.44,
                        3.69,
                        3.27,
                        3.62,
                        3.13,
                        3.91,
                        3.15,
                        2.7,
                        3.39,
                        3.33,
                        3.81,
                        4.27,
                        3.61,
                        4.75,
                        3.25,
                        3.28,
                        3.89,
                        4.02,
                        3.39,
                        3.64,
                        3.37,
                        3.72,
                        3.25,
                        3.29,
                        4.08,
                        3.6,
                        2.69,
                        3.24,
                        3.43,
                        4.35,
                        3.95,
                        2.63,
                        2.9
                    ],
                    "marker": {
                        "fillColor": "#FFFFFF",
                        "lineColor": "darkblue",
                        "lineWidth": 2,
                        "radius": 5
                    },
                    "name": "Among core",
                    "type": "spline",
                    "yAxis": 1
                }
            ],
            "height_ratio": 69.23076923076923,
            "label_x": "Time (quarter)",
            "label_y": "Number of Contributors (thousand)",
            "label_y_secondary": "% Women (of total m + w)",
            "title": "Active Contributors in CPAN Public Projects",
            "x_categories": [
                "2008-3",
                "2008-6",
                "2008-9",
                "2008-12",
                "2009-3",
                "2009-6",
                "2009-9",
                "2009-12",
                "2010-3",
                "2010-6",
                "2010-9",
                "2010-12",
                "2011-3",
                "2011-6",
                "2011-9",
                "2011-12",
                "2012-3",
                "2012-6",
                "2012-9",
                "2012-12",
                "2013-3",
                "2013-6",
                "2013-9",
                "2013-12",
                "2014-3",
                "2014-6",
                "2014-9",
                "2014-12",
                "2015-3",
                "2015-6",
                "2015-9",
                "2015-12",
                "2016-3",
                "2016-6",
                "2016-9",
                "2016-12",
                "2017-3",
                "2017-6",
                "2017-9",
                "2017-12",
                "2018-3",
                "2018-6",
                "2018-9",
                "2018-12",
                "2019-3"
            ]
        },
        "CPAN_line": {
            "data": [
                {
                    "color": "#131313",
                    "data": [
                        5.97,
                        2.91,
                        4.17,
                        2.75,
                        3.17,
                        2.9,
                        4.38,
                        5.33,
                        3.47,
                        2.84,
                        4.31,
                        3.92,
                        5.67,
                        3.75,
                        4.24,
                        5.25,
                        4.1,
                        4.35,
                        3.02,
                        3.74,
                        3.82,
                        4.15,
                        4.35,
                        4.4,
                        3.93,
                        4.07,
                        3.57,
                        3.44,
                        3.24,
                        4.01,
                        3.28,
                        3.28,
                        3.45,
                        3.76,
                        4.22,
                        3.66,
                        3.87,
                        3.67,
                        2.68,
                        3.12,
                        3.65,
                        4.25,
                        3.42,
                        3.04,
                        3.01
                    ],
                    "name": "Among all",
                    "type": "spline",
                    "yAxis": 1
                }
            ],
            "height_ratio": 66.66666666666666,
            "label_x": "",
            "label_y": "",
            "label_y_secondary": "",
            "title": "",
            "x_categories": [
                "2008",
                "2008",
                "2008",
                "2008",
                "2009",
                "2009",
                "2009",
                "2009",
                "2010",
                "2010",
                "2010",
                "2010",
                "2011",
                "2011",
                "2011",
                "2011",
                "2012",
                "2012",
                "2012",
                "2012",
                "2013",
                "2013",
                "2013",
                "2013",
                "2014",
                "2014",
                "2014",
                "2014",
                "2015",
                "2015",
                "2015",
                "2015",
                "2016",
                "2016",
                "2016",
                "2016",
                "2017",
                "2017",
                "2017",
                "2017",
                "2018",
                "2018",
                "2018",
                "2018",
                "2019"
            ]
        },
        "CPAN_women-bar": {
            "data": [
                {
                    "color": "#131313",
                    "data": [
                        4,
                        3,
                        4,
                        3,
                        4,
                        4,
                        7,
                        9,
                        7,
                        6,
                        10,
                        10,
                        17,
                        12,
                        14,
                        19,
                        17,
                        17,
                        12,
                        16,
                        19,
                        24,
                        26,
                        23,
                        24,
                        24,
                        22,
                        21,
                        24,
                        25,
                        20,
                        20,
                        21,
                        22,
                        25,
                        21,
                        22,
                        19,
                        14,
                        15,
                        18,
                        21,
                        15,
                        14,
                        12
                    ],
                    "name": "Women",
                    "type": "column",
                    "yAxis": 1
                }
            ],
            "height_ratio": 66.66666666666666,
            "label_x": "",
            "label_y": "",
            "label_y_secondary": "",
            "title": "",
            "x_categories": [
                "2008",
                "2008",
                "2008",
                "2008",
                "2009",
                "2009",
                "2009",
                "2009",
                "2010",
                "2010",
                "2010",
                "2010",
                "2011",
                "2011",
                "2011",
                "2011",
                "2012",
                "2012",
                "2012",
                "2012",
                "2013",
                "2013",
                "2013",
                "2013",
                "2014",
                "2014",
                "2014",
                "2014",
                "2015",
                "2015",
                "2015",
                "2015",
                "2016",
                "2016",
                "2016",
                "2016",
                "2017",
                "2017",
                "2017",
                "2017",
                "2018",
                "2018",
                "2018",
                "2018",
                "2019"
            ]
        },
        "CRAN": {
            "data": [
                {
                    "color": "blanchedalmond",
                    "data": [
                        0.023,
                        0.019,
                        0.019,
                        0.028,
                        0.025,
                        0.032,
                        0.033,
                        0.038,
                        0.038,
                        0.054,
                        0.053,
                        0.067,
                        0.053,
                        0.06,
                        0.077,
                        0.099,
                        0.119,
                        0.139,
                        0.177,
                        0.159,
                        0.248,
                        0.293,
                        0.351,
                        0.396,
                        0.513,
                        0.592,
                        0.718,
                        0.751,
                        0.966,
                        1.088,
                        1.118,
                        1.14,
                        1.323,
                        1.445,
                        1.543,
                        1.658,
                        1.804,
                        2.013,
                        2.058,
                        2.096,
                        2.316,
                        2.423,
                        2.426,
                        2.409,
                        2.545
                    ],
                    "name": "All Unknown",
                    "type": "column"
                },
                {
                    "color": "#f29d4b",
                    "data": [
                        0.011,
                        0.013,
                        0.012,
                        0.015,
                        0.016,
                        0.022,
                        0.021,
                        0.025,
                        0.027,
                        0.038,
                        0.038,
                        0.046,
                        0.039,
                        0.043,
                        0.056,
                        0.07,
                        0.094,
                        0.112,
                        0.143,
                        0.125,
                        0.193,
                        0.219,
                        0.263,
                        0.297,
                        0.397,
                        0.451,
                        0.528,
                        0.568,
                        0.739,
                        0.835,
                        0.858,
                        0.859,
                        1.013,
                        1.106,
                        1.166,
                        1.234,
                        1.383,
                        1.522,
                        1.549,
                        1.568,
                        1.722,
                        1.823,
                        1.776,
                        1.757,
                        1.817
                    ],
                    "name": "All Men",
                    "type": "column"
                },
                {
                    "color": "#de2d26",
                    "data": [
                        0.0,
                        0.0,
                        0.0,
                        0.0,
                        0.0,
                        0.0,
                        0.0,
                        0.0,
                        0.0,
                        0.0,
                        0.0,
                        0.0,
                        0.001,
                        0.001,
                        0.001,
                        0.002,
                        0.003,
                        0.006,
                        0.006,
                        0.005,
                        0.009,
                        0.008,
                        0.011,
                        0.013,
                        0.018,
                        0.022,
                        0.031,
                        0.035,
                        0.04,
                        0.047,
                        0.048,
                        0.044,
                        0.049,
                        0.065,
                        0.067,
                        0.075,
                        0.091,
                        0.115,
                        0.123,
                        0.121,
                        0.136,
                        0.165,
                        0.165,
                        0.161,
                        0.177
                    ],
                    "name": "All Women",
                    "type": "column"
                },
                {
                    "color": "darkblue",
                    "data": [
                        0.0,
                        0.0,
                        0.0,
                        0.0,
                        0.0,
                        0.0,
                        0.0,
                        0.0,
                        0.0,
                        0.0,
                        0.0,
                        0.0,
                        2.56,
                        2.33,
                        1.79,
                        2.86,
                        3.19,
                        5.36,
                        4.2,
                        4.0,
                        4.66,
                        3.65,
                        4.18,
                        4.38,
                        4.53,
                        4.88,
                        5.87,
                        6.16,
                        5.41,
                        5.63,
                        5.59,
                        5.12,
                        4.84,
                        5.88,
                        5.75,
                        6.08,
                        6.58,
                        7.56,
                        7.94,
                        7.72,
                        7.9,
                        9.05,
                        9.29,
                        9.16,
                        9.74
                    ],
                    "name": "Among all",
                    "type": "spline",
                    "yAxis": 1
                },
                {
                    "color": "darkblue",
                    "data": [
                        0.0,
                        0.0,
                        0.0,
                        0.0,
                        0.0,
                        0.0,
                        0.0,
                        0.0,
                        0.0,
                        0.0,
                        0.0,
                        0.0,
                        4.17,
                        3.7,
                        2.94,
                        2.63,
                        3.92,
                        7.27,
                        2.7,
                        3.28,
                        4.9,
                        3.54,
                        1.65,
                        3.36,
                        4.27,
                        3.75,
                        5.94,
                        6.85,
                        4.59,
                        4.82,
                        5.15,
                        3.85,
                        4.33,
                        5.64,
                        5.57,
                        5.58,
                        7.44,
                        8.16,
                        6.76,
                        7.68,
                        7.58,
                        8.06,
                        9.79,
                        8.29,
                        8.99
                    ],
                    "marker": {
                        "fillColor": "#FFFFFF",
                        "lineColor": "darkblue",
                        "lineWidth": 2,
                        "radius": 5
                    },
                    "name": "Among core",
                    "type": "spline",
                    "yAxis": 1
                }
            ],
            "height_ratio": 69.23076923076923,
            "label_x": "Time (quarter)",
            "label_y": "Number of Contributors (thousand)",
            "label_y_secondary": "% Women (of total m + w)",
            "title": "Active Contributors in CRAN Public Projects",
            "x_categories": [
                "2008-3",
                "2008-6",
                "2008-9",
                "2008-12",
                "2009-3",
                "2009-6",
                "2009-9",
                "2009-12",
                "2010-3",
                "2010-6",
                "2010-9",
                "2010-12",
                "2011-3",
                "2011-6",
                "2011-9",
                "2011-12",
                "2012-3",
                "2012-6",
                "2012-9",
                "2012-12",
                "2013-3",
                "2013-6",
                "2013-9",
                "2013-12",
                "2014-3",
                "2014-6",
                "2014-9",
                "2014-12",
                "2015-3",
                "2015-6",
                "2015-9",
                "2015-12",
                "2016-3",
                "2016-6",
                "2016-9",
                "2016-12",
                "2017-3",
                "2017-6",
                "2017-9",
                "2017-12",
                "2018-3",
                "2018-6",
                "2018-9",
                "2018-12",
                "2019-3"
            ]
        },
        "CRAN_line": {
            "data": [
                {
                    "color": "#2167BA",
                    "data": [
                        0.0,
                        0.0,
                        0.0,
                        0.0,
                        0.0,
                        0.0,
                        0.0,
                        0.0,
                        0.0,
                        0.0,
                        0.0,
                        0.0,
                        2.56,
                        2.33,
                        1.79,
                        2.86,
                        3.19,
                        5.36,
                        4.2,
                        4.0,
                        4.66,
                        3.65,
                        4.18,
                        4.38,
                        4.53,
                        4.88,
                        5.87,
                        6.16,
                        5.41,
                        5.63,
                        5.59,
                        5.12,
                        4.84,
                        5.88,
                        5.75,
                        6.08,
                        6.58,
                        7.56,
                        7.94,
                        7.72,
                        7.9,
                        9.05,
                        9.29,
                        9.16,
                        9.74
                    ],
                    "name": "Among all",
                    "type": "spline",
                    "yAxis": 1
                }
            ],
            "height_ratio": 66.66666666666666,
            "label_x": "",
            "label_y": "",
            "label_y_secondary": "",
            "title": "",
            "x_categories": [
                "2008",
                "2008",
                "2008",
                "2008",
                "2009",
                "2009",
                "2009",
                "2009",
                "2010",
                "2010",
                "2010",
                "2010",
                "2011",
                "2011",
                "2011",
                "2011",
                "2012",
                "2012",
                "2012",
                "2012",
                "2013",
                "2013",
                "2013",
                "2013",
                "2014",
                "2014",
                "2014",
                "2014",
                "2015",
                "2015",
                "2015",
                "2015",
                "2016",
                "2016",
                "2016",
                "2016",
                "2017",
                "2017",
                "2017",
                "2017",
                "2018",
                "2018",
                "2018",
                "2018",
                "2019"
            ]
        },
        "CRAN_women-bar": {
            "data": [
                {
                    "color": "#2167BA",
                    "data": [
                        0,
                        0,
                        0,
                        0,
                        0,
                        0,
                        0,
                        0,
                        0,
                        0,
                        0,
                        0,
                        1,
                        1,
                        1,
                        2,
                        3,
                        6,
                        6,
                        5,
                        9,
                        8,
                        11,
                        13,
                        18,
                        22,
                        31,
                        35,
                        40,
                        47,
                        48,
                        44,
                        49,
                        65,
                        67,
                        75,
                        91,
                        115,
                        123,
                        121,
                        136,
                        165,
                        165,
                        161,
                        177
                    ],
                    "name": "Women",
                    "type": "column",
                    "yAxis": 1
                }
            ],
            "height_ratio": 66.66666666666666,
            "label_x": "",
            "label_y": "",
            "label_y_secondary": "",
            "title": "",
            "x_categories": [
                "2008",
                "2008",
                "2008",
                "2008",
                "2009",
                "2009",
                "2009",
                "2009",
                "2010",
                "2010",
                "2010",
                "2010",
                "2011",
                "2011",
                "2011",
                "2011",
                "2012",
                "2012",
                "2012",
                "2012",
                "2013",
                "2013",
                "2013",
                "2013",
                "2014",
                "2014",
                "2014",
                "2014",
                "2015",
                "2015",
                "2015",
                "2015",
                "2016",
                "2016",
                "2016",
                "2016",
                "2017",
                "2017",
                "2017",
                "2017",
                "2018",
                "2018",
                "2018",
                "2018",
                "2019"
            ]
        },
        "Cargo": {
            "data": [
                {
                    "color": "blanchedalmond",
                    "data": [
                        0.0,
                        0.0,
                        0.0,
                        0.001,
                        0.004,
                        0.004,
                        0.004,
                        0.006,
                        0.006,
                        0.006,
                        0.007,
                        0.01,
                        0.017,
                        0.021,
                        0.017,
                        0.015,
                        0.029,
                        0.035,
                        0.054,
                        0.052,
                        0.048,
                        0.055,
                        0.1,
                        0.125,
                        0.154,
                        0.294,
                        0.486,
                        0.789,
                        1.038,
                        1.222,
                        1.246,
                        1.319,
                        1.643,
                        1.78,
                        1.969,
                        2.197,
                        2.708,
                        2.941,
                        3.14,
                        3.474,
                        3.972,
                        4.302,
                        4.73,
                        5.436,
                        5.949
                    ],
                    "name": "All Unknown",
                    "type": "column"
                },
                {
                    "color": "#f29d4b",
                    "data": [
                        0.0,
                        0.0,
                        0.0,
                        0.0,
                        0.0,
                        0.0,
                        0.0,
                        0.002,
                        0.001,
                        0.002,
                        0.001,
                        0.002,
                        0.004,
                        0.002,
                        0.003,
                        0.002,
                        0.011,
                        0.013,
                        0.021,
                        0.034,
                        0.039,
                        0.045,
                        0.079,
                        0.1,
                        0.126,
                        0.234,
                        0.386,
                        0.622,
                        0.798,
                        0.938,
                        0.979,
                        1.033,
                        1.268,
                        1.353,
                        1.548,
                        1.696,
                        2.1,
                        2.269,
                        2.397,
                        2.667,
                        3.035,
                        3.258,
                        3.535,
                        4.035,
                        4.331
                    ],
                    "name": "All Men",
                    "type": "column"
                },
                {
                    "color": "#de2d26",
                    "data": [
                        0.0,
                        0.0,
                        0.0,
                        0.0,
                        0.0,
                        0.0,
                        0.0,
                        0.0,
                        0.0,
                        0.0,
                        0.0,
                        0.0,
                        0.0,
                        0.0,
                        0.0,
                        0.0,
                        0.0,
                        0.001,
                        0.0,
                        0.0,
                        0.0,
                        0.0,
                        0.002,
                        0.003,
                        0.006,
                        0.01,
                        0.012,
                        0.021,
                        0.019,
                        0.031,
                        0.032,
                        0.035,
                        0.041,
                        0.032,
                        0.041,
                        0.047,
                        0.051,
                        0.073,
                        0.095,
                        0.095,
                        0.103,
                        0.126,
                        0.138,
                        0.137,
                        0.18
                    ],
                    "name": "All Women",
                    "type": "column"
                },
                {
                    "color": "darkblue",
                    "data": [
                        0.0,
                        0.0,
                        0.0,
                        0.0,
                        0.0,
                        0.0,
                        0.0,
                        0.0,
                        0.0,
                        0.0,
                        0.0,
                        0.0,
                        0.0,
                        0.0,
                        0.0,
                        0.0,
                        0.0,
                        7.69,
                        0.0,
                        0.0,
                        0.0,
                        0.0,
                        2.53,
                        3.0,
                        4.76,
                        4.27,
                        3.11,
                        3.38,
                        2.38,
                        3.3,
                        3.27,
                        3.39,
                        3.23,
                        2.37,
                        2.65,
                        2.77,
                        2.43,
                        3.22,
                        3.96,
                        3.56,
                        3.39,
                        3.87,
                        3.9,
                        3.4,
                        4.16
                    ],
                    "name": "Among all",
                    "type": "spline",
                    "yAxis": 1
                },
                {
                    "color": "darkblue",
                    "data": [
                        0.0,
                        0.0,
                        0.0,
                        0.0,
                        0.0,
                        0.0,
                        0.0,
                        0.0,
                        0.0,
                        0.0,
                        0.0,
                        0.0,
                        0.0,
                        0.0,
                        0.0,
                        0.0,
                        0.0,
                        7.69,
                        0.0,
                        0.0,
                        0.0,
                        0.0,
                        2.82,
                        3.26,
                        4.31,
                        4.37,
                        3.31,
                        3.75,
                        2.08,
                        3.2,
                        2.96,
                        3.36,
                        2.88,
                        2.38,
                        2.41,
                        2.54,
                        2.27,
                        3.49,
                        4.19,
                        3.36,
                        3.17,
                        3.98,
                        4.13,
                        3.7,
                        4.14
                    ],
                    "marker": {
                        "fillColor": "#FFFFFF",
                        "lineColor": "darkblue",
                        "lineWidth": 2,
                        "radius": 5
                    },
                    "name": "Among core",
                    "type": "spline",
                    "yAxis": 1
                }
            ],
            "height_ratio": 69.23076923076923,
            "label_x": "Time (quarter)",
            "label_y": "Number of Contributors (thousand)",
            "label_y_secondary": "% Women (of total m + w)",
            "title": "Active Contributors in Cargo Public Projects",
            "x_categories": [
                "2008-3",
                "2008-6",
                "2008-9",
                "2008-12",
                "2009-3",
                "2009-6",
                "2009-9",
                "2009-12",
                "2010-3",
                "2010-6",
                "2010-9",
                "2010-12",
                "2011-3",
                "2011-6",
                "2011-9",
                "2011-12",
                "2012-3",
                "2012-6",
                "2012-9",
                "2012-12",
                "2013-3",
                "2013-6",
                "2013-9",
                "2013-12",
                "2014-3",
                "2014-6",
                "2014-9",
                "2014-12",
                "2015-3",
                "2015-6",
                "2015-9",
                "2015-12",
                "2016-3",
                "2016-6",
                "2016-9",
                "2016-12",
                "2017-3",
                "2017-6",
                "2017-9",
                "2017-12",
                "2018-3",
                "2018-6",
                "2018-9",
                "2018-12",
                "2019-3"
            ]
        },
        "Cargo_line": {
            "data": [
                {
                    "color": "#765229",
                    "data": [
                        NaN,
                        NaN,
                        NaN,
                        0.0,
                        0.0,
                        0.0,
                        0.0,
                        0.0,
                        0.0,
                        0.0,
                        0.0,
                        0.0,
                        0.0,
                        0.0,
                        0.0,
                        0.0,
                        0.0,
                        7.69,
                        0.0,
                        0.0,
                        0.0,
                        0.0,
                        2.53,
                        3.0,
                        4.76,
                        4.27,
                        3.11,
                        3.38,
                        2.38,
                        3.3,
                        3.27,
                        3.39,
                        3.23,
                        2.37,
                        2.65,
                        2.77,
                        2.43,
                        3.22,
                        3.96,
                        3.56,
                        3.39,
                        3.87,
                        3.9,
                        3.4,
                        4.16
                    ],
                    "name": "Among all",
                    "type": "spline",
                    "yAxis": 1
                }
            ],
            "height_ratio": 66.66666666666666,
            "label_x": "",
            "label_y": "",
            "label_y_secondary": "",
            "title": "",
            "x_categories": [
                "2008",
                "2008",
                "2008",
                "2008",
                "2009",
                "2009",
                "2009",
                "2009",
                "2010",
                "2010",
                "2010",
                "2010",
                "2011",
                "2011",
                "2011",
                "2011",
                "2012",
                "2012",
                "2012",
                "2012",
                "2013",
                "2013",
                "2013",
                "2013",
                "2014",
                "2014",
                "2014",
                "2014",
                "2015",
                "2015",
                "2015",
                "2015",
                "2016",
                "2016",
                "2016",
                "2016",
                "2017",
                "2017",
                "2017",
                "2017",
                "2018",
                "2018",
                "2018",
                "2018",
                "2019"
            ]
        },
        "Cargo_women-bar": {
            "data": [
                {
                    "color": "#765229",
                    "data": [
                        0,
                        0,
                        0,
                        0,
                        0,
                        0,
                        0,
                        0,
                        0,
                        0,
                        0,
                        0,
                        0,
                        0,
                        0,
                        0,
                        0,
                        1,
                        0,
                        0,
                        0,
                        0,
                        2,
                        3,
                        6,
                        10,
                        12,
                        21,
                        19,
                        31,
                        32,
                        35,
                        41,
                        32,
                        41,
                        47,
                        51,
                        73,
                        95,
                        95,
                        103,
                        126,
                        138,
                        137,
                        180
                    ],
                    "name": "Women",
                    "type": "column",
                    "yAxis": 1
                }
            ],
            "height_ratio": 66.66666666666666,
            "label_x": "",
            "label_y": "",
            "label_y_secondary": "",
            "title": "",
            "x_categories": [
                "2008",
                "2008",
                "2008",
                "2008",
                "2009",
                "2009",
                "2009",
                "2009",
                "2010",
                "2010",
                "2010",
                "2010",
                "2011",
                "2011",
                "2011",
                "2011",
                "2012",
                "2012",
                "2012",
                "2012",
                "2013",
                "2013",
                "2013",
                "2013",
                "2014",
                "2014",
                "2014",
                "2014",
                "2015",
                "2015",
                "2015",
                "2015",
                "2016",
                "2016",
                "2016",
                "2016",
                "2017",
                "2017",
                "2017",
                "2017",
                "2018",
                "2018",
                "2018",
                "2018",
                "2019"
            ]
        },
        "Clojars": {
            "data": [
                {
                    "color": "blanchedalmond",
                    "data": [
                        0.018,
                        0.02,
                        0.03,
                        0.036,
                        0.046,
                        0.077,
                        0.103,
                        0.173,
                        0.257,
                        0.278,
                        0.363,
                        0.416,
                        0.468,
                        0.508,
                        0.622,
                        0.757,
                        0.965,
                        1.047,
                        1.158,
                        1.242,
                        1.541,
                        1.569,
                        1.751,
                        1.962,
                        2.152,
                        2.242,
                        2.372,
                        2.555,
                        2.826,
                        2.804,
                        3.052,
                        3.109,
                        3.253,
                        3.235,
                        3.176,
                        3.156,
                        3.465,
                        3.303,
                        3.364,
                        3.181,
                        3.069,
                        2.961,
                        2.851,
                        2.92,
                        2.699
                    ],
                    "name": "All Unknown",
                    "type": "column"
                },
                {
                    "color": "#f29d4b",
                    "data": [
                        0.009,
                        0.009,
                        0.018,
                        0.025,
                        0.032,
                        0.059,
                        0.079,
                        0.146,
                        0.214,
                        0.233,
                        0.309,
                        0.352,
                        0.395,
                        0.43,
                        0.52,
                        0.623,
                        0.792,
                        0.863,
                        0.937,
                        1.014,
                        1.221,
                        1.244,
                        1.359,
                        1.557,
                        1.718,
                        1.782,
                        1.879,
                        2.017,
                        2.251,
                        2.228,
                        2.442,
                        2.467,
                        2.561,
                        2.478,
                        2.501,
                        2.457,
                        2.708,
                        2.558,
                        2.54,
                        2.408,
                        2.338,
                        2.23,
                        2.096,
                        2.11,
                        1.976
                    ],
                    "name": "All Men",
                    "type": "column"
                },
                {
                    "color": "#de2d26",
                    "data": [
                        0.0,
                        0.0,
                        0.0,
                        0.0,
                        0.001,
                        0.001,
                        0.001,
                        0.004,
                        0.007,
                        0.006,
                        0.01,
                        0.006,
                        0.009,
                        0.007,
                        0.011,
                        0.011,
                        0.013,
                        0.015,
                        0.019,
                        0.018,
                        0.033,
                        0.032,
                        0.029,
                        0.033,
                        0.036,
                        0.035,
                        0.045,
                        0.042,
                        0.052,
                        0.047,
                        0.057,
                        0.057,
                        0.071,
                        0.075,
                        0.08,
                        0.076,
                        0.085,
                        0.095,
                        0.094,
                        0.082,
                        0.086,
                        0.082,
                        0.091,
                        0.083,
                        0.085
                    ],
                    "name": "All Women",
                    "type": "column"
                },
                {
                    "color": "darkblue",
                    "data": [
                        0.0,
                        0.0,
                        0.0,
                        0.0,
                        3.12,
                        1.69,
                        1.27,
                        2.74,
                        3.27,
                        2.58,
                        3.24,
                        1.7,
                        2.28,
                        1.63,
                        2.12,
                        1.77,
                        1.64,
                        1.74,
                        2.03,
                        1.78,
                        2.7,
                        2.57,
                        2.13,
                        2.12,
                        2.1,
                        1.96,
                        2.39,
                        2.08,
                        2.31,
                        2.11,
                        2.33,
                        2.31,
                        2.77,
                        3.03,
                        3.2,
                        3.09,
                        3.14,
                        3.71,
                        3.7,
                        3.41,
                        3.68,
                        3.68,
                        4.34,
                        3.93,
                        4.3
                    ],
                    "name": "Among all",
                    "type": "spline",
                    "yAxis": 1
                },
                {
                    "color": "darkblue",
                    "data": [
                        0.0,
                        0.0,
                        0.0,
                        0.0,
                        3.33,
                        1.72,
                        1.32,
                        2.82,
                        3.38,
                        2.28,
                        2.82,
                        1.85,
                        2.49,
                        1.75,
                        2.1,
                        1.81,
                        1.78,
                        1.89,
                        1.73,
                        1.85,
                        2.83,
                        2.4,
                        2.42,
                        2.13,
                        1.97,
                        2.1,
                        2.6,
                        1.99,
                        2.32,
                        2.2,
                        2.62,
                        2.48,
                        3.09,
                        3.24,
                        3.51,
                        3.12,
                        3.34,
                        4.05,
                        4.0,
                        3.56,
                        3.74,
                        3.82,
                        4.71,
                        4.03,
                        4.55
                    ],
                    "marker": {
                        "fillColor": "#FFFFFF",
                        "lineColor": "darkblue",
                        "lineWidth": 2,
                        "radius": 5
                    },
                    "name": "Among core",
                    "type": "spline",
                    "yAxis": 1
                }
            ],
            "height_ratio": 69.23076923076923,
            "label_x": "Time (quarter)",
            "label_y": "Number of Contributors (thousand)",
            "label_y_secondary": "% Women (of total m + w)",
            "title": "Active Contributors in Clojars Public Projects",
            "x_categories": [
                "2008-3",
                "2008-6",
                "2008-9",
                "2008-12",
                "2009-3",
                "2009-6",
                "2009-9",
                "2009-12",
                "2010-3",
                "2010-6",
                "2010-9",
                "2010-12",
                "2011-3",
                "2011-6",
                "2011-9",
                "2011-12",
                "2012-3",
                "2012-6",
                "2012-9",
                "2012-12",
                "2013-3",
                "2013-6",
                "2013-9",
                "2013-12",
                "2014-3",
                "2014-6",
                "2014-9",
                "2014-12",
                "2015-3",
                "2015-6",
                "2015-9",
                "2015-12",
                "2016-3",
                "2016-6",
                "2016-9",
                "2016-12",
                "2017-3",
                "2017-6",
                "2017-9",
                "2017-12",
                "2018-3",
                "2018-6",
                "2018-9",
                "2018-12",
                "2019-3"
            ]
        },
        "Clojars_line": {
            "data": [
                {
                    "color": "#341133",
                    "data": [
                        0.0,
                        0.0,
                        0.0,
                        0.0,
                        3.12,
                        1.69,
                        1.27,
                        2.74,
                        3.27,
                        2.58,
                        3.24,
                        1.7,
                        2.28,
                        1.63,
                        2.12,
                        1.77,
                        1.64,
                        1.74,
                        2.03,
                        1.78,
                        2.7,
                        2.57,
                        2.13,
                        2.12,
                        2.1,
                        1.96,
                        2.39,
                        2.08,
                        2.31,
                        2.11,
                        2.33,
                        2.31,
                        2.77,
                        3.03,
                        3.2,
                        3.09,
                        3.14,
                        3.71,
                        3.7,
                        3.41,
                        3.68,
                        3.68,
                        4.34,
                        3.93,
                        4.3
                    ],
                    "name": "Among all",
                    "type": "spline",
                    "yAxis": 1
                }
            ],
            "height_ratio": 66.66666666666666,
            "label_x": "",
            "label_y": "",
            "label_y_secondary": "",
            "title": "",
            "x_categories": [
                "2008",
                "2008",
                "2008",
                "2008",
                "2009",
                "2009",
                "2009",
                "2009",
                "2010",
                "2010",
                "2010",
                "2010",
                "2011",
                "2011",
                "2011",
                "2011",
                "2012",
                "2012",
                "2012",
                "2012",
                "2013",
                "2013",
                "2013",
                "2013",
                "2014",
                "2014",
                "2014",
                "2014",
                "2015",
                "2015",
                "2015",
                "2015",
                "2016",
                "2016",
                "2016",
                "2016",
                "2017",
                "2017",
                "2017",
                "2017",
                "2018",
                "2018",
                "2018",
                "2018",
                "2019"
            ]
        },
        "Clojars_women-bar": {
            "data": [
                {
                    "color": "#341133",
                    "data": [
                        0,
                        0,
                        0,
                        0,
                        1,
                        1,
                        1,
                        4,
                        7,
                        6,
                        10,
                        6,
                        9,
                        7,
                        11,
                        11,
                        13,
                        15,
                        19,
                        18,
                        33,
                        32,
                        29,
                        33,
                        36,
                        35,
                        45,
                        42,
                        52,
                        47,
                        57,
                        57,
                        71,
                        75,
                        80,
                        76,
                        85,
                        95,
                        94,
                        82,
                        86,
                        82,
                        91,
                        83,
                        85
                    ],
                    "name": "Women",
                    "type": "column",
                    "yAxis": 1
                }
            ],
            "height_ratio": 66.66666666666666,
            "label_x": "",
            "label_y": "",
            "label_y_secondary": "",
            "title": "",
            "x_categories": [
                "2008",
                "2008",
                "2008",
                "2008",
                "2009",
                "2009",
                "2009",
                "2009",
                "2010",
                "2010",
                "2010",
                "2010",
                "2011",
                "2011",
                "2011",
                "2011",
                "2012",
                "2012",
                "2012",
                "2012",
                "2013",
                "2013",
                "2013",
                "2013",
                "2014",
                "2014",
                "2014",
                "2014",
                "2015",
                "2015",
                "2015",
                "2015",
                "2016",
                "2016",
                "2016",
                "2016",
                "2017",
                "2017",
                "2017",
                "2017",
                "2018",
                "2018",
                "2018",
                "2018",
                "2019"
            ]
        },
        "CocoaPods": {
            "data": [
                {
                    "color": "blanchedalmond",
                    "data": [
                        0.012,
                        0.017,
                        0.03,
                        0.052,
                        0.057,
                        0.076,
                        0.093,
                        0.118,
                        0.134,
                        0.173,
                        0.257,
                        0.335,
                        0.471,
                        0.671,
                        0.867,
                        1.025,
                        1.407,
                        1.68,
                        2.328,
                        2.45,
                        3.178,
                        3.457,
                        4.072,
                        4.765,
                        5.395,
                        5.693,
                        6.176,
                        6.411,
                        7.507,
                        8.499,
                        9.312,
                        10.125,
                        11.06,
                        11.613,
                        12.534,
                        12.506,
                        12.573,
                        12.81,
                        13.128,
                        13.552,
                        12.521,
                        12.716,
                        12.985,
                        12.943,
                        12.014
                    ],
                    "name": "All Unknown",
                    "type": "column"
                },
                {
                    "color": "#f29d4b",
                    "data": [
                        0.004,
                        0.011,
                        0.021,
                        0.037,
                        0.045,
                        0.06,
                        0.074,
                        0.096,
                        0.11,
                        0.148,
                        0.221,
                        0.288,
                        0.397,
                        0.557,
                        0.718,
                        0.847,
                        1.144,
                        1.358,
                        1.847,
                        1.931,
                        2.502,
                        2.699,
                        3.109,
                        3.613,
                        4.122,
                        4.292,
                        4.601,
                        4.761,
                        5.517,
                        6.086,
                        6.562,
                        6.958,
                        7.389,
                        7.477,
                        8.141,
                        8.006,
                        7.943,
                        7.751,
                        7.918,
                        8.349,
                        7.537,
                        7.596,
                        7.739,
                        7.581,
                        7.165
                    ],
                    "name": "All Men",
                    "type": "column"
                },
                {
                    "color": "#de2d26",
                    "data": [
                        0.0,
                        0.0,
                        0.0,
                        0.0,
                        0.0,
                        0.0,
                        0.001,
                        0.001,
                        0.001,
                        0.004,
                        0.003,
                        0.008,
                        0.008,
                        0.015,
                        0.013,
                        0.02,
                        0.023,
                        0.023,
                        0.034,
                        0.043,
                        0.051,
                        0.043,
                        0.063,
                        0.081,
                        0.102,
                        0.111,
                        0.131,
                        0.134,
                        0.161,
                        0.186,
                        0.189,
                        0.223,
                        0.264,
                        0.256,
                        0.305,
                        0.296,
                        0.337,
                        0.337,
                        0.323,
                        0.357,
                        0.323,
                        0.348,
                        0.357,
                        0.362,
                        0.313
                    ],
                    "name": "All Women",
                    "type": "column"
                },
                {
                    "color": "darkblue",
                    "data": [
                        0.0,
                        0.0,
                        0.0,
                        0.0,
                        0.0,
                        0.0,
                        1.35,
                        1.04,
                        0.91,
                        2.7,
                        1.36,
                        2.78,
                        2.02,
                        2.69,
                        1.81,
                        2.36,
                        2.01,
                        1.69,
                        1.84,
                        2.23,
                        2.04,
                        1.59,
                        2.03,
                        2.24,
                        2.47,
                        2.59,
                        2.85,
                        2.81,
                        2.92,
                        3.06,
                        2.88,
                        3.2,
                        3.57,
                        3.42,
                        3.75,
                        3.7,
                        4.24,
                        4.35,
                        4.08,
                        4.28,
                        4.29,
                        4.58,
                        4.61,
                        4.78,
                        4.37
                    ],
                    "name": "Among all",
                    "type": "spline",
                    "yAxis": 1
                },
                {
                    "color": "darkblue",
                    "data": [
                        0.0,
                        0.0,
                        0.0,
                        0.0,
                        0.0,
                        0.0,
                        1.43,
                        0.0,
                        0.98,
                        2.8,
                        1.41,
                        2.88,
                        2.11,
                        2.6,
                        1.72,
                        2.3,
                        1.86,
                        1.56,
                        1.9,
                        2.17,
                        1.98,
                        1.54,
                        1.92,
                        2.24,
                        2.51,
                        2.47,
                        2.76,
                        2.89,
                        2.94,
                        2.88,
                        2.75,
                        3.02,
                        3.52,
                        3.39,
                        3.57,
                        3.47,
                        3.84,
                        4.14,
                        3.8,
                        4.0,
                        3.87,
                        4.52,
                        4.48,
                        4.52,
                        4.07
                    ],
                    "marker": {
                        "fillColor": "#FFFFFF",
                        "lineColor": "darkblue",
                        "lineWidth": 2,
                        "radius": 5
                    },
                    "name": "Among core",
                    "type": "spline",
                    "yAxis": 1
                }
            ],
            "height_ratio": 69.23076923076923,
            "label_x": "Time (quarter)",
            "label_y": "Number of Contributors (thousand)",
            "label_y_secondary": "% Women (of total m + w)",
            "title": "Active Contributors in CocoaPods Public Projects",
            "x_categories": [
                "2008-3",
                "2008-6",
                "2008-9",
                "2008-12",
                "2009-3",
                "2009-6",
                "2009-9",
                "2009-12",
                "2010-3",
                "2010-6",
                "2010-9",
                "2010-12",
                "2011-3",
                "2011-6",
                "2011-9",
                "2011-12",
                "2012-3",
                "2012-6",
                "2012-9",
                "2012-12",
                "2013-3",
                "2013-6",
                "2013-9",
                "2013-12",
                "2014-3",
                "2014-6",
                "2014-9",
                "2014-12",
                "2015-3",
                "2015-6",
                "2015-9",
                "2015-12",
                "2016-3",
                "2016-6",
                "2016-9",
                "2016-12",
                "2017-3",
                "2017-6",
                "2017-9",
                "2017-12",
                "2018-3",
                "2018-6",
                "2018-9",
                "2018-12",
                "2019-3"
            ]
        },
        "CocoaPods_line": {
            "data": [
                {
                    "color": "#E31316",
                    "data": [
                        0.0,
                        0.0,
                        0.0,
                        0.0,
                        0.0,
                        0.0,
                        1.35,
                        1.04,
                        0.91,
                        2.7,
                        1.36,
                        2.78,
                        2.02,
                        2.69,
                        1.81,
                        2.36,
                        2.01,
                        1.69,
                        1.84,
                        2.23,
                        2.04,
                        1.59,
                        2.03,
                        2.24,
                        2.47,
                        2.59,
                        2.85,
                        2.81,
                        2.92,
                        3.06,
                        2.88,
                        3.2,
                        3.57,
                        3.42,
                        3.75,
                        3.7,
                        4.24,
                        4.35,
                        4.08,
                        4.28,
                        4.29,
                        4.58,
                        4.61,
                        4.78,
                        4.37
                    ],
                    "name": "Among all",
                    "type": "spline",
                    "yAxis": 1
                }
            ],
            "height_ratio": 66.66666666666666,
            "label_x": "",
            "label_y": "",
            "label_y_secondary": "",
            "title": "",
            "x_categories": [
                "2008",
                "2008",
                "2008",
                "2008",
                "2009",
                "2009",
                "2009",
                "2009",
                "2010",
                "2010",
                "2010",
                "2010",
                "2011",
                "2011",
                "2011",
                "2011",
                "2012",
                "2012",
                "2012",
                "2012",
                "2013",
                "2013",
                "2013",
                "2013",
                "2014",
                "2014",
                "2014",
                "2014",
                "2015",
                "2015",
                "2015",
                "2015",
                "2016",
                "2016",
                "2016",
                "2016",
                "2017",
                "2017",
                "2017",
                "2017",
                "2018",
                "2018",
                "2018",
                "2018",
                "2019"
            ]
        },
        "CocoaPods_women-bar": {
            "data": [
                {
                    "color": "#E31316",
                    "data": [
                        0,
                        0,
                        0,
                        0,
                        0,
                        0,
                        1,
                        1,
                        1,
                        4,
                        3,
                        8,
                        8,
                        15,
                        13,
                        20,
                        23,
                        23,
                        34,
                        43,
                        51,
                        43,
                        63,
                        81,
                        102,
                        111,
                        131,
                        134,
                        161,
                        186,
                        189,
                        223,
                        264,
                        256,
                        305,
                        296,
                        337,
                        337,
                        323,
                        357,
                        323,
                        348,
                        357,
                        362,
                        313
                    ],
                    "name": "Women",
                    "type": "column",
                    "yAxis": 1
                }
            ],
            "height_ratio": 66.66666666666666,
            "label_x": "",
            "label_y": "",
            "label_y_secondary": "",
            "title": "",
            "x_categories": [
                "2008",
                "2008",
                "2008",
                "2008",
                "2009",
                "2009",
                "2009",
                "2009",
                "2010",
                "2010",
                "2010",
                "2010",
                "2011",
                "2011",
                "2011",
                "2011",
                "2012",
                "2012",
                "2012",
                "2012",
                "2013",
                "2013",
                "2013",
                "2013",
                "2014",
                "2014",
                "2014",
                "2014",
                "2015",
                "2015",
                "2015",
                "2015",
                "2016",
                "2016",
                "2016",
                "2016",
                "2017",
                "2017",
                "2017",
                "2017",
                "2018",
                "2018",
                "2018",
                "2018",
                "2019"
            ]
        },
        "Go": {
            "data": [
                {
                    "color": "blanchedalmond",
                    "data": [
                        0.015,
                        0.012,
                        0.028,
                        0.029,
                        0.037,
                        0.055,
                        0.051,
                        0.172,
                        0.167,
                        0.156,
                        0.255,
                        0.262,
                        0.356,
                        0.51,
                        0.567,
                        0.7,
                        0.958,
                        1.203,
                        1.837,
                        1.896,
                        2.678,
                        3.551,
                        5.058,
                        5.705,
                        7.445,
                        8.546,
                        10.564,
                        11.964,
                        14.395,
                        15.054,
                        15.838,
                        18.155,
                        19.197,
                        17.459,
                        17.473,
                        18.192,
                        19.882,
                        20.242,
                        21.138,
                        22.402,
                        24.211,
                        24.58,
                        25.271,
                        26.279,
                        25.67
                    ],
                    "name": "All Unknown",
                    "type": "column"
                },
                {
                    "color": "#f29d4b",
                    "data": [
                        0.013,
                        0.01,
                        0.019,
                        0.022,
                        0.026,
                        0.044,
                        0.04,
                        0.133,
                        0.133,
                        0.112,
                        0.2,
                        0.198,
                        0.278,
                        0.402,
                        0.444,
                        0.557,
                        0.754,
                        0.909,
                        1.364,
                        1.409,
                        1.968,
                        2.6,
                        3.623,
                        4.128,
                        5.29,
                        6.094,
                        7.445,
                        8.433,
                        10.133,
                        10.649,
                        11.157,
                        12.647,
                        13.496,
                        12.516,
                        12.46,
                        12.914,
                        14.258,
                        14.402,
                        14.772,
                        15.628,
                        16.81,
                        16.954,
                        17.243,
                        17.544,
                        17.147
                    ],
                    "name": "All Men",
                    "type": "column"
                },
                {
                    "color": "#de2d26",
                    "data": [
                        0.001,
                        0.0,
                        0.001,
                        0.0,
                        0.0,
                        0.001,
                        0.0,
                        0.002,
                        0.005,
                        0.004,
                        0.005,
                        0.005,
                        0.006,
                        0.011,
                        0.012,
                        0.014,
                        0.021,
                        0.025,
                        0.032,
                        0.032,
                        0.045,
                        0.067,
                        0.093,
                        0.099,
                        0.142,
                        0.162,
                        0.219,
                        0.257,
                        0.312,
                        0.321,
                        0.365,
                        0.428,
                        0.46,
                        0.442,
                        0.442,
                        0.463,
                        0.495,
                        0.558,
                        0.644,
                        0.64,
                        0.67,
                        0.7,
                        0.733,
                        0.751,
                        0.71
                    ],
                    "name": "All Women",
                    "type": "column"
                },
                {
                    "color": "darkblue",
                    "data": [
                        7.69,
                        0.0,
                        5.26,
                        0.0,
                        0.0,
                        2.27,
                        0.0,
                        1.5,
                        3.76,
                        3.57,
                        2.5,
                        2.53,
                        2.16,
                        2.74,
                        2.7,
                        2.51,
                        2.79,
                        2.75,
                        2.35,
                        2.27,
                        2.29,
                        2.58,
                        2.57,
                        2.4,
                        2.68,
                        2.66,
                        2.94,
                        3.05,
                        3.08,
                        3.01,
                        3.27,
                        3.38,
                        3.41,
                        3.53,
                        3.55,
                        3.59,
                        3.47,
                        3.87,
                        4.36,
                        4.1,
                        3.99,
                        4.13,
                        4.25,
                        4.28,
                        4.14
                    ],
                    "name": "Among all",
                    "type": "spline",
                    "yAxis": 1
                },
                {
                    "color": "darkblue",
                    "data": [
                        7.69,
                        0.0,
                        5.26,
                        0.0,
                        0.0,
                        2.27,
                        0.0,
                        0.81,
                        2.5,
                        3.92,
                        2.14,
                        2.86,
                        2.05,
                        3.01,
                        2.79,
                        2.38,
                        2.85,
                        2.9,
                        2.93,
                        2.76,
                        2.23,
                        2.69,
                        2.9,
                        2.59,
                        2.58,
                        2.73,
                        2.9,
                        3.11,
                        3.14,
                        3.07,
                        3.45,
                        3.58,
                        3.39,
                        3.73,
                        3.88,
                        3.79,
                        3.63,
                        4.17,
                        4.61,
                        4.4,
                        4.24,
                        4.43,
                        4.46,
                        4.59,
                        4.39
                    ],
                    "marker": {
                        "fillColor": "#FFFFFF",
                        "lineColor": "darkblue",
                        "lineWidth": 2,
                        "radius": 5
                    },
                    "name": "Among core",
                    "type": "spline",
                    "yAxis": 1
                }
            ],
            "height_ratio": 69.23076923076923,
            "label_x": "Time (quarter)",
            "label_y": "Number of Contributors (thousand)",
            "label_y_secondary": "% Women (of total m + w)",
            "title": "Active Contributors in Go Public Projects",
            "x_categories": [
                "2008-3",
                "2008-6",
                "2008-9",
                "2008-12",
                "2009-3",
                "2009-6",
                "2009-9",
                "2009-12",
                "2010-3",
                "2010-6",
                "2010-9",
                "2010-12",
                "2011-3",
                "2011-6",
                "2011-9",
                "2011-12",
                "2012-3",
                "2012-6",
                "2012-9",
                "2012-12",
                "2013-3",
                "2013-6",
                "2013-9",
                "2013-12",
                "2014-3",
                "2014-6",
                "2014-9",
                "2014-12",
                "2015-3",
                "2015-6",
                "2015-9",
                "2015-12",
                "2016-3",
                "2016-6",
                "2016-9",
                "2016-12",
                "2017-3",
                "2017-6",
                "2017-9",
                "2017-12",
                "2018-3",
                "2018-6",
                "2018-9",
                "2018-12",
                "2019-3"
            ]
        },
        "Go_line": {
            "data": [
                {
                    "color": "#017C9B",
                    "data": [
                        7.69,
                        0.0,
                        5.26,
                        0.0,
                        0.0,
                        2.27,
                        0.0,
                        1.5,
                        3.76,
                        3.57,
                        2.5,
                        2.53,
                        2.16,
                        2.74,
                        2.7,
                        2.51,
                        2.79,
                        2.75,
                        2.35,
                        2.27,
                        2.29,
                        2.58,
                        2.57,
                        2.4,
                        2.68,
                        2.66,
                        2.94,
                        3.05,
                        3.08,
                        3.01,
                        3.27,
                        3.38,
                        3.41,
                        3.53,
                        3.55,
                        3.59,
                        3.47,
                        3.87,
                        4.36,
                        4.1,
                        3.99,
                        4.13,
                        4.25,
                        4.28,
                        4.14
                    ],
                    "name": "Among all",
                    "type": "spline",
                    "yAxis": 1
                }
            ],
            "height_ratio": 66.66666666666666,
            "label_x": "",
            "label_y": "",
            "label_y_secondary": "",
            "title": "",
            "x_categories": [
                "2008",
                "2008",
                "2008",
                "2008",
                "2009",
                "2009",
                "2009",
                "2009",
                "2010",
                "2010",
                "2010",
                "2010",
                "2011",
                "2011",
                "2011",
                "2011",
                "2012",
                "2012",
                "2012",
                "2012",
                "2013",
                "2013",
                "2013",
                "2013",
                "2014",
                "2014",
                "2014",
                "2014",
                "2015",
                "2015",
                "2015",
                "2015",
                "2016",
                "2016",
                "2016",
                "2016",
                "2017",
                "2017",
                "2017",
                "2017",
                "2018",
                "2018",
                "2018",
                "2018",
                "2019"
            ]
        },
        "Go_women-bar": {
            "data": [
                {
                    "color": "#017C9B",
                    "data": [
                        1,
                        0,
                        1,
                        0,
                        0,
                        1,
                        0,
                        2,
                        5,
                        4,
                        5,
                        5,
                        6,
                        11,
                        12,
                        14,
                        21,
                        25,
                        32,
                        32,
                        45,
                        67,
                        93,
                        99,
                        142,
                        162,
                        219,
                        257,
                        312,
                        321,
                        365,
                        428,
                        460,
                        442,
                        442,
                        463,
                        495,
                        558,
                        644,
                        640,
                        670,
                        700,
                        733,
                        751,
                        710
                    ],
                    "name": "Women",
                    "type": "column",
                    "yAxis": 1
                }
            ],
            "height_ratio": 66.66666666666666,
            "label_x": "",
            "label_y": "",
            "label_y_secondary": "",
            "title": "",
            "x_categories": [
                "2008",
                "2008",
                "2008",
                "2008",
                "2009",
                "2009",
                "2009",
                "2009",
                "2010",
                "2010",
                "2010",
                "2010",
                "2011",
                "2011",
                "2011",
                "2011",
                "2012",
                "2012",
                "2012",
                "2012",
                "2013",
                "2013",
                "2013",
                "2013",
                "2014",
                "2014",
                "2014",
                "2014",
                "2015",
                "2015",
                "2015",
                "2015",
                "2016",
                "2016",
                "2016",
                "2016",
                "2017",
                "2017",
                "2017",
                "2017",
                "2018",
                "2018",
                "2018",
                "2018",
                "2019"
            ]
        },
        "Hackage": {
            "data": [
                {
                    "color": "blanchedalmond",
                    "data": [
                        0.058,
                        0.056,
                        0.067,
                        0.089,
                        0.113,
                        0.097,
                        0.099,
                        0.122,
                        0.142,
                        0.167,
                        0.181,
                        0.224,
                        0.245,
                        0.285,
                        0.315,
                        0.333,
                        0.475,
                        0.487,
                        0.582,
                        0.577,
                        0.677,
                        0.677,
                        0.7,
                        0.814,
                        0.941,
                        1.127,
                        1.128,
                        1.138,
                        1.262,
                        1.309,
                        1.316,
                        1.292,
                        1.305,
                        1.292,
                        1.272,
                        1.296,
                        1.363,
                        1.297,
                        1.419,
                        1.472,
                        1.52,
                        1.55,
                        1.441,
                        1.444,
                        1.417
                    ],
                    "name": "All Unknown",
                    "type": "column"
                },
                {
                    "color": "#f29d4b",
                    "data": [
                        0.043,
                        0.044,
                        0.052,
                        0.07,
                        0.092,
                        0.076,
                        0.08,
                        0.099,
                        0.121,
                        0.142,
                        0.155,
                        0.19,
                        0.212,
                        0.244,
                        0.269,
                        0.278,
                        0.402,
                        0.405,
                        0.487,
                        0.48,
                        0.568,
                        0.557,
                        0.576,
                        0.682,
                        0.77,
                        0.942,
                        0.922,
                        0.93,
                        1.029,
                        1.09,
                        1.093,
                        1.045,
                        1.061,
                        1.068,
                        1.052,
                        1.055,
                        1.1,
                        1.055,
                        1.137,
                        1.17,
                        1.215,
                        1.254,
                        1.149,
                        1.163,
                        1.151
                    ],
                    "name": "All Men",
                    "type": "column"
                },
                {
                    "color": "#de2d26",
                    "data": [
                        0.001,
                        0.001,
                        0.001,
                        0.001,
                        0.002,
                        0.002,
                        0.002,
                        0.002,
                        0.0,
                        0.003,
                        0.002,
                        0.007,
                        0.001,
                        0.005,
                        0.004,
                        0.003,
                        0.007,
                        0.01,
                        0.009,
                        0.012,
                        0.013,
                        0.01,
                        0.014,
                        0.019,
                        0.02,
                        0.022,
                        0.023,
                        0.027,
                        0.021,
                        0.031,
                        0.024,
                        0.026,
                        0.024,
                        0.027,
                        0.029,
                        0.029,
                        0.028,
                        0.03,
                        0.025,
                        0.04,
                        0.045,
                        0.038,
                        0.038,
                        0.036,
                        0.044
                    ],
                    "name": "All Women",
                    "type": "column"
                },
                {
                    "color": "darkblue",
                    "data": [
                        2.33,
                        2.27,
                        1.92,
                        1.43,
                        2.17,
                        2.63,
                        2.5,
                        2.02,
                        0.0,
                        2.11,
                        1.29,
                        3.68,
                        0.47,
                        2.05,
                        1.49,
                        1.08,
                        1.74,
                        2.47,
                        1.85,
                        2.5,
                        2.29,
                        1.8,
                        2.43,
                        2.79,
                        2.6,
                        2.34,
                        2.49,
                        2.9,
                        2.04,
                        2.84,
                        2.2,
                        2.49,
                        2.26,
                        2.53,
                        2.76,
                        2.75,
                        2.55,
                        2.84,
                        2.2,
                        3.42,
                        3.7,
                        3.03,
                        3.31,
                        3.1,
                        3.82
                    ],
                    "name": "Among all",
                    "type": "spline",
                    "yAxis": 1
                },
                {
                    "color": "darkblue",
                    "data": [
                        2.94,
                        3.03,
                        2.86,
                        1.96,
                        2.82,
                        3.45,
                        1.56,
                        2.67,
                        0.0,
                        1.87,
                        1.85,
                        3.08,
                        0.65,
                        1.18,
                        1.6,
                        1.44,
                        1.06,
                        1.82,
                        1.53,
                        2.67,
                        2.43,
                        2.31,
                        2.67,
                        2.34,
                        2.22,
                        2.18,
                        2.37,
                        2.65,
                        2.05,
                        2.54,
                        2.3,
                        2.39,
                        2.3,
                        2.43,
                        2.64,
                        2.56,
                        2.95,
                        2.56,
                        1.85,
                        3.72,
                        3.82,
                        3.22,
                        2.96,
                        2.6,
                        3.76
                    ],
                    "marker": {
                        "fillColor": "#FFFFFF",
                        "lineColor": "darkblue",
                        "lineWidth": 2,
                        "radius": 5
                    },
                    "name": "Among core",
                    "type": "spline",
                    "yAxis": 1
                }
            ],
            "height_ratio": 69.23076923076923,
            "label_x": "Time (quarter)",
            "label_y": "Number of Contributors (thousand)",
            "label_y_secondary": "% Women (of total m + w)",
            "title": "Active Contributors in Hackage Public Projects",
            "x_categories": [
                "2008-3",
                "2008-6",
                "2008-9",
                "2008-12",
                "2009-3",
                "2009-6",
                "2009-9",
                "2009-12",
                "2010-3",
                "2010-6",
                "2010-9",
                "2010-12",
                "2011-3",
                "2011-6",
                "2011-9",
                "2011-12",
                "2012-3",
                "2012-6",
                "2012-9",
                "2012-12",
                "2013-3",
                "2013-6",
                "2013-9",
                "2013-12",
                "2014-3",
                "2014-6",
                "2014-9",
                "2014-12",
                "2015-3",
                "2015-6",
                "2015-9",
                "2015-12",
                "2016-3",
                "2016-6",
                "2016-9",
                "2016-12",
                "2017-3",
                "2017-6",
                "2017-9",
                "2017-12",
                "2018-3",
                "2018-6",
                "2018-9",
                "2018-12",
                "2019-3"
            ]
        },
        "Hackage_line": {
            "data": [
                {
                    "color": "#5C5281",
                    "data": [
                        2.33,
                        2.27,
                        1.92,
                        1.43,
                        2.17,
                        2.63,
                        2.5,
                        2.02,
                        0.0,
                        2.11,
                        1.29,
                        3.68,
                        0.47,
                        2.05,
                        1.49,
                        1.08,
                        1.74,
                        2.47,
                        1.85,
                        2.5,
                        2.29,
                        1.8,
                        2.43,
                        2.79,
                        2.6,
                        2.34,
                        2.49,
                        2.9,
                        2.04,
                        2.84,
                        2.2,
                        2.49,
                        2.26,
                        2.53,
                        2.76,
                        2.75,
                        2.55,
                        2.84,
                        2.2,
                        3.42,
                        3.7,
                        3.03,
                        3.31,
                        3.1,
                        3.82
                    ],
                    "name": "Among all",
                    "type": "spline",
                    "yAxis": 1
                }
            ],
            "height_ratio": 66.66666666666666,
            "label_x": "",
            "label_y": "",
            "label_y_secondary": "",
            "title": "",
            "x_categories": [
                "2008",
                "2008",
                "2008",
                "2008",
                "2009",
                "2009",
                "2009",
                "2009",
                "2010",
                "2010",
                "2010",
                "2010",
                "2011",
                "2011",
                "2011",
                "2011",
                "2012",
                "2012",
                "2012",
                "2012",
                "2013",
                "2013",
                "2013",
                "2013",
                "2014",
                "2014",
                "2014",
                "2014",
                "2015",
                "2015",
                "2015",
                "2015",
                "2016",
                "2016",
                "2016",
                "2016",
                "2017",
                "2017",
                "2017",
                "2017",
                "2018",
                "2018",
                "2018",
                "2018",
                "2019"
            ]
        },
        "Hackage_women-bar": {
            "data": [
                {
                    "color": "#5C5281",
                    "data": [
                        1,
                        1,
                        1,
                        1,
                        2,
                        2,
                        2,
                        2,
                        0,
                        3,
                        2,
                        7,
                        1,
                        5,
                        4,
                        3,
                        7,
                        10,
                        9,
                        12,
                        13,
                        10,
                        14,
                        19,
                        20,
                        22,
                        23,
                        27,
                        21,
                        31,
                        24,
                        26,
                        24,
                        27,
                        29,
                        29,
                        28,
                        30,
                        25,
                        40,
                        45,
                        38,
                        38,
                        36,
                        44
                    ],
                    "name": "Women",
                    "type": "column",
                    "yAxis": 1
                }
            ],
            "height_ratio": 66.66666666666666,
            "label_x": "",
            "label_y": "",
            "label_y_secondary": "",
            "title": "",
            "x_categories": [
                "2008",
                "2008",
                "2008",
                "2008",
                "2009",
                "2009",
                "2009",
                "2009",
                "2010",
                "2010",
                "2010",
                "2010",
                "2011",
                "2011",
                "2011",
                "2011",
                "2012",
                "2012",
                "2012",
                "2012",
                "2013",
                "2013",
                "2013",
                "2013",
                "2014",
                "2014",
                "2014",
                "2014",
                "2015",
                "2015",
                "2015",
                "2015",
                "2016",
                "2016",
                "2016",
                "2016",
                "2017",
                "2017",
                "2017",
                "2017",
                "2018",
                "2018",
                "2018",
                "2018",
                "2019"
            ]
        },
        "Hex": {
            "data": [
                {
                    "color": "blanchedalmond",
                    "data": [
                        0.005,
                        0.004,
                        0.003,
                        0.003,
                        0.009,
                        0.016,
                        0.016,
                        0.028,
                        0.027,
                        0.035,
                        0.074,
                        0.058,
                        0.092,
                        0.086,
                        0.116,
                        0.131,
                        0.18,
                        0.17,
                        0.186,
                        0.209,
                        0.238,
                        0.282,
                        0.332,
                        0.364,
                        0.401,
                        0.46,
                        0.554,
                        0.598,
                        0.667,
                        0.789,
                        1.011,
                        1.167,
                        1.417,
                        1.54,
                        1.754,
                        1.79,
                        2.132,
                        1.991,
                        2.152,
                        2.102,
                        2.135,
                        2.086,
                        2.102,
                        2.271,
                        2.092
                    ],
                    "name": "All Unknown",
                    "type": "column"
                },
                {
                    "color": "#f29d4b",
                    "data": [
                        0.002,
                        0.003,
                        0.003,
                        0.003,
                        0.008,
                        0.013,
                        0.012,
                        0.02,
                        0.024,
                        0.035,
                        0.071,
                        0.052,
                        0.079,
                        0.079,
                        0.108,
                        0.116,
                        0.155,
                        0.145,
                        0.161,
                        0.189,
                        0.202,
                        0.24,
                        0.272,
                        0.283,
                        0.324,
                        0.365,
                        0.453,
                        0.489,
                        0.548,
                        0.645,
                        0.815,
                        0.963,
                        1.148,
                        1.265,
                        1.459,
                        1.443,
                        1.75,
                        1.593,
                        1.735,
                        1.715,
                        1.726,
                        1.681,
                        1.686,
                        1.796,
                        1.678
                    ],
                    "name": "All Men",
                    "type": "column"
                },
                {
                    "color": "#de2d26",
                    "data": [
                        0.0,
                        0.0,
                        0.0,
                        0.0,
                        0.0,
                        0.0,
                        0.0,
                        0.0,
                        0.001,
                        0.001,
                        0.001,
                        0.0,
                        0.002,
                        0.001,
                        0.002,
                        0.0,
                        0.001,
                        0.002,
                        0.003,
                        0.003,
                        0.004,
                        0.004,
                        0.001,
                        0.005,
                        0.006,
                        0.003,
                        0.008,
                        0.007,
                        0.011,
                        0.015,
                        0.023,
                        0.026,
                        0.029,
                        0.037,
                        0.037,
                        0.034,
                        0.048,
                        0.04,
                        0.044,
                        0.057,
                        0.044,
                        0.044,
                        0.044,
                        0.051,
                        0.05
                    ],
                    "name": "All Women",
                    "type": "column"
                },
                {
                    "color": "darkblue",
                    "data": [
                        0.0,
                        0.0,
                        0.0,
                        0.0,
                        0.0,
                        0.0,
                        0.0,
                        0.0,
                        4.17,
                        2.86,
                        1.41,
                        0.0,
                        2.53,
                        1.27,
                        1.85,
                        0.0,
                        0.65,
                        1.38,
                        1.86,
                        1.59,
                        1.98,
                        1.67,
                        0.37,
                        1.77,
                        1.85,
                        0.82,
                        1.77,
                        1.43,
                        2.01,
                        2.33,
                        2.82,
                        2.7,
                        2.53,
                        2.92,
                        2.54,
                        2.36,
                        2.74,
                        2.51,
                        2.54,
                        3.32,
                        2.55,
                        2.62,
                        2.61,
                        2.84,
                        2.98
                    ],
                    "name": "Among all",
                    "type": "spline",
                    "yAxis": 1
                },
                {
                    "color": "darkblue",
                    "data": [
                        0.0,
                        0.0,
                        0.0,
                        0.0,
                        0.0,
                        0.0,
                        0.0,
                        0.0,
                        4.17,
                        2.86,
                        1.41,
                        0.0,
                        2.63,
                        1.33,
                        1.94,
                        0.0,
                        0.67,
                        1.43,
                        2.0,
                        1.68,
                        2.15,
                        1.83,
                        0.41,
                        1.98,
                        1.68,
                        0.92,
                        2.07,
                        1.71,
                        2.2,
                        2.12,
                        2.65,
                        2.99,
                        2.31,
                        2.68,
                        2.55,
                        2.32,
                        2.76,
                        2.4,
                        2.22,
                        3.72,
                        2.58,
                        2.6,
                        2.33,
                        3.2,
                        3.01
                    ],
                    "marker": {
                        "fillColor": "#FFFFFF",
                        "lineColor": "darkblue",
                        "lineWidth": 2,
                        "radius": 5
                    },
                    "name": "Among core",
                    "type": "spline",
                    "yAxis": 1
                }
            ],
            "height_ratio": 69.23076923076923,
            "label_x": "Time (quarter)",
            "label_y": "Number of Contributors (thousand)",
            "label_y_secondary": "% Women (of total m + w)",
            "title": "Active Contributors in Hex Public Projects",
            "x_categories": [
                "2008-3",
                "2008-6",
                "2008-9",
                "2008-12",
                "2009-3",
                "2009-6",
                "2009-9",
                "2009-12",
                "2010-3",
                "2010-6",
                "2010-9",
                "2010-12",
                "2011-3",
                "2011-6",
                "2011-9",
                "2011-12",
                "2012-3",
                "2012-6",
                "2012-9",
                "2012-12",
                "2013-3",
                "2013-6",
                "2013-9",
                "2013-12",
                "2014-3",
                "2014-6",
                "2014-9",
                "2014-12",
                "2015-3",
                "2015-6",
                "2015-9",
                "2015-12",
                "2016-3",
                "2016-6",
                "2016-9",
                "2016-12",
                "2017-3",
                "2017-6",
                "2017-9",
                "2017-12",
                "2018-3",
                "2018-6",
                "2018-9",
                "2018-12",
                "2019-3"
            ]
        },
        "Hex_line": {
            "data": [
                {
                    "color": "#52796F",
                    "data": [
                        0.0,
                        0.0,
                        0.0,
                        0.0,
                        0.0,
                        0.0,
                        0.0,
                        0.0,
                        4.17,
                        2.86,
                        1.41,
                        0.0,
                        2.53,
                        1.27,
                        1.85,
                        0.0,
                        0.65,
                        1.38,
                        1.86,
                        1.59,
                        1.98,
                        1.67,
                        0.37,
                        1.77,
                        1.85,
                        0.82,
                        1.77,
                        1.43,
                        2.01,
                        2.33,
                        2.82,
                        2.7,
                        2.53,
                        2.92,
                        2.54,
                        2.36,
                        2.74,
                        2.51,
                        2.54,
                        3.32,
                        2.55,
                        2.62,
                        2.61,
                        2.84,
                        2.98
                    ],
                    "name": "Among all",
                    "type": "spline",
                    "yAxis": 1
                }
            ],
            "height_ratio": 66.66666666666666,
            "label_x": "",
            "label_y": "",
            "label_y_secondary": "",
            "title": "",
            "x_categories": [
                "2008",
                "2008",
                "2008",
                "2008",
                "2009",
                "2009",
                "2009",
                "2009",
                "2010",
                "2010",
                "2010",
                "2010",
                "2011",
                "2011",
                "2011",
                "2011",
                "2012",
                "2012",
                "2012",
                "2012",
                "2013",
                "2013",
                "2013",
                "2013",
                "2014",
                "2014",
                "2014",
                "2014",
                "2015",
                "2015",
                "2015",
                "2015",
                "2016",
                "2016",
                "2016",
                "2016",
                "2017",
                "2017",
                "2017",
                "2017",
                "2018",
                "2018",
                "2018",
                "2018",
                "2019"
            ]
        },
        "Hex_women-bar": {
            "data": [
                {
                    "color": "#52796F",
                    "data": [
                        0,
                        0,
                        0,
                        0,
                        0,
                        0,
                        0,
                        0,
                        1,
                        1,
                        1,
                        0,
                        2,
                        1,
                        2,
                        0,
                        1,
                        2,
                        3,
                        3,
                        4,
                        4,
                        1,
                        5,
                        6,
                        3,
                        8,
                        7,
                        11,
                        15,
                        23,
                        26,
                        29,
                        37,
                        37,
                        34,
                        48,
                        40,
                        44,
                        57,
                        44,
                        44,
                        44,
                        51,
                        50
                    ],
                    "name": "Women",
                    "type": "column",
                    "yAxis": 1
                }
            ],
            "height_ratio": 66.66666666666666,
            "label_x": "",
            "label_y": "",
            "label_y_secondary": "",
            "title": "",
            "x_categories": [
                "2008",
                "2008",
                "2008",
                "2008",
                "2009",
                "2009",
                "2009",
                "2009",
                "2010",
                "2010",
                "2010",
                "2010",
                "2011",
                "2011",
                "2011",
                "2011",
                "2012",
                "2012",
                "2012",
                "2012",
                "2013",
                "2013",
                "2013",
                "2013",
                "2014",
                "2014",
                "2014",
                "2014",
                "2015",
                "2015",
                "2015",
                "2015",
                "2016",
                "2016",
                "2016",
                "2016",
                "2017",
                "2017",
                "2017",
                "2017",
                "2018",
                "2018",
                "2018",
                "2018",
                "2019"
            ]
        },
        "Maven": {
            "data": [
                {
                    "color": "blanchedalmond",
                    "data": [
                        0.434,
                        0.503,
                        0.553,
                        0.61,
                        0.729,
                        0.8,
                        0.846,
                        1.067,
                        1.326,
                        1.403,
                        1.77,
                        2.188,
                        2.684,
                        3.334,
                        3.96,
                        4.554,
                        5.841,
                        6.347,
                        7.531,
                        8.353,
                        10.718,
                        11.676,
                        13.295,
                        14.529,
                        16.611,
                        17.994,
                        19.377,
                        20.922,
                        23.724,
                        24.405,
                        24.877,
                        25.941,
                        27.281,
                        27.415,
                        26.785,
                        28.72,
                        30.37,
                        30.087,
                        29.376,
                        29.443,
                        28.898,
                        28.538,
                        27.727,
                        27.836,
                        25.964
                    ],
                    "name": "All Unknown",
                    "type": "column"
                },
                {
                    "color": "#f29d4b",
                    "data": [
                        0.257,
                        0.303,
                        0.323,
                        0.383,
                        0.477,
                        0.522,
                        0.558,
                        0.728,
                        0.94,
                        0.985,
                        1.224,
                        1.583,
                        2.013,
                        2.508,
                        2.998,
                        3.547,
                        4.556,
                        4.926,
                        5.79,
                        6.421,
                        8.329,
                        9.011,
                        10.174,
                        11.055,
                        12.656,
                        13.655,
                        14.679,
                        15.703,
                        17.852,
                        18.221,
                        18.645,
                        19.082,
                        20.212,
                        20.188,
                        19.546,
                        20.588,
                        21.732,
                        21.144,
                        20.442,
                        20.495,
                        20.095,
                        19.443,
                        18.5,
                        18.432,
                        17.208
                    ],
                    "name": "All Men",
                    "type": "column"
                },
                {
                    "color": "#de2d26",
                    "data": [
                        0.008,
                        0.009,
                        0.012,
                        0.009,
                        0.011,
                        0.016,
                        0.014,
                        0.021,
                        0.023,
                        0.025,
                        0.03,
                        0.043,
                        0.047,
                        0.053,
                        0.066,
                        0.081,
                        0.089,
                        0.104,
                        0.147,
                        0.156,
                        0.204,
                        0.217,
                        0.275,
                        0.301,
                        0.375,
                        0.399,
                        0.45,
                        0.451,
                        0.539,
                        0.6,
                        0.64,
                        0.641,
                        0.752,
                        0.771,
                        0.767,
                        0.773,
                        0.873,
                        0.916,
                        0.955,
                        0.988,
                        0.911,
                        0.917,
                        0.949,
                        0.922,
                        0.876
                    ],
                    "name": "All Women",
                    "type": "column"
                },
                {
                    "color": "darkblue",
                    "data": [
                        3.11,
                        2.97,
                        3.72,
                        2.35,
                        2.31,
                        3.07,
                        2.51,
                        2.88,
                        2.45,
                        2.54,
                        2.45,
                        2.72,
                        2.33,
                        2.11,
                        2.2,
                        2.28,
                        1.95,
                        2.11,
                        2.54,
                        2.43,
                        2.45,
                        2.41,
                        2.7,
                        2.72,
                        2.96,
                        2.92,
                        3.07,
                        2.87,
                        3.02,
                        3.29,
                        3.43,
                        3.36,
                        3.72,
                        3.82,
                        3.92,
                        3.75,
                        4.02,
                        4.33,
                        4.67,
                        4.82,
                        4.53,
                        4.72,
                        5.13,
                        5.0,
                        5.09
                    ],
                    "name": "Among all",
                    "type": "spline",
                    "yAxis": 1
                },
                {
                    "color": "darkblue",
                    "data": [
                        2.42,
                        2.38,
                        3.14,
                        1.67,
                        2.42,
                        3.1,
                        2.44,
                        3.11,
                        2.28,
                        2.25,
                        2.31,
                        2.8,
                        2.49,
                        2.09,
                        2.18,
                        2.24,
                        1.95,
                        2.1,
                        2.36,
                        2.34,
                        2.5,
                        2.42,
                        2.75,
                        2.74,
                        3.05,
                        3.01,
                        3.32,
                        2.89,
                        3.19,
                        3.37,
                        3.52,
                        3.52,
                        3.83,
                        3.91,
                        4.13,
                        4.0,
                        4.27,
                        4.67,
                        4.89,
                        5.06,
                        4.72,
                        5.0,
                        5.47,
                        5.5,
                        5.36
                    ],
                    "marker": {
                        "fillColor": "#FFFFFF",
                        "lineColor": "darkblue",
                        "lineWidth": 2,
                        "radius": 5
                    },
                    "name": "Among core",
                    "type": "spline",
                    "yAxis": 1
                }
            ],
            "height_ratio": 69.23076923076923,
            "label_x": "Time (quarter)",
            "label_y": "Number of Contributors (thousand)",
            "label_y_secondary": "% Women (of total m + w)",
            "title": "Active Contributors in Maven Public Projects",
            "x_categories": [
                "2008-3",
                "2008-6",
                "2008-9",
                "2008-12",
                "2009-3",
                "2009-6",
                "2009-9",
                "2009-12",
                "2010-3",
                "2010-6",
                "2010-9",
                "2010-12",
                "2011-3",
                "2011-6",
                "2011-9",
                "2011-12",
                "2012-3",
                "2012-6",
                "2012-9",
                "2012-12",
                "2013-3",
                "2013-6",
                "2013-9",
                "2013-12",
                "2014-3",
                "2014-6",
                "2014-9",
                "2014-12",
                "2015-3",
                "2015-6",
                "2015-9",
                "2015-12",
                "2016-3",
                "2016-6",
                "2016-9",
                "2016-12",
                "2017-3",
                "2017-6",
                "2017-9",
                "2017-12",
                "2018-3",
                "2018-6",
                "2018-9",
                "2018-12",
                "2019-3"
            ]
        },
        "Maven_line": {
            "data": [
                {
                    "color": "#000000",
                    "data": [
                        3.11,
                        2.97,
                        3.72,
                        2.35,
                        2.31,
                        3.07,
                        2.51,
                        2.88,
                        2.45,
                        2.54,
                        2.45,
                        2.72,
                        2.33,
                        2.11,
                        2.2,
                        2.28,
                        1.95,
                        2.11,
                        2.54,
                        2.43,
                        2.45,
                        2.41,
                        2.7,
                        2.72,
                        2.96,
                        2.92,
                        3.07,
                        2.87,
                        3.02,
                        3.29,
                        3.43,
                        3.36,
                        3.72,
                        3.82,
                        3.92,
                        3.75,
                        4.02,
                        4.33,
                        4.67,
                        4.82,
                        4.53,
                        4.72,
                        5.13,
                        5.0,
                        5.09
                    ],
                    "name": "Among all",
                    "type": "spline",
                    "yAxis": 1
                }
            ],
            "height_ratio": 66.66666666666666,
            "label_x": "",
            "label_y": "",
            "label_y_secondary": "",
            "title": "",
            "x_categories": [
                "2008",
                "2008",
                "2008",
                "2008",
                "2009",
                "2009",
                "2009",
                "2009",
                "2010",
                "2010",
                "2010",
                "2010",
                "2011",
                "2011",
                "2011",
                "2011",
                "2012",
                "2012",
                "2012",
                "2012",
                "2013",
                "2013",
                "2013",
                "2013",
                "2014",
                "2014",
                "2014",
                "2014",
                "2015",
                "2015",
                "2015",
                "2015",
                "2016",
                "2016",
                "2016",
                "2016",
                "2017",
                "2017",
                "2017",
                "2017",
                "2018",
                "2018",
                "2018",
                "2018",
                "2019"
            ]
        },
        "Maven_women-bar": {
            "data": [
                {
                    "color": "#000000",
                    "data": [
                        8,
                        9,
                        12,
                        9,
                        11,
                        16,
                        14,
                        21,
                        23,
                        25,
                        30,
                        43,
                        47,
                        53,
                        66,
                        81,
                        89,
                        104,
                        147,
                        156,
                        204,
                        217,
                        275,
                        301,
                        375,
                        399,
                        450,
                        451,
                        539,
                        600,
                        640,
                        641,
                        752,
                        771,
                        767,
                        773,
                        873,
                        916,
                        955,
                        988,
                        911,
                        917,
                        949,
                        922,
                        876
                    ],
                    "name": "Women",
                    "type": "column",
                    "yAxis": 1
                }
            ],
            "height_ratio": 66.66666666666666,
            "label_x": "",
            "label_y": "",
            "label_y_secondary": "",
            "title": "",
            "x_categories": [
                "2008",
                "2008",
                "2008",
                "2008",
                "2009",
                "2009",
                "2009",
                "2009",
                "2010",
                "2010",
                "2010",
                "2010",
                "2011",
                "2011",
                "2011",
                "2011",
                "2012",
                "2012",
                "2012",
                "2012",
                "2013",
                "2013",
                "2013",
                "2013",
                "2014",
                "2014",
                "2014",
                "2014",
                "2015",
                "2015",
                "2015",
                "2015",
                "2016",
                "2016",
                "2016",
                "2016",
                "2017",
                "2017",
                "2017",
                "2017",
                "2018",
                "2018",
                "2018",
                "2018",
                "2019"
            ]
        },
        "Meteor": {
            "data": [
                {
                    "color": "blanchedalmond",
                    "data": [
                        0.015,
                        0.017,
                        0.019,
                        0.022,
                        0.025,
                        0.022,
                        0.024,
                        0.024,
                        0.026,
                        0.03,
                        0.067,
                        0.064,
                        0.088,
                        0.12,
                        0.137,
                        0.234,
                        0.298,
                        0.46,
                        0.603,
                        0.735,
                        1.156,
                        1.468,
                        1.926,
                        2.303,
                        2.825,
                        3.069,
                        3.484,
                        4.111,
                        4.772,
                        4.89,
                        4.884,
                        4.811,
                        4.762,
                        3.95,
                        3.467,
                        3.205,
                        3.004,
                        2.42,
                        2.042,
                        2.067,
                        1.73,
                        1.494,
                        1.4,
                        1.306,
                        1.166
                    ],
                    "name": "All Unknown",
                    "type": "column"
                },
                {
                    "color": "#f29d4b",
                    "data": [
                        0.014,
                        0.014,
                        0.016,
                        0.018,
                        0.019,
                        0.02,
                        0.023,
                        0.022,
                        0.024,
                        0.024,
                        0.057,
                        0.058,
                        0.072,
                        0.098,
                        0.11,
                        0.195,
                        0.244,
                        0.384,
                        0.494,
                        0.614,
                        0.93,
                        1.197,
                        1.497,
                        1.817,
                        2.2,
                        2.404,
                        2.73,
                        3.167,
                        3.638,
                        3.694,
                        3.685,
                        3.552,
                        3.582,
                        2.928,
                        2.531,
                        2.33,
                        2.243,
                        1.754,
                        1.437,
                        1.484,
                        1.208,
                        1.046,
                        0.965,
                        0.893,
                        0.813
                    ],
                    "name": "All Men",
                    "type": "column"
                },
                {
                    "color": "#de2d26",
                    "data": [
                        0.0,
                        0.0,
                        0.0,
                        0.001,
                        0.001,
                        0.002,
                        0.001,
                        0.001,
                        0.001,
                        0.001,
                        0.002,
                        0.001,
                        0.003,
                        0.002,
                        0.002,
                        0.003,
                        0.003,
                        0.007,
                        0.007,
                        0.019,
                        0.029,
                        0.029,
                        0.041,
                        0.049,
                        0.059,
                        0.064,
                        0.077,
                        0.086,
                        0.086,
                        0.112,
                        0.123,
                        0.109,
                        0.124,
                        0.111,
                        0.101,
                        0.089,
                        0.084,
                        0.07,
                        0.06,
                        0.068,
                        0.048,
                        0.04,
                        0.052,
                        0.042,
                        0.039
                    ],
                    "name": "All Women",
                    "type": "column"
                },
                {
                    "color": "darkblue",
                    "data": [
                        0.0,
                        0.0,
                        0.0,
                        5.56,
                        5.26,
                        10.0,
                        4.35,
                        4.55,
                        4.17,
                        4.17,
                        3.51,
                        1.72,
                        4.17,
                        2.04,
                        1.82,
                        1.54,
                        1.23,
                        1.82,
                        1.42,
                        3.09,
                        3.12,
                        2.42,
                        2.74,
                        2.7,
                        2.68,
                        2.66,
                        2.82,
                        2.72,
                        2.36,
                        3.03,
                        3.34,
                        3.07,
                        3.46,
                        3.79,
                        3.99,
                        3.82,
                        3.74,
                        3.99,
                        4.18,
                        4.58,
                        3.97,
                        3.82,
                        5.39,
                        4.7,
                        4.8
                    ],
                    "name": "Among all",
                    "type": "spline",
                    "yAxis": 1
                },
                {
                    "color": "darkblue",
                    "data": [
                        0.0,
                        0.0,
                        0.0,
                        5.56,
                        5.26,
                        10.0,
                        4.35,
                        4.55,
                        4.17,
                        4.17,
                        3.51,
                        1.72,
                        4.17,
                        2.04,
                        1.82,
                        1.54,
                        1.23,
                        1.82,
                        1.43,
                        3.13,
                        3.06,
                        2.41,
                        2.75,
                        2.71,
                        2.76,
                        2.69,
                        2.76,
                        2.6,
                        2.42,
                        3.08,
                        3.55,
                        3.18,
                        3.68,
                        3.76,
                        3.96,
                        3.62,
                        3.71,
                        4.0,
                        3.75,
                        4.37,
                        3.84,
                        3.59,
                        5.19,
                        4.42,
                        4.57
                    ],
                    "marker": {
                        "fillColor": "#FFFFFF",
                        "lineColor": "darkblue",
                        "lineWidth": 2,
                        "radius": 5
                    },
                    "name": "Among core",
                    "type": "spline",
                    "yAxis": 1
                }
            ],
            "height_ratio": 69.23076923076923,
            "label_x": "Time (quarter)",
            "label_y": "Number of Contributors (thousand)",
            "label_y_secondary": "% Women (of total m + w)",
            "title": "Active Contributors in Meteor Public Projects",
            "x_categories": [
                "2008-3",
                "2008-6",
                "2008-9",
                "2008-12",
                "2009-3",
                "2009-6",
                "2009-9",
                "2009-12",
                "2010-3",
                "2010-6",
                "2010-9",
                "2010-12",
                "2011-3",
                "2011-6",
                "2011-9",
                "2011-12",
                "2012-3",
                "2012-6",
                "2012-9",
                "2012-12",
                "2013-3",
                "2013-6",
                "2013-9",
                "2013-12",
                "2014-3",
                "2014-6",
                "2014-9",
                "2014-12",
                "2015-3",
                "2015-6",
                "2015-9",
                "2015-12",
                "2016-3",
                "2016-6",
                "2016-9",
                "2016-12",
                "2017-3",
                "2017-6",
                "2017-9",
                "2017-12",
                "2018-3",
                "2018-6",
                "2018-9",
                "2018-12",
                "2019-3"
            ]
        },
        "Meteor_line": {
            "data": [
                {
                    "color": "#585CFE",
                    "data": [
                        0.0,
                        0.0,
                        0.0,
                        5.56,
                        5.26,
                        10.0,
                        4.35,
                        4.55,
                        4.17,
                        4.17,
                        3.51,
                        1.72,
                        4.17,
                        2.04,
                        1.82,
                        1.54,
                        1.23,
                        1.82,
                        1.42,
                        3.09,
                        3.12,
                        2.42,
                        2.74,
                        2.7,
                        2.68,
                        2.66,
                        2.82,
                        2.72,
                        2.36,
                        3.03,
                        3.34,
                        3.07,
                        3.46,
                        3.79,
                        3.99,
                        3.82,
                        3.74,
                        3.99,
                        4.18,
                        4.58,
                        3.97,
                        3.82,
                        5.39,
                        4.7,
                        4.8
                    ],
                    "name": "Among all",
                    "type": "spline",
                    "yAxis": 1
                }
            ],
            "height_ratio": 66.66666666666666,
            "label_x": "",
            "label_y": "",
            "label_y_secondary": "",
            "title": "",
            "x_categories": [
                "2008",
                "2008",
                "2008",
                "2008",
                "2009",
                "2009",
                "2009",
                "2009",
                "2010",
                "2010",
                "2010",
                "2010",
                "2011",
                "2011",
                "2011",
                "2011",
                "2012",
                "2012",
                "2012",
                "2012",
                "2013",
                "2013",
                "2013",
                "2013",
                "2014",
                "2014",
                "2014",
                "2014",
                "2015",
                "2015",
                "2015",
                "2015",
                "2016",
                "2016",
                "2016",
                "2016",
                "2017",
                "2017",
                "2017",
                "2017",
                "2018",
                "2018",
                "2018",
                "2018",
                "2019"
            ]
        },
        "Meteor_women-bar": {
            "data": [
                {
                    "color": "#585CFE",
                    "data": [
                        0,
                        0,
                        0,
                        1,
                        1,
                        2,
                        1,
                        1,
                        1,
                        1,
                        2,
                        1,
                        3,
                        2,
                        2,
                        3,
                        3,
                        7,
                        7,
                        19,
                        29,
                        29,
                        41,
                        49,
                        59,
                        64,
                        77,
                        86,
                        86,
                        112,
                        123,
                        109,
                        124,
                        111,
                        101,
                        89,
                        84,
                        70,
                        60,
                        68,
                        48,
                        40,
                        52,
                        42,
                        39
                    ],
                    "name": "Women",
                    "type": "column",
                    "yAxis": 1
                }
            ],
            "height_ratio": 66.66666666666666,
            "label_x": "",
            "label_y": "",
            "label_y_secondary": "",
            "title": "",
            "x_categories": [
                "2008",
                "2008",
                "2008",
                "2008",
                "2009",
                "2009",
                "2009",
                "2009",
                "2010",
                "2010",
                "2010",
                "2010",
                "2011",
                "2011",
                "2011",
                "2011",
                "2012",
                "2012",
                "2012",
                "2012",
                "2013",
                "2013",
                "2013",
                "2013",
                "2014",
                "2014",
                "2014",
                "2014",
                "2015",
                "2015",
                "2015",
                "2015",
                "2016",
                "2016",
                "2016",
                "2016",
                "2017",
                "2017",
                "2017",
                "2017",
                "2018",
                "2018",
                "2018",
                "2018",
                "2019"
            ]
        },
        "NPM": {
            "data": [
                {
                    "color": "blanchedalmond",
                    "data": [
                        0.262,
                        0.42,
                        0.486,
                        0.502,
                        0.628,
                        0.568,
                        0.626,
                        0.744,
                        0.993,
                        1.26,
                        1.852,
                        2.317,
                        3.081,
                        4.381,
                        5.342,
                        6.306,
                        8.695,
                        9.544,
                        11.747,
                        12.931,
                        17.662,
                        19.656,
                        23.221,
                        26.258,
                        31.666,
                        34.524,
                        38.058,
                        41.476,
                        49.595,
                        53.078,
                        56.052,
                        61.334,
                        69.41,
                        71.813,
                        73.203,
                        79.526,
                        85.875,
                        89.859,
                        95.087,
                        100.009,
                        104.732,
                        105.924,
                        106.549,
                        110.791,
                        109.115
                    ],
                    "name": "All Unknown",
                    "type": "column"
                },
                {
                    "color": "#f29d4b",
                    "data": [
                        0.206,
                        0.333,
                        0.382,
                        0.403,
                        0.492,
                        0.457,
                        0.499,
                        0.59,
                        0.777,
                        0.986,
                        1.411,
                        1.789,
                        2.448,
                        3.467,
                        4.188,
                        5.086,
                        6.925,
                        7.549,
                        9.139,
                        10.041,
                        13.614,
                        15.078,
                        17.556,
                        19.721,
                        23.834,
                        25.979,
                        28.323,
                        30.796,
                        36.643,
                        39.089,
                        41.036,
                        44.524,
                        50.588,
                        51.901,
                        52.175,
                        55.894,
                        60.673,
                        62.734,
                        65.251,
                        68.053,
                        70.902,
                        70.978,
                        70.078,
                        72.302,
                        70.805
                    ],
                    "name": "All Men",
                    "type": "column"
                },
                {
                    "color": "#de2d26",
                    "data": [
                        0.006,
                        0.006,
                        0.009,
                        0.011,
                        0.01,
                        0.013,
                        0.015,
                        0.013,
                        0.012,
                        0.023,
                        0.033,
                        0.039,
                        0.052,
                        0.062,
                        0.088,
                        0.094,
                        0.122,
                        0.152,
                        0.198,
                        0.207,
                        0.303,
                        0.339,
                        0.467,
                        0.52,
                        0.638,
                        0.744,
                        0.89,
                        0.951,
                        1.19,
                        1.391,
                        1.464,
                        1.647,
                        1.914,
                        2.035,
                        2.184,
                        2.324,
                        2.595,
                        2.824,
                        3.071,
                        3.223,
                        3.341,
                        3.54,
                        3.656,
                        3.76,
                        3.693
                    ],
                    "name": "All Women",
                    "type": "column"
                },
                {
                    "color": "darkblue",
                    "data": [
                        2.91,
                        1.8,
                        2.36,
                        2.73,
                        2.03,
                        2.84,
                        3.01,
                        2.2,
                        1.54,
                        2.33,
                        2.34,
                        2.18,
                        2.12,
                        1.79,
                        2.1,
                        1.85,
                        1.76,
                        2.01,
                        2.17,
                        2.06,
                        2.23,
                        2.25,
                        2.66,
                        2.64,
                        2.68,
                        2.86,
                        3.14,
                        3.09,
                        3.25,
                        3.56,
                        3.57,
                        3.7,
                        3.78,
                        3.92,
                        4.19,
                        4.16,
                        4.28,
                        4.5,
                        4.71,
                        4.74,
                        4.71,
                        4.99,
                        5.22,
                        5.2,
                        5.22
                    ],
                    "name": "Among all",
                    "type": "spline",
                    "yAxis": 1
                },
                {
                    "color": "darkblue",
                    "data": [
                        2.93,
                        1.8,
                        2.35,
                        2.73,
                        2.04,
                        2.86,
                        3.01,
                        2.23,
                        1.56,
                        2.37,
                        2.33,
                        2.19,
                        2.13,
                        1.83,
                        1.98,
                        1.84,
                        1.85,
                        2.11,
                        2.22,
                        2.11,
                        2.29,
                        2.32,
                        2.79,
                        2.77,
                        2.77,
                        2.92,
                        3.17,
                        3.11,
                        3.35,
                        3.66,
                        3.69,
                        3.83,
                        3.89,
                        4.05,
                        4.39,
                        4.37,
                        4.48,
                        4.69,
                        4.94,
                        5.02,
                        4.92,
                        5.31,
                        5.44,
                        5.52,
                        5.51
                    ],
                    "marker": {
                        "fillColor": "#FFFFFF",
                        "lineColor": "darkblue",
                        "lineWidth": 2,
                        "radius": 5
                    },
                    "name": "Among core",
                    "type": "spline",
                    "yAxis": 1
                }
            ],
            "height_ratio": 69.23076923076923,
            "label_x": "Time (quarter)",
            "label_y": "Number of Contributors (thousand)",
            "label_y_secondary": "% Women (of total m + w)",
            "title": "Active Contributors in NPM Public Projects",
            "x_categories": [
                "2008-3",
                "2008-6",
                "2008-9",
                "2008-12",
                "2009-3",
                "2009-6",
                "2009-9",
                "2009-12",
                "2010-3",
                "2010-6",
                "2010-9",
                "2010-12",
                "2011-3",
                "2011-6",
                "2011-9",
                "2011-12",
                "2012-3",
                "2012-6",
                "2012-9",
                "2012-12",
                "2013-3",
                "2013-6",
                "2013-9",
                "2013-12",
                "2014-3",
                "2014-6",
                "2014-9",
                "2014-12",
                "2015-3",
                "2015-6",
                "2015-9",
                "2015-12",
                "2016-3",
                "2016-6",
                "2016-9",
                "2016-12",
                "2017-3",
                "2017-6",
                "2017-9",
                "2017-12",
                "2018-3",
                "2018-6",
                "2018-9",
                "2018-12",
                "2019-3"
            ]
        },
        "NPM_line": {
            "data": [
                {
                    "color": "#CB3837",
                    "data": [
                        2.91,
                        1.8,
                        2.36,
                        2.73,
                        2.03,
                        2.84,
                        3.01,
                        2.2,
                        1.54,
                        2.33,
                        2.34,
                        2.18,
                        2.12,
                        1.79,
                        2.1,
                        1.85,
                        1.76,
                        2.01,
                        2.17,
                        2.06,
                        2.23,
                        2.25,
                        2.66,
                        2.64,
                        2.68,
                        2.86,
                        3.14,
                        3.09,
                        3.25,
                        3.56,
                        3.57,
                        3.7,
                        3.78,
                        3.92,
                        4.19,
                        4.16,
                        4.28,
                        4.5,
                        4.71,
                        4.74,
                        4.71,
                        4.99,
                        5.22,
                        5.2,
                        5.22
                    ],
                    "name": "Among all",
                    "type": "spline",
                    "yAxis": 1
                }
            ],
            "height_ratio": 66.66666666666666,
            "label_x": "",
            "label_y": "",
            "label_y_secondary": "",
            "title": "",
            "x_categories": [
                "2008",
                "2008",
                "2008",
                "2008",
                "2009",
                "2009",
                "2009",
                "2009",
                "2010",
                "2010",
                "2010",
                "2010",
                "2011",
                "2011",
                "2011",
                "2011",
                "2012",
                "2012",
                "2012",
                "2012",
                "2013",
                "2013",
                "2013",
                "2013",
                "2014",
                "2014",
                "2014",
                "2014",
                "2015",
                "2015",
                "2015",
                "2015",
                "2016",
                "2016",
                "2016",
                "2016",
                "2017",
                "2017",
                "2017",
                "2017",
                "2018",
                "2018",
                "2018",
                "2018",
                "2019"
            ]
        },
        "NPM_women-bar": {
            "data": [
                {
                    "color": "#CB3837",
                    "data": [
                        6,
                        6,
                        9,
                        11,
                        10,
                        13,
                        15,
                        13,
                        12,
                        23,
                        33,
                        39,
                        52,
                        62,
                        88,
                        94,
                        122,
                        152,
                        198,
                        207,
                        303,
                        339,
                        467,
                        520,
                        638,
                        744,
                        890,
                        951,
                        1190,
                        1391,
                        1464,
                        1647,
                        1914,
                        2035,
                        2184,
                        2324,
                        2595,
                        2824,
                        3071,
                        3223,
                        3341,
                        3540,
                        3656,
                        3760,
                        3693
                    ],
                    "name": "Women",
                    "type": "column",
                    "yAxis": 1
                }
            ],
            "height_ratio": 66.66666666666666,
            "label_x": "",
            "label_y": "",
            "label_y_secondary": "",
            "title": "",
            "x_categories": [
                "2008",
                "2008",
                "2008",
                "2008",
                "2009",
                "2009",
                "2009",
                "2009",
                "2010",
                "2010",
                "2010",
                "2010",
                "2011",
                "2011",
                "2011",
                "2011",
                "2012",
                "2012",
                "2012",
                "2012",
                "2013",
                "2013",
                "2013",
                "2013",
                "2014",
                "2014",
                "2014",
                "2014",
                "2015",
                "2015",
                "2015",
                "2015",
                "2016",
                "2016",
                "2016",
                "2016",
                "2017",
                "2017",
                "2017",
                "2017",
                "2018",
                "2018",
                "2018",
                "2018",
                "2019"
            ]
        },
        "NuGet": {
            "data": [
                {
                    "color": "blanchedalmond",
                    "data": [
                        0.117,
                        0.13,
                        0.187,
                        0.242,
                        0.246,
                        0.236,
                        0.29,
                        0.353,
                        0.443,
                        0.515,
                        0.598,
                        0.691,
                        0.935,
                        1.258,
                        1.568,
                        1.821,
                        2.513,
                        2.663,
                        3.256,
                        3.635,
                        4.911,
                        5.403,
                        6.257,
                        6.875,
                        7.954,
                        8.611,
                        9.243,
                        9.991,
                        11.59,
                        11.902,
                        11.891,
                        12.348,
                        13.659,
                        13.489,
                        13.585,
                        14.227,
                        15.226,
                        15.389,
                        15.727,
                        16.096,
                        16.517,
                        16.507,
                        16.475,
                        17.249,
                        17.283
                    ],
                    "name": "All Unknown",
                    "type": "column"
                },
                {
                    "color": "#f29d4b",
                    "data": [
                        0.065,
                        0.08,
                        0.102,
                        0.135,
                        0.144,
                        0.154,
                        0.179,
                        0.247,
                        0.309,
                        0.368,
                        0.44,
                        0.514,
                        0.724,
                        0.995,
                        1.241,
                        1.447,
                        1.999,
                        2.095,
                        2.571,
                        2.82,
                        3.831,
                        4.19,
                        4.754,
                        5.24,
                        6.042,
                        6.507,
                        6.917,
                        7.429,
                        8.605,
                        8.7,
                        8.697,
                        8.947,
                        9.951,
                        9.651,
                        9.632,
                        10.058,
                        10.719,
                        10.633,
                        10.849,
                        11.068,
                        11.284,
                        11.115,
                        11.014,
                        11.441,
                        11.355
                    ],
                    "name": "All Men",
                    "type": "column"
                },
                {
                    "color": "#de2d26",
                    "data": [
                        0.001,
                        0.002,
                        0.001,
                        0.001,
                        0.003,
                        0.003,
                        0.003,
                        0.002,
                        0.004,
                        0.008,
                        0.008,
                        0.009,
                        0.012,
                        0.016,
                        0.025,
                        0.019,
                        0.025,
                        0.028,
                        0.048,
                        0.063,
                        0.074,
                        0.076,
                        0.103,
                        0.117,
                        0.136,
                        0.133,
                        0.169,
                        0.169,
                        0.199,
                        0.224,
                        0.251,
                        0.263,
                        0.275,
                        0.301,
                        0.297,
                        0.315,
                        0.31,
                        0.335,
                        0.365,
                        0.351,
                        0.371,
                        0.372,
                        0.348,
                        0.395,
                        0.391
                    ],
                    "name": "All Women",
                    "type": "column"
                },
                {
                    "color": "darkblue",
                    "data": [
                        1.54,
                        2.5,
                        0.98,
                        0.74,
                        2.08,
                        1.95,
                        1.68,
                        0.81,
                        1.29,
                        2.17,
                        1.82,
                        1.75,
                        1.66,
                        1.61,
                        2.01,
                        1.31,
                        1.25,
                        1.34,
                        1.87,
                        2.23,
                        1.93,
                        1.81,
                        2.17,
                        2.23,
                        2.25,
                        2.04,
                        2.44,
                        2.27,
                        2.31,
                        2.57,
                        2.89,
                        2.94,
                        2.76,
                        3.12,
                        3.08,
                        3.13,
                        2.89,
                        3.15,
                        3.36,
                        3.17,
                        3.29,
                        3.35,
                        3.16,
                        3.45,
                        3.44
                    ],
                    "name": "Among all",
                    "type": "spline",
                    "yAxis": 1
                },
                {
                    "color": "darkblue",
                    "data": [
                        1.59,
                        2.6,
                        1.05,
                        0.8,
                        2.33,
                        2.26,
                        1.89,
                        0.91,
                        1.41,
                        2.42,
                        2.02,
                        1.92,
                        1.7,
                        1.74,
                        2.03,
                        1.54,
                        1.27,
                        1.47,
                        2.16,
                        2.54,
                        1.95,
                        1.88,
                        2.34,
                        2.44,
                        2.48,
                        2.18,
                        2.68,
                        2.52,
                        2.49,
                        2.86,
                        3.22,
                        3.19,
                        3.06,
                        3.52,
                        3.39,
                        3.45,
                        3.2,
                        3.58,
                        3.73,
                        3.72,
                        3.57,
                        3.65,
                        3.41,
                        3.91,
                        3.86
                    ],
                    "marker": {
                        "fillColor": "#FFFFFF",
                        "lineColor": "darkblue",
                        "lineWidth": 2,
                        "radius": 5
                    },
                    "name": "Among core",
                    "type": "spline",
                    "yAxis": 1
                }
            ],
            "height_ratio": 69.23076923076923,
            "label_x": "Time (quarter)",
            "label_y": "Number of Contributors (thousand)",
            "label_y_secondary": "% Women (of total m + w)",
            "title": "Active Contributors in NuGet Public Projects",
            "x_categories": [
                "2008-3",
                "2008-6",
                "2008-9",
                "2008-12",
                "2009-3",
                "2009-6",
                "2009-9",
                "2009-12",
                "2010-3",
                "2010-6",
                "2010-9",
                "2010-12",
                "2011-3",
                "2011-6",
                "2011-9",
                "2011-12",
                "2012-3",
                "2012-6",
                "2012-9",
                "2012-12",
                "2013-3",
                "2013-6",
                "2013-9",
                "2013-12",
                "2014-3",
                "2014-6",
                "2014-9",
                "2014-12",
                "2015-3",
                "2015-6",
                "2015-9",
                "2015-12",
                "2016-3",
                "2016-6",
                "2016-9",
                "2016-12",
                "2017-3",
                "2017-6",
                "2017-9",
                "2017-12",
                "2018-3",
                "2018-6",
                "2018-9",
                "2018-12",
                "2019-3"
            ]
        },
        "NuGet_line": {
            "data": [
                {
                    "color": "#004880",
                    "data": [
                        1.54,
                        2.5,
                        0.98,
                        0.74,
                        2.08,
                        1.95,
                        1.68,
                        0.81,
                        1.29,
                        2.17,
                        1.82,
                        1.75,
                        1.66,
                        1.61,
                        2.01,
                        1.31,
                        1.25,
                        1.34,
                        1.87,
                        2.23,
                        1.93,
                        1.81,
                        2.17,
                        2.23,
                        2.25,
                        2.04,
                        2.44,
                        2.27,
                        2.31,
                        2.57,
                        2.89,
                        2.94,
                        2.76,
                        3.12,
                        3.08,
                        3.13,
                        2.89,
                        3.15,
                        3.36,
                        3.17,
                        3.29,
                        3.35,
                        3.16,
                        3.45,
                        3.44
                    ],
                    "name": "Among all",
                    "type": "spline",
                    "yAxis": 1
                }
            ],
            "height_ratio": 66.66666666666666,
            "label_x": "",
            "label_y": "",
            "label_y_secondary": "",
            "title": "",
            "x_categories": [
                "2008",
                "2008",
                "2008",
                "2008",
                "2009",
                "2009",
                "2009",
                "2009",
                "2010",
                "2010",
                "2010",
                "2010",
                "2011",
                "2011",
                "2011",
                "2011",
                "2012",
                "2012",
                "2012",
                "2012",
                "2013",
                "2013",
                "2013",
                "2013",
                "2014",
                "2014",
                "2014",
                "2014",
                "2015",
                "2015",
                "2015",
                "2015",
                "2016",
                "2016",
                "2016",
                "2016",
                "2017",
                "2017",
                "2017",
                "2017",
                "2018",
                "2018",
                "2018",
                "2018",
                "2019"
            ]
        },
        "NuGet_women-bar": {
            "data": [
                {
                    "color": "#004880",
                    "data": [
                        1,
                        2,
                        1,
                        1,
                        3,
                        3,
                        3,
                        2,
                        4,
                        8,
                        8,
                        9,
                        12,
                        16,
                        25,
                        19,
                        25,
                        28,
                        48,
                        63,
                        74,
                        76,
                        103,
                        117,
                        136,
                        133,
                        169,
                        169,
                        199,
                        224,
                        251,
                        263,
                        275,
                        301,
                        297,
                        315,
                        310,
                        335,
                        365,
                        351,
                        371,
                        372,
                        348,
                        395,
                        391
                    ],
                    "name": "Women",
                    "type": "column",
                    "yAxis": 1
                }
            ],
            "height_ratio": 66.66666666666666,
            "label_x": "",
            "label_y": "",
            "label_y_secondary": "",
            "title": "",
            "x_categories": [
                "2008",
                "2008",
                "2008",
                "2008",
                "2009",
                "2009",
                "2009",
                "2009",
                "2010",
                "2010",
                "2010",
                "2010",
                "2011",
                "2011",
                "2011",
                "2011",
                "2012",
                "2012",
                "2012",
                "2012",
                "2013",
                "2013",
                "2013",
                "2013",
                "2014",
                "2014",
                "2014",
                "2014",
                "2015",
                "2015",
                "2015",
                "2015",
                "2016",
                "2016",
                "2016",
                "2016",
                "2017",
                "2017",
                "2017",
                "2017",
                "2018",
                "2018",
                "2018",
                "2018",
                "2019"
            ]
        },
        "Packagist": {
            "data": [
                {
                    "color": "blanchedalmond",
                    "data": [
                        0.299,
                        0.284,
                        0.313,
                        0.328,
                        0.399,
                        0.485,
                        0.56,
                        0.594,
                        0.716,
                        0.822,
                        0.996,
                        1.225,
                        1.636,
                        2.06,
                        2.64,
                        3.183,
                        4.366,
                        4.851,
                        6.293,
                        6.799,
                        9.153,
                        10.349,
                        12.029,
                        13.389,
                        15.648,
                        16.35,
                        17.681,
                        18.875,
                        21.873,
                        22.643,
                        22.733,
                        24.163,
                        26.447,
                        26.65,
                        26.676,
                        27.977,
                        30.615,
                        29.742,
                        30.365,
                        31.296,
                        32.564,
                        31.05,
                        30.971,
                        31.65,
                        31.059
                    ],
                    "name": "All Unknown",
                    "type": "column"
                },
                {
                    "color": "#f29d4b",
                    "data": [
                        0.215,
                        0.2,
                        0.229,
                        0.246,
                        0.31,
                        0.375,
                        0.425,
                        0.45,
                        0.53,
                        0.627,
                        0.767,
                        0.971,
                        1.288,
                        1.638,
                        2.105,
                        2.509,
                        3.374,
                        3.765,
                        4.888,
                        5.234,
                        6.951,
                        7.828,
                        8.972,
                        9.856,
                        11.526,
                        11.958,
                        12.893,
                        13.639,
                        15.884,
                        16.195,
                        16.182,
                        17.046,
                        18.547,
                        18.485,
                        18.364,
                        18.963,
                        20.724,
                        19.609,
                        19.989,
                        20.471,
                        21.463,
                        19.969,
                        19.827,
                        20.307,
                        19.867
                    ],
                    "name": "All Men",
                    "type": "column"
                },
                {
                    "color": "#de2d26",
                    "data": [
                        0.002,
                        0.0,
                        0.002,
                        0.003,
                        0.004,
                        0.006,
                        0.008,
                        0.004,
                        0.007,
                        0.01,
                        0.011,
                        0.011,
                        0.017,
                        0.017,
                        0.026,
                        0.045,
                        0.057,
                        0.071,
                        0.09,
                        0.106,
                        0.157,
                        0.167,
                        0.205,
                        0.237,
                        0.279,
                        0.281,
                        0.335,
                        0.367,
                        0.396,
                        0.445,
                        0.455,
                        0.471,
                        0.5,
                        0.536,
                        0.547,
                        0.568,
                        0.624,
                        0.599,
                        0.586,
                        0.658,
                        0.667,
                        0.696,
                        0.645,
                        0.698,
                        0.677
                    ],
                    "name": "All Women",
                    "type": "column"
                },
                {
                    "color": "darkblue",
                    "data": [
                        0.93,
                        0.0,
                        0.87,
                        1.22,
                        1.29,
                        1.6,
                        1.88,
                        0.89,
                        1.32,
                        1.59,
                        1.43,
                        1.13,
                        1.32,
                        1.04,
                        1.24,
                        1.79,
                        1.69,
                        1.89,
                        1.84,
                        2.03,
                        2.26,
                        2.13,
                        2.28,
                        2.4,
                        2.42,
                        2.35,
                        2.6,
                        2.69,
                        2.49,
                        2.75,
                        2.81,
                        2.76,
                        2.7,
                        2.9,
                        2.98,
                        3.0,
                        3.01,
                        3.05,
                        2.93,
                        3.21,
                        3.11,
                        3.49,
                        3.25,
                        3.44,
                        3.41
                    ],
                    "name": "Among all",
                    "type": "spline",
                    "yAxis": 1
                },
                {
                    "color": "darkblue",
                    "data": [
                        0.97,
                        0.0,
                        0.92,
                        1.27,
                        1.34,
                        1.66,
                        1.97,
                        0.94,
                        1.39,
                        1.69,
                        1.51,
                        1.19,
                        1.39,
                        0.99,
                        1.32,
                        1.67,
                        1.67,
                        1.96,
                        1.92,
                        2.08,
                        2.15,
                        2.04,
                        2.27,
                        2.46,
                        2.38,
                        2.35,
                        2.6,
                        2.75,
                        2.66,
                        2.85,
                        2.96,
                        2.87,
                        2.78,
                        3.08,
                        3.21,
                        3.09,
                        2.93,
                        3.15,
                        2.98,
                        3.13,
                        3.2,
                        3.67,
                        3.33,
                        3.5,
                        3.53
                    ],
                    "marker": {
                        "fillColor": "#FFFFFF",
                        "lineColor": "darkblue",
                        "lineWidth": 2,
                        "radius": 5
                    },
                    "name": "Among core",
                    "type": "spline",
                    "yAxis": 1
                }
            ],
            "height_ratio": 69.23076923076923,
            "label_x": "Time (quarter)",
            "label_y": "Number of Contributors (thousand)",
            "label_y_secondary": "% Women (of total m + w)",
            "title": "Active Contributors in Packagist Public Projects",
            "x_categories": [
                "2008-3",
                "2008-6",
                "2008-9",
                "2008-12",
                "2009-3",
                "2009-6",
                "2009-9",
                "2009-12",
                "2010-3",
                "2010-6",
                "2010-9",
                "2010-12",
                "2011-3",
                "2011-6",
                "2011-9",
                "2011-12",
                "2012-3",
                "2012-6",
                "2012-9",
                "2012-12",
                "2013-3",
                "2013-6",
                "2013-9",
                "2013-12",
                "2014-3",
                "2014-6",
                "2014-9",
                "2014-12",
                "2015-3",
                "2015-6",
                "2015-9",
                "2015-12",
                "2016-3",
                "2016-6",
                "2016-9",
                "2016-12",
                "2017-3",
                "2017-6",
                "2017-9",
                "2017-12",
                "2018-3",
                "2018-6",
                "2018-9",
                "2018-12",
                "2019-3"
            ]
        },
        "Packagist_line": {
            "data": [
                {
                    "color": "#BB522D",
                    "data": [
                        0.93,
                        0.0,
                        0.87,
                        1.22,
                        1.29,
                        1.6,
                        1.88,
                        0.89,
                        1.32,
                        1.59,
                        1.43,
                        1.13,
                        1.32,
                        1.04,
                        1.24,
                        1.79,
                        1.69,
                        1.89,
                        1.84,
                        2.03,
                        2.26,
                        2.13,
                        2.28,
                        2.4,
                        2.42,
                        2.35,
                        2.6,
                        2.69,
                        2.49,
                        2.75,
                        2.81,
                        2.76,
                        2.7,
                        2.9,
                        2.98,
                        3.0,
                        3.01,
                        3.05,
                        2.93,
                        3.21,
                        3.11,
                        3.49,
                        3.25,
                        3.44,
                        3.41
                    ],
                    "name": "Among all",
                    "type": "spline",
                    "yAxis": 1
                }
            ],
            "height_ratio": 66.66666666666666,
            "label_x": "",
            "label_y": "",
            "label_y_secondary": "",
            "title": "",
            "x_categories": [
                "2008",
                "2008",
                "2008",
                "2008",
                "2009",
                "2009",
                "2009",
                "2009",
                "2010",
                "2010",
                "2010",
                "2010",
                "2011",
                "2011",
                "2011",
                "2011",
                "2012",
                "2012",
                "2012",
                "2012",
                "2013",
                "2013",
                "2013",
                "2013",
                "2014",
                "2014",
                "2014",
                "2014",
                "2015",
                "2015",
                "2015",
                "2015",
                "2016",
                "2016",
                "2016",
                "2016",
                "2017",
                "2017",
                "2017",
                "2017",
                "2018",
                "2018",
                "2018",
                "2018",
                "2019"
            ]
        },
        "Packagist_women-bar": {
            "data": [
                {
                    "color": "#BB522D",
                    "data": [
                        2,
                        0,
                        2,
                        3,
                        4,
                        6,
                        8,
                        4,
                        7,
                        10,
                        11,
                        11,
                        17,
                        17,
                        26,
                        45,
                        57,
                        71,
                        90,
                        106,
                        157,
                        167,
                        205,
                        237,
                        279,
                        281,
                        335,
                        367,
                        396,
                        445,
                        455,
                        471,
                        500,
                        536,
                        547,
                        568,
                        624,
                        599,
                        586,
                        658,
                        667,
                        696,
                        645,
                        698,
                        677
                    ],
                    "name": "Women",
                    "type": "column",
                    "yAxis": 1
                }
            ],
            "height_ratio": 66.66666666666666,
            "label_x": "",
            "label_y": "",
            "label_y_secondary": "",
            "title": "",
            "x_categories": [
                "2008",
                "2008",
                "2008",
                "2008",
                "2009",
                "2009",
                "2009",
                "2009",
                "2010",
                "2010",
                "2010",
                "2010",
                "2011",
                "2011",
                "2011",
                "2011",
                "2012",
                "2012",
                "2012",
                "2012",
                "2013",
                "2013",
                "2013",
                "2013",
                "2014",
                "2014",
                "2014",
                "2014",
                "2015",
                "2015",
                "2015",
                "2015",
                "2016",
                "2016",
                "2016",
                "2016",
                "2017",
                "2017",
                "2017",
                "2017",
                "2018",
                "2018",
                "2018",
                "2018",
                "2019"
            ]
        },
        "PlatformIO": {
            "data": [
                {
                    "color": "blanchedalmond",
                    "data": [
                        0.0,
                        0.002,
                        0.0,
                        0.001,
                        0.004,
                        0.005,
                        0.006,
                        0.007,
                        0.009,
                        0.005,
                        0.01,
                        0.017,
                        0.019,
                        0.023,
                        0.035,
                        0.053,
                        0.069,
                        0.092,
                        0.094,
                        0.119,
                        0.139,
                        0.152,
                        0.179,
                        0.224,
                        0.281,
                        0.31,
                        0.316,
                        0.35,
                        0.482,
                        0.567,
                        0.613,
                        0.773,
                        1.028,
                        0.931,
                        0.924,
                        1.076,
                        1.185,
                        1.193,
                        1.184,
                        1.332,
                        1.546,
                        1.441,
                        1.6,
                        1.563,
                        1.65
                    ],
                    "name": "All Unknown",
                    "type": "column"
                },
                {
                    "color": "#f29d4b",
                    "data": [
                        0.0,
                        0.002,
                        0.0,
                        0.001,
                        0.002,
                        0.003,
                        0.001,
                        0.003,
                        0.005,
                        0.005,
                        0.005,
                        0.013,
                        0.012,
                        0.017,
                        0.025,
                        0.038,
                        0.055,
                        0.068,
                        0.072,
                        0.085,
                        0.105,
                        0.108,
                        0.129,
                        0.165,
                        0.203,
                        0.233,
                        0.229,
                        0.264,
                        0.338,
                        0.407,
                        0.436,
                        0.547,
                        0.692,
                        0.64,
                        0.654,
                        0.726,
                        0.787,
                        0.772,
                        0.807,
                        0.876,
                        0.984,
                        0.926,
                        1.013,
                        0.953,
                        1.019
                    ],
                    "name": "All Men",
                    "type": "column"
                },
                {
                    "color": "#de2d26",
                    "data": [
                        0.0,
                        0.0,
                        0.0,
                        0.0,
                        0.0,
                        0.0,
                        0.0,
                        0.0,
                        0.001,
                        0.001,
                        0.001,
                        0.001,
                        0.001,
                        0.001,
                        0.001,
                        0.002,
                        0.001,
                        0.004,
                        0.003,
                        0.003,
                        0.002,
                        0.002,
                        0.002,
                        0.007,
                        0.005,
                        0.005,
                        0.007,
                        0.006,
                        0.005,
                        0.013,
                        0.012,
                        0.013,
                        0.018,
                        0.01,
                        0.016,
                        0.026,
                        0.023,
                        0.022,
                        0.015,
                        0.025,
                        0.023,
                        0.025,
                        0.017,
                        0.023,
                        0.029
                    ],
                    "name": "All Women",
                    "type": "column"
                },
                {
                    "color": "darkblue",
                    "data": [
                        0.0,
                        0.0,
                        0.0,
                        0.0,
                        0.0,
                        0.0,
                        0.0,
                        0.0,
                        0.0,
                        0.0,
                        0.0,
                        7.69,
                        8.33,
                        5.88,
                        4.0,
                        5.26,
                        1.82,
                        5.88,
                        4.17,
                        3.53,
                        1.9,
                        1.85,
                        1.55,
                        4.24,
                        2.46,
                        2.15,
                        3.06,
                        2.27,
                        1.48,
                        3.19,
                        2.75,
                        2.38,
                        2.6,
                        1.56,
                        2.45,
                        3.58,
                        2.92,
                        2.85,
                        1.86,
                        2.85,
                        2.34,
                        2.7,
                        1.68,
                        2.41,
                        2.85
                    ],
                    "name": "Among all",
                    "type": "spline",
                    "yAxis": 1
                },
                {
                    "color": "darkblue",
                    "data": [
                        0.0,
                        0.0,
                        0.0,
                        0.0,
                        0.0,
                        0.0,
                        0.0,
                        0.0,
                        0.0,
                        0.0,
                        0.0,
                        0.0,
                        0.0,
                        9.09,
                        4.76,
                        6.67,
                        2.33,
                        5.66,
                        3.77,
                        3.08,
                        2.53,
                        2.3,
                        2.02,
                        4.92,
                        2.65,
                        1.83,
                        3.31,
                        2.63,
                        1.72,
                        3.82,
                        2.68,
                        2.04,
                        2.69,
                        1.37,
                        2.37,
                        3.83,
                        2.52,
                        2.91,
                        1.75,
                        2.71,
                        2.79,
                        3.08,
                        1.01,
                        2.4,
                        3.11
                    ],
                    "marker": {
                        "fillColor": "#FFFFFF",
                        "lineColor": "darkblue",
                        "lineWidth": 2,
                        "radius": 5
                    },
                    "name": "Among core",
                    "type": "spline",
                    "yAxis": 1
                }
            ],
            "height_ratio": 69.23076923076923,
            "label_x": "Time (quarter)",
            "label_y": "Number of Contributors (thousand)",
            "label_y_secondary": "% Women (of total m + w)",
            "title": "Active Contributors in PlatformIO Public Projects",
            "x_categories": [
                "2008-3",
                "2008-6",
                "2008-9",
                "2008-12",
                "2009-3",
                "2009-6",
                "2009-9",
                "2009-12",
                "2010-3",
                "2010-6",
                "2010-9",
                "2010-12",
                "2011-3",
                "2011-6",
                "2011-9",
                "2011-12",
                "2012-3",
                "2012-6",
                "2012-9",
                "2012-12",
                "2013-3",
                "2013-6",
                "2013-9",
                "2013-12",
                "2014-3",
                "2014-6",
                "2014-9",
                "2014-12",
                "2015-3",
                "2015-6",
                "2015-9",
                "2015-12",
                "2016-3",
                "2016-6",
                "2016-9",
                "2016-12",
                "2017-3",
                "2017-6",
                "2017-9",
                "2017-12",
                "2018-3",
                "2018-6",
                "2018-9",
                "2018-12",
                "2019-3"
            ]
        },
        "PlatformIO_line": {
            "data": [
                {
                    "color": "#C14E24",
                    "data": [
                        NaN,
                        0.0,
                        NaN,
                        0.0,
                        0.0,
                        0.0,
                        0.0,
                        0.0,
                        20.0,
                        20.0,
                        20.0,
                        7.69,
                        8.33,
                        5.88,
                        4.0,
                        5.26,
                        1.82,
                        5.88,
                        4.17,
                        3.53,
                        1.9,
                        1.85,
                        1.55,
                        4.24,
                        2.46,
                        2.15,
                        3.06,
                        2.27,
                        1.48,
                        3.19,
                        2.75,
                        2.38,
                        2.6,
                        1.56,
                        2.45,
                        3.58,
                        2.92,
                        2.85,
                        1.86,
                        2.85,
                        2.34,
                        2.7,
                        1.68,
                        2.41,
                        2.85
                    ],
                    "name": "Among all",
                    "type": "spline",
                    "yAxis": 1
                }
            ],
            "height_ratio": 66.66666666666666,
            "label_x": "",
            "label_y": "",
            "label_y_secondary": "",
            "title": "",
            "x_categories": [
                "2008",
                "2008",
                "2008",
                "2008",
                "2009",
                "2009",
                "2009",
                "2009",
                "2010",
                "2010",
                "2010",
                "2010",
                "2011",
                "2011",
                "2011",
                "2011",
                "2012",
                "2012",
                "2012",
                "2012",
                "2013",
                "2013",
                "2013",
                "2013",
                "2014",
                "2014",
                "2014",
                "2014",
                "2015",
                "2015",
                "2015",
                "2015",
                "2016",
                "2016",
                "2016",
                "2016",
                "2017",
                "2017",
                "2017",
                "2017",
                "2018",
                "2018",
                "2018",
                "2018",
                "2019"
            ]
        },
        "PlatformIO_women-bar": {
            "data": [
                {
                    "color": "#C14E24",
                    "data": [
                        0,
                        0,
                        0,
                        0,
                        0,
                        0,
                        0,
                        0,
                        1,
                        1,
                        1,
                        1,
                        1,
                        1,
                        1,
                        2,
                        1,
                        4,
                        3,
                        3,
                        2,
                        2,
                        2,
                        7,
                        5,
                        5,
                        7,
                        6,
                        5,
                        13,
                        12,
                        13,
                        18,
                        10,
                        16,
                        26,
                        23,
                        22,
                        15,
                        25,
                        23,
                        25,
                        17,
                        23,
                        29
                    ],
                    "name": "Women",
                    "type": "column",
                    "yAxis": 1
                }
            ],
            "height_ratio": 66.66666666666666,
            "label_x": "",
            "label_y": "",
            "label_y_secondary": "",
            "title": "",
            "x_categories": [
                "2008",
                "2008",
                "2008",
                "2008",
                "2009",
                "2009",
                "2009",
                "2009",
                "2010",
                "2010",
                "2010",
                "2010",
                "2011",
                "2011",
                "2011",
                "2011",
                "2012",
                "2012",
                "2012",
                "2012",
                "2013",
                "2013",
                "2013",
                "2013",
                "2014",
                "2014",
                "2014",
                "2014",
                "2015",
                "2015",
                "2015",
                "2015",
                "2016",
                "2016",
                "2016",
                "2016",
                "2017",
                "2017",
                "2017",
                "2017",
                "2018",
                "2018",
                "2018",
                "2018",
                "2019"
            ]
        },
        "Pub": {
            "data": [
                {
                    "color": "blanchedalmond",
                    "data": [
                        0.001,
                        0.0,
                        0.0,
                        0.0,
                        0.0,
                        0.001,
                        0.0,
                        0.0,
                        0.0,
                        0.0,
                        0.0,
                        0.0,
                        0.0,
                        0.0,
                        0.0,
                        0.001,
                        0.007,
                        0.018,
                        0.053,
                        0.085,
                        0.127,
                        0.177,
                        0.179,
                        0.243,
                        0.284,
                        0.304,
                        0.368,
                        0.377,
                        0.444,
                        0.475,
                        0.51,
                        0.482,
                        0.487,
                        0.508,
                        0.464,
                        0.505,
                        0.559,
                        0.684,
                        0.691,
                        0.787,
                        0.95,
                        1.281,
                        1.906,
                        2.194,
                        2.869
                    ],
                    "name": "All Unknown",
                    "type": "column"
                },
                {
                    "color": "#f29d4b",
                    "data": [
                        0.0,
                        0.0,
                        0.0,
                        0.0,
                        0.0,
                        0.0,
                        0.0,
                        0.0,
                        0.0,
                        0.0,
                        0.0,
                        0.0,
                        0.0,
                        0.0,
                        0.0,
                        0.001,
                        0.007,
                        0.017,
                        0.045,
                        0.069,
                        0.097,
                        0.136,
                        0.138,
                        0.19,
                        0.229,
                        0.237,
                        0.288,
                        0.295,
                        0.336,
                        0.373,
                        0.402,
                        0.387,
                        0.37,
                        0.403,
                        0.35,
                        0.354,
                        0.425,
                        0.499,
                        0.483,
                        0.558,
                        0.689,
                        0.881,
                        1.241,
                        1.377,
                        1.783
                    ],
                    "name": "All Men",
                    "type": "column"
                },
                {
                    "color": "#de2d26",
                    "data": [
                        0.0,
                        0.0,
                        0.0,
                        0.0,
                        0.0,
                        0.0,
                        0.0,
                        0.0,
                        0.0,
                        0.0,
                        0.0,
                        0.0,
                        0.0,
                        0.0,
                        0.0,
                        0.0,
                        0.0,
                        0.0,
                        0.001,
                        0.004,
                        0.003,
                        0.004,
                        0.006,
                        0.009,
                        0.008,
                        0.007,
                        0.01,
                        0.01,
                        0.009,
                        0.014,
                        0.012,
                        0.014,
                        0.012,
                        0.016,
                        0.014,
                        0.011,
                        0.018,
                        0.023,
                        0.019,
                        0.024,
                        0.03,
                        0.034,
                        0.037,
                        0.057,
                        0.068
                    ],
                    "name": "All Women",
                    "type": "column"
                },
                {
                    "color": "darkblue",
                    "data": [
                        0.0,
                        0.0,
                        0.0,
                        0.0,
                        0.0,
                        0.0,
                        0.0,
                        0.0,
                        0.0,
                        0.0,
                        0.0,
                        0.0,
                        0.0,
                        0.0,
                        0.0,
                        0.0,
                        0.0,
                        0.0,
                        2.22,
                        5.8,
                        3.09,
                        2.94,
                        4.35,
                        4.74,
                        3.49,
                        2.95,
                        3.47,
                        3.39,
                        2.68,
                        3.75,
                        2.99,
                        3.62,
                        3.24,
                        3.97,
                        4.0,
                        3.11,
                        4.24,
                        4.61,
                        3.93,
                        4.3,
                        4.35,
                        3.86,
                        2.98,
                        4.14,
                        3.81
                    ],
                    "name": "Among all",
                    "type": "spline",
                    "yAxis": 1
                },
                {
                    "color": "darkblue",
                    "data": [
                        0.0,
                        0.0,
                        0.0,
                        0.0,
                        0.0,
                        0.0,
                        0.0,
                        0.0,
                        0.0,
                        0.0,
                        0.0,
                        0.0,
                        0.0,
                        0.0,
                        0.0,
                        0.0,
                        0.0,
                        0.0,
                        3.23,
                        7.14,
                        5.66,
                        4.05,
                        6.58,
                        7.69,
                        5.13,
                        4.39,
                        4.2,
                        2.91,
                        3.51,
                        4.09,
                        3.4,
                        4.3,
                        3.74,
                        4.52,
                        4.26,
                        3.02,
                        4.66,
                        5.39,
                        4.69,
                        4.99,
                        5.29,
                        4.37,
                        3.45,
                        4.08,
                        4.04
                    ],
                    "marker": {
                        "fillColor": "#FFFFFF",
                        "lineColor": "darkblue",
                        "lineWidth": 2,
                        "radius": 5
                    },
                    "name": "Among core",
                    "type": "spline",
                    "yAxis": 1
                }
            ],
            "height_ratio": 69.23076923076923,
            "label_x": "Time (quarter)",
            "label_y": "Number of Contributors (thousand)",
            "label_y_secondary": "% Women (of total m + w)",
            "title": "Active Contributors in Pub Public Projects",
            "x_categories": [
                "2008-3",
                "2008-6",
                "2008-9",
                "2008-12",
                "2009-3",
                "2009-6",
                "2009-9",
                "2009-12",
                "2010-3",
                "2010-6",
                "2010-9",
                "2010-12",
                "2011-3",
                "2011-6",
                "2011-9",
                "2011-12",
                "2012-3",
                "2012-6",
                "2012-9",
                "2012-12",
                "2013-3",
                "2013-6",
                "2013-9",
                "2013-12",
                "2014-3",
                "2014-6",
                "2014-9",
                "2014-12",
                "2015-3",
                "2015-6",
                "2015-9",
                "2015-12",
                "2016-3",
                "2016-6",
                "2016-9",
                "2016-12",
                "2017-3",
                "2017-6",
                "2017-9",
                "2017-12",
                "2018-3",
                "2018-6",
                "2018-9",
                "2018-12",
                "2019-3"
            ]
        },
        "Pub_line": {
            "data": [
                {
                    "color": "#01579B",
                    "data": [
                        0.0,
                        NaN,
                        NaN,
                        NaN,
                        NaN,
                        0.0,
                        NaN,
                        NaN,
                        NaN,
                        NaN,
                        NaN,
                        NaN,
                        NaN,
                        NaN,
                        NaN,
                        0.0,
                        0.0,
                        0.0,
                        2.22,
                        5.8,
                        3.09,
                        2.94,
                        4.35,
                        4.74,
                        3.49,
                        2.95,
                        3.47,
                        3.39,
                        2.68,
                        3.75,
                        2.99,
                        3.62,
                        3.24,
                        3.97,
                        4.0,
                        3.11,
                        4.24,
                        4.61,
                        3.93,
                        4.3,
                        4.35,
                        3.86,
                        2.98,
                        4.14,
                        3.81
                    ],
                    "name": "Among all",
                    "type": "spline",
                    "yAxis": 1
                }
            ],
            "height_ratio": 66.66666666666666,
            "label_x": "",
            "label_y": "",
            "label_y_secondary": "",
            "title": "",
            "x_categories": [
                "2008",
                "2008",
                "2008",
                "2008",
                "2009",
                "2009",
                "2009",
                "2009",
                "2010",
                "2010",
                "2010",
                "2010",
                "2011",
                "2011",
                "2011",
                "2011",
                "2012",
                "2012",
                "2012",
                "2012",
                "2013",
                "2013",
                "2013",
                "2013",
                "2014",
                "2014",
                "2014",
                "2014",
                "2015",
                "2015",
                "2015",
                "2015",
                "2016",
                "2016",
                "2016",
                "2016",
                "2017",
                "2017",
                "2017",
                "2017",
                "2018",
                "2018",
                "2018",
                "2018",
                "2019"
            ]
        },
        "Pub_women-bar": {
            "data": [
                {
                    "color": "#01579B",
                    "data": [
                        0,
                        0,
                        0,
                        0,
                        0,
                        0,
                        0,
                        0,
                        0,
                        0,
                        0,
                        0,
                        0,
                        0,
                        0,
                        0,
                        0,
                        0,
                        1,
                        4,
                        3,
                        4,
                        6,
                        9,
                        8,
                        7,
                        10,
                        10,
                        9,
                        14,
                        12,
                        14,
                        12,
                        16,
                        14,
                        11,
                        18,
                        23,
                        19,
                        24,
                        30,
                        34,
                        37,
                        57,
                        68
                    ],
                    "name": "Women",
                    "type": "column",
                    "yAxis": 1
                }
            ],
            "height_ratio": 66.66666666666666,
            "label_x": "",
            "label_y": "",
            "label_y_secondary": "",
            "title": "",
            "x_categories": [
                "2008",
                "2008",
                "2008",
                "2008",
                "2009",
                "2009",
                "2009",
                "2009",
                "2010",
                "2010",
                "2010",
                "2010",
                "2011",
                "2011",
                "2011",
                "2011",
                "2012",
                "2012",
                "2012",
                "2012",
                "2013",
                "2013",
                "2013",
                "2013",
                "2014",
                "2014",
                "2014",
                "2014",
                "2015",
                "2015",
                "2015",
                "2015",
                "2016",
                "2016",
                "2016",
                "2016",
                "2017",
                "2017",
                "2017",
                "2017",
                "2018",
                "2018",
                "2018",
                "2018",
                "2019"
            ]
        },
        "Puppet": {
            "data": [
                {
                    "color": "blanchedalmond",
                    "data": [
                        0.002,
                        0.002,
                        0.002,
                        0.004,
                        0.004,
                        0.005,
                        0.006,
                        0.006,
                        0.011,
                        0.015,
                        0.024,
                        0.013,
                        0.026,
                        0.05,
                        0.077,
                        0.093,
                        0.174,
                        0.226,
                        0.308,
                        0.414,
                        0.552,
                        0.705,
                        0.852,
                        0.979,
                        1.106,
                        1.212,
                        1.343,
                        1.409,
                        1.556,
                        1.527,
                        1.501,
                        1.501,
                        1.655,
                        1.551,
                        1.371,
                        1.297,
                        1.372,
                        1.281,
                        1.229,
                        1.2,
                        1.229,
                        1.221,
                        1.16,
                        1.092,
                        0.98
                    ],
                    "name": "All Unknown",
                    "type": "column"
                },
                {
                    "color": "#f29d4b",
                    "data": [
                        0.0,
                        0.001,
                        0.002,
                        0.004,
                        0.004,
                        0.005,
                        0.005,
                        0.004,
                        0.009,
                        0.01,
                        0.017,
                        0.008,
                        0.02,
                        0.038,
                        0.056,
                        0.07,
                        0.148,
                        0.186,
                        0.258,
                        0.366,
                        0.462,
                        0.585,
                        0.71,
                        0.818,
                        0.912,
                        0.99,
                        1.104,
                        1.143,
                        1.252,
                        1.246,
                        1.191,
                        1.216,
                        1.316,
                        1.245,
                        1.088,
                        1.024,
                        1.088,
                        1.01,
                        0.978,
                        0.929,
                        0.934,
                        0.911,
                        0.812,
                        0.84,
                        0.747
                    ],
                    "name": "All Men",
                    "type": "column"
                },
                {
                    "color": "#de2d26",
                    "data": [
                        0.0,
                        0.0,
                        0.0,
                        0.0,
                        0.0,
                        0.0,
                        0.0,
                        0.0,
                        0.0,
                        0.001,
                        0.001,
                        0.001,
                        0.001,
                        0.001,
                        0.001,
                        0.002,
                        0.003,
                        0.002,
                        0.005,
                        0.004,
                        0.008,
                        0.009,
                        0.014,
                        0.011,
                        0.01,
                        0.017,
                        0.024,
                        0.022,
                        0.02,
                        0.031,
                        0.025,
                        0.021,
                        0.028,
                        0.025,
                        0.023,
                        0.028,
                        0.026,
                        0.024,
                        0.025,
                        0.035,
                        0.032,
                        0.029,
                        0.031,
                        0.027,
                        0.024
                    ],
                    "name": "All Women",
                    "type": "column"
                },
                {
                    "color": "darkblue",
                    "data": [
                        0.0,
                        0.0,
                        0.0,
                        0.0,
                        0.0,
                        0.0,
                        0.0,
                        0.0,
                        0.0,
                        10.0,
                        5.88,
                        12.5,
                        5.0,
                        2.63,
                        1.79,
                        2.86,
                        2.03,
                        1.08,
                        1.94,
                        1.09,
                        1.73,
                        1.54,
                        1.97,
                        1.34,
                        1.1,
                        1.72,
                        2.17,
                        1.92,
                        1.6,
                        2.49,
                        2.1,
                        1.73,
                        2.13,
                        2.01,
                        2.11,
                        2.73,
                        2.39,
                        2.38,
                        2.56,
                        3.77,
                        3.43,
                        3.18,
                        3.82,
                        3.21,
                        3.21
                    ],
                    "name": "Among all",
                    "type": "spline",
                    "yAxis": 1
                },
                {
                    "color": "darkblue",
                    "data": [
                        0.0,
                        0.0,
                        0.0,
                        0.0,
                        0.0,
                        0.0,
                        0.0,
                        0.0,
                        0.0,
                        0.0,
                        6.67,
                        0.0,
                        5.26,
                        3.23,
                        2.22,
                        3.51,
                        2.36,
                        1.2,
                        2.27,
                        1.27,
                        1.82,
                        1.5,
                        1.84,
                        1.37,
                        1.27,
                        1.55,
                        2.24,
                        2.07,
                        1.37,
                        2.08,
                        2.29,
                        1.68,
                        2.03,
                        2.17,
                        2.25,
                        3.11,
                        2.16,
                        2.4,
                        2.99,
                        3.47,
                        3.37,
                        3.08,
                        4.03,
                        3.11,
                        3.26
                    ],
                    "marker": {
                        "fillColor": "#FFFFFF",
                        "lineColor": "darkblue",
                        "lineWidth": 2,
                        "radius": 5
                    },
                    "name": "Among core",
                    "type": "spline",
                    "yAxis": 1
                }
            ],
            "height_ratio": 69.23076923076923,
            "label_x": "Time (quarter)",
            "label_y": "Number of Contributors (thousand)",
            "label_y_secondary": "% Women (of total m + w)",
            "title": "Active Contributors in Puppet Public Projects",
            "x_categories": [
                "2008-3",
                "2008-6",
                "2008-9",
                "2008-12",
                "2009-3",
                "2009-6",
                "2009-9",
                "2009-12",
                "2010-3",
                "2010-6",
                "2010-9",
                "2010-12",
                "2011-3",
                "2011-6",
                "2011-9",
                "2011-12",
                "2012-3",
                "2012-6",
                "2012-9",
                "2012-12",
                "2013-3",
                "2013-6",
                "2013-9",
                "2013-12",
                "2014-3",
                "2014-6",
                "2014-9",
                "2014-12",
                "2015-3",
                "2015-6",
                "2015-9",
                "2015-12",
                "2016-3",
                "2016-6",
                "2016-9",
                "2016-12",
                "2017-3",
                "2017-6",
                "2017-9",
                "2017-12",
                "2018-3",
                "2018-6",
                "2018-9",
                "2018-12",
                "2019-3"
            ]
        },
        "Puppet_line": {
            "data": [
                {
                    "color": "#9C670E",
                    "data": [
                        0.0,
                        0.0,
                        0.0,
                        0.0,
                        0.0,
                        0.0,
                        0.0,
                        0.0,
                        0.0,
                        10.0,
                        5.88,
                        12.5,
                        5.0,
                        2.63,
                        1.79,
                        2.86,
                        2.03,
                        1.08,
                        1.94,
                        1.09,
                        1.73,
                        1.54,
                        1.97,
                        1.34,
                        1.1,
                        1.72,
                        2.17,
                        1.92,
                        1.6,
                        2.49,
                        2.1,
                        1.73,
                        2.13,
                        2.01,
                        2.11,
                        2.73,
                        2.39,
                        2.38,
                        2.56,
                        3.77,
                        3.43,
                        3.18,
                        3.82,
                        3.21,
                        3.21
                    ],
                    "name": "Among all",
                    "type": "spline",
                    "yAxis": 1
                }
            ],
            "height_ratio": 66.66666666666666,
            "label_x": "",
            "label_y": "",
            "label_y_secondary": "",
            "title": "",
            "x_categories": [
                "2008",
                "2008",
                "2008",
                "2008",
                "2009",
                "2009",
                "2009",
                "2009",
                "2010",
                "2010",
                "2010",
                "2010",
                "2011",
                "2011",
                "2011",
                "2011",
                "2012",
                "2012",
                "2012",
                "2012",
                "2013",
                "2013",
                "2013",
                "2013",
                "2014",
                "2014",
                "2014",
                "2014",
                "2015",
                "2015",
                "2015",
                "2015",
                "2016",
                "2016",
                "2016",
                "2016",
                "2017",
                "2017",
                "2017",
                "2017",
                "2018",
                "2018",
                "2018",
                "2018",
                "2019"
            ]
        },
        "Puppet_women-bar": {
            "data": [
                {
                    "color": "#9C670E",
                    "data": [
                        0,
                        0,
                        0,
                        0,
                        0,
                        0,
                        0,
                        0,
                        0,
                        1,
                        1,
                        1,
                        1,
                        1,
                        1,
                        2,
                        3,
                        2,
                        5,
                        4,
                        8,
                        9,
                        14,
                        11,
                        10,
                        17,
                        24,
                        22,
                        20,
                        31,
                        25,
                        21,
                        28,
                        25,
                        23,
                        28,
                        26,
                        24,
                        25,
                        35,
                        32,
                        29,
                        31,
                        27,
                        24
                    ],
                    "name": "Women",
                    "type": "column",
                    "yAxis": 1
                }
            ],
            "height_ratio": 66.66666666666666,
            "label_x": "",
            "label_y": "",
            "label_y_secondary": "",
            "title": "",
            "x_categories": [
                "2008",
                "2008",
                "2008",
                "2008",
                "2009",
                "2009",
                "2009",
                "2009",
                "2010",
                "2010",
                "2010",
                "2010",
                "2011",
                "2011",
                "2011",
                "2011",
                "2012",
                "2012",
                "2012",
                "2012",
                "2013",
                "2013",
                "2013",
                "2013",
                "2014",
                "2014",
                "2014",
                "2014",
                "2015",
                "2015",
                "2015",
                "2015",
                "2016",
                "2016",
                "2016",
                "2016",
                "2017",
                "2017",
                "2017",
                "2017",
                "2018",
                "2018",
                "2018",
                "2018",
                "2019"
            ]
        },
        "Pypi": {
            "data": [
                {
                    "color": "blanchedalmond",
                    "data": [
                        0.387,
                        0.487,
                        0.585,
                        0.609,
                        0.823,
                        0.829,
                        0.947,
                        1.117,
                        1.378,
                        1.503,
                        1.809,
                        2.13,
                        2.541,
                        2.994,
                        3.603,
                        4.078,
                        5.59,
                        5.853,
                        6.882,
                        7.035,
                        9.199,
                        10.123,
                        11.55,
                        12.428,
                        14.33,
                        15.188,
                        16.381,
                        17.48,
                        19.947,
                        21.23,
                        21.616,
                        22.853,
                        25.388,
                        26.082,
                        27.052,
                        28.878,
                        31.798,
                        33.846,
                        35.378,
                        38.34,
                        41.939,
                        43.509,
                        44.795,
                        48.655,
                        48.861
                    ],
                    "name": "All Unknown",
                    "type": "column"
                },
                {
                    "color": "#f29d4b",
                    "data": [
                        0.246,
                        0.331,
                        0.408,
                        0.423,
                        0.577,
                        0.589,
                        0.703,
                        0.816,
                        1.032,
                        1.171,
                        1.417,
                        1.653,
                        2.041,
                        2.411,
                        2.954,
                        3.328,
                        4.541,
                        4.737,
                        5.488,
                        5.638,
                        7.33,
                        8.049,
                        9.087,
                        9.69,
                        11.165,
                        11.748,
                        12.566,
                        13.416,
                        15.21,
                        16.118,
                        16.323,
                        17.229,
                        18.912,
                        19.341,
                        19.991,
                        21.179,
                        23.179,
                        24.106,
                        24.913,
                        26.905,
                        29.194,
                        29.817,
                        30.296,
                        32.1,
                        32.046
                    ],
                    "name": "All Men",
                    "type": "column"
                },
                {
                    "color": "#de2d26",
                    "data": [
                        0.006,
                        0.009,
                        0.01,
                        0.008,
                        0.016,
                        0.014,
                        0.019,
                        0.015,
                        0.02,
                        0.032,
                        0.042,
                        0.044,
                        0.044,
                        0.056,
                        0.072,
                        0.075,
                        0.097,
                        0.117,
                        0.152,
                        0.13,
                        0.192,
                        0.237,
                        0.263,
                        0.282,
                        0.371,
                        0.398,
                        0.431,
                        0.47,
                        0.545,
                        0.571,
                        0.636,
                        0.667,
                        0.705,
                        0.786,
                        0.844,
                        0.941,
                        1.022,
                        1.1,
                        1.207,
                        1.327,
                        1.43,
                        1.522,
                        1.636,
                        1.721,
                        1.759
                    ],
                    "name": "All Women",
                    "type": "column"
                },
                {
                    "color": "darkblue",
                    "data": [
                        2.44,
                        2.72,
                        2.45,
                        1.89,
                        2.77,
                        2.38,
                        2.7,
                        1.84,
                        1.94,
                        2.73,
                        2.96,
                        2.66,
                        2.16,
                        2.32,
                        2.44,
                        2.25,
                        2.14,
                        2.47,
                        2.77,
                        2.31,
                        2.62,
                        2.94,
                        2.89,
                        2.91,
                        3.32,
                        3.39,
                        3.43,
                        3.5,
                        3.58,
                        3.54,
                        3.9,
                        3.87,
                        3.73,
                        4.06,
                        4.22,
                        4.44,
                        4.41,
                        4.56,
                        4.84,
                        4.93,
                        4.9,
                        5.1,
                        5.4,
                        5.36,
                        5.49
                    ],
                    "name": "Among all",
                    "type": "spline",
                    "yAxis": 1
                },
                {
                    "color": "darkblue",
                    "data": [
                        2.78,
                        2.75,
                        2.47,
                        2.14,
                        3.11,
                        2.77,
                        2.86,
                        2.21,
                        2.34,
                        2.94,
                        3.15,
                        2.75,
                        2.3,
                        2.29,
                        2.45,
                        2.27,
                        2.23,
                        2.55,
                        2.91,
                        2.46,
                        2.68,
                        3.08,
                        3.08,
                        3.02,
                        3.39,
                        3.33,
                        3.47,
                        3.59,
                        3.63,
                        3.68,
                        4.19,
                        4.02,
                        3.86,
                        4.32,
                        4.4,
                        4.68,
                        4.61,
                        4.73,
                        5.08,
                        5.22,
                        5.02,
                        5.45,
                        5.75,
                        5.6,
                        5.76
                    ],
                    "marker": {
                        "fillColor": "#FFFFFF",
                        "lineColor": "darkblue",
                        "lineWidth": 2,
                        "radius": 5
                    },
                    "name": "Among core",
                    "type": "spline",
                    "yAxis": 1
                }
            ],
            "height_ratio": 69.23076923076923,
            "label_x": "Time (quarter)",
            "label_y": "Number of Contributors (thousand)",
            "label_y_secondary": "% Women (of total m + w)",
            "title": "Active Contributors in Pypi Public Projects",
            "x_categories": [
                "2008-3",
                "2008-6",
                "2008-9",
                "2008-12",
                "2009-3",
                "2009-6",
                "2009-9",
                "2009-12",
                "2010-3",
                "2010-6",
                "2010-9",
                "2010-12",
                "2011-3",
                "2011-6",
                "2011-9",
                "2011-12",
                "2012-3",
                "2012-6",
                "2012-9",
                "2012-12",
                "2013-3",
                "2013-6",
                "2013-9",
                "2013-12",
                "2014-3",
                "2014-6",
                "2014-9",
                "2014-12",
                "2015-3",
                "2015-6",
                "2015-9",
                "2015-12",
                "2016-3",
                "2016-6",
                "2016-9",
                "2016-12",
                "2017-3",
                "2017-6",
                "2017-9",
                "2017-12",
                "2018-3",
                "2018-6",
                "2018-9",
                "2018-12",
                "2019-3"
            ]
        },
        "Pypi_line": {
            "data": [
                {
                    "color": "#3774A8",
                    "data": [
                        2.44,
                        2.72,
                        2.45,
                        1.89,
                        2.77,
                        2.38,
                        2.7,
                        1.84,
                        1.94,
                        2.73,
                        2.96,
                        2.66,
                        2.16,
                        2.32,
                        2.44,
                        2.25,
                        2.14,
                        2.47,
                        2.77,
                        2.31,
                        2.62,
                        2.94,
                        2.89,
                        2.91,
                        3.32,
                        3.39,
                        3.43,
                        3.5,
                        3.58,
                        3.54,
                        3.9,
                        3.87,
                        3.73,
                        4.06,
                        4.22,
                        4.44,
                        4.41,
                        4.56,
                        4.84,
                        4.93,
                        4.9,
                        5.1,
                        5.4,
                        5.36,
                        5.49
                    ],
                    "name": "Among all",
                    "type": "spline",
                    "yAxis": 1
                }
            ],
            "height_ratio": 66.66666666666666,
            "label_x": "",
            "label_y": "",
            "label_y_secondary": "",
            "title": "",
            "x_categories": [
                "2008",
                "2008",
                "2008",
                "2008",
                "2009",
                "2009",
                "2009",
                "2009",
                "2010",
                "2010",
                "2010",
                "2010",
                "2011",
                "2011",
                "2011",
                "2011",
                "2012",
                "2012",
                "2012",
                "2012",
                "2013",
                "2013",
                "2013",
                "2013",
                "2014",
                "2014",
                "2014",
                "2014",
                "2015",
                "2015",
                "2015",
                "2015",
                "2016",
                "2016",
                "2016",
                "2016",
                "2017",
                "2017",
                "2017",
                "2017",
                "2018",
                "2018",
                "2018",
                "2018",
                "2019"
            ]
        },
        "Pypi_women-bar": {
            "data": [
                {
                    "color": "#3774A8",
                    "data": [
                        6,
                        9,
                        10,
                        8,
                        16,
                        14,
                        19,
                        15,
                        20,
                        32,
                        42,
                        44,
                        44,
                        56,
                        72,
                        75,
                        97,
                        117,
                        152,
                        130,
                        192,
                        237,
                        263,
                        282,
                        371,
                        398,
                        431,
                        470,
                        545,
                        571,
                        636,
                        667,
                        705,
                        786,
                        844,
                        941,
                        1022,
                        1100,
                        1207,
                        1327,
                        1430,
                        1522,
                        1636,
                        1721,
                        1759
                    ],
                    "name": "Women",
                    "type": "column",
                    "yAxis": 1
                }
            ],
            "height_ratio": 66.66666666666666,
            "label_x": "",
            "label_y": "",
            "label_y_secondary": "",
            "title": "",
            "x_categories": [
                "2008",
                "2008",
                "2008",
                "2008",
                "2009",
                "2009",
                "2009",
                "2009",
                "2010",
                "2010",
                "2010",
                "2010",
                "2011",
                "2011",
                "2011",
                "2011",
                "2012",
                "2012",
                "2012",
                "2012",
                "2013",
                "2013",
                "2013",
                "2013",
                "2014",
                "2014",
                "2014",
                "2014",
                "2015",
                "2015",
                "2015",
                "2015",
                "2016",
                "2016",
                "2016",
                "2016",
                "2017",
                "2017",
                "2017",
                "2017",
                "2018",
                "2018",
                "2018",
                "2018",
                "2019"
            ]
        },
        "RubyGems": {
            "data": [
                {
                    "color": "blanchedalmond",
                    "data": [
                        0.389,
                        0.688,
                        0.943,
                        1.196,
                        1.529,
                        1.698,
                        1.874,
                        2.311,
                        2.662,
                        2.842,
                        3.46,
                        4.13,
                        5.037,
                        5.934,
                        6.794,
                        7.369,
                        9.922,
                        10.157,
                        11.702,
                        11.154,
                        14.511,
                        14.784,
                        16.247,
                        16.619,
                        17.579,
                        17.278,
                        17.293,
                        17.772,
                        19.042,
                        18.81,
                        17.6,
                        17.723,
                        18.736,
                        17.475,
                        16.844,
                        16.689,
                        17.139,
                        16.459,
                        15.921,
                        15.756,
                        15.894,
                        15.12,
                        14.316,
                        14.265,
                        13.638
                    ],
                    "name": "All Unknown",
                    "type": "column"
                },
                {
                    "color": "#f29d4b",
                    "data": [
                        0.268,
                        0.549,
                        0.79,
                        0.998,
                        1.272,
                        1.411,
                        1.555,
                        1.911,
                        2.224,
                        2.389,
                        2.908,
                        3.468,
                        4.253,
                        4.99,
                        5.7,
                        6.163,
                        8.229,
                        8.425,
                        9.503,
                        9.142,
                        11.768,
                        11.863,
                        12.949,
                        13.291,
                        14.286,
                        14.01,
                        13.941,
                        14.19,
                        15.105,
                        14.905,
                        13.904,
                        14.01,
                        14.93,
                        13.862,
                        13.352,
                        13.038,
                        13.375,
                        12.749,
                        12.314,
                        11.969,
                        12.003,
                        11.326,
                        10.468,
                        10.551,
                        10.033
                    ],
                    "name": "All Men",
                    "type": "column"
                },
                {
                    "color": "#de2d26",
                    "data": [
                        0.01,
                        0.011,
                        0.016,
                        0.017,
                        0.027,
                        0.025,
                        0.024,
                        0.03,
                        0.036,
                        0.049,
                        0.068,
                        0.071,
                        0.082,
                        0.107,
                        0.141,
                        0.132,
                        0.183,
                        0.183,
                        0.241,
                        0.209,
                        0.274,
                        0.313,
                        0.365,
                        0.38,
                        0.41,
                        0.454,
                        0.469,
                        0.482,
                        0.514,
                        0.526,
                        0.585,
                        0.56,
                        0.603,
                        0.587,
                        0.552,
                        0.57,
                        0.562,
                        0.601,
                        0.625,
                        0.602,
                        0.631,
                        0.613,
                        0.594,
                        0.563,
                        0.514
                    ],
                    "name": "All Women",
                    "type": "column"
                },
                {
                    "color": "darkblue",
                    "data": [
                        3.73,
                        2.0,
                        2.03,
                        1.7,
                        2.12,
                        1.77,
                        1.54,
                        1.57,
                        1.62,
                        2.05,
                        2.34,
                        2.05,
                        1.93,
                        2.14,
                        2.47,
                        2.14,
                        2.22,
                        2.17,
                        2.54,
                        2.29,
                        2.33,
                        2.64,
                        2.82,
                        2.86,
                        2.87,
                        3.24,
                        3.36,
                        3.4,
                        3.4,
                        3.53,
                        4.21,
                        4.0,
                        4.04,
                        4.23,
                        4.13,
                        4.37,
                        4.2,
                        4.71,
                        5.08,
                        5.03,
                        5.26,
                        5.41,
                        5.67,
                        5.34,
                        5.12
                    ],
                    "name": "Among all",
                    "type": "spline",
                    "yAxis": 1
                },
                {
                    "color": "darkblue",
                    "data": [
                        3.23,
                        1.24,
                        1.87,
                        1.77,
                        2.03,
                        1.64,
                        1.53,
                        1.71,
                        1.55,
                        2.15,
                        2.24,
                        2.08,
                        1.85,
                        2.2,
                        2.35,
                        2.1,
                        2.17,
                        1.85,
                        2.35,
                        2.15,
                        2.16,
                        2.51,
                        2.76,
                        2.64,
                        2.83,
                        3.34,
                        3.52,
                        3.45,
                        3.53,
                        3.62,
                        4.12,
                        4.02,
                        3.98,
                        4.25,
                        4.14,
                        4.43,
                        4.17,
                        4.88,
                        5.27,
                        5.39,
                        5.5,
                        5.48,
                        5.94,
                        5.62,
                        5.3
                    ],
                    "marker": {
                        "fillColor": "#FFFFFF",
                        "lineColor": "darkblue",
                        "lineWidth": 2,
                        "radius": 5
                    },
                    "name": "Among core",
                    "type": "spline",
                    "yAxis": 1
                }
            ],
            "height_ratio": 69.23076923076923,
            "label_x": "Time (quarter)",
            "label_y": "Number of Contributors (thousand)",
            "label_y_secondary": "% Women (of total m + w)",
            "title": "Active Contributors in RubyGems Public Projects",
            "x_categories": [
                "2008-3",
                "2008-6",
                "2008-9",
                "2008-12",
                "2009-3",
                "2009-6",
                "2009-9",
                "2009-12",
                "2010-3",
                "2010-6",
                "2010-9",
                "2010-12",
                "2011-3",
                "2011-6",
                "2011-9",
                "2011-12",
                "2012-3",
                "2012-6",
                "2012-9",
                "2012-12",
                "2013-3",
                "2013-6",
                "2013-9",
                "2013-12",
                "2014-3",
                "2014-6",
                "2014-9",
                "2014-12",
                "2015-3",
                "2015-6",
                "2015-9",
                "2015-12",
                "2016-3",
                "2016-6",
                "2016-9",
                "2016-12",
                "2017-3",
                "2017-6",
                "2017-9",
                "2017-12",
                "2018-3",
                "2018-6",
                "2018-9",
                "2018-12",
                "2019-3"
            ]
        },
        "RubyGems_line": {
            "data": [
                {
                    "color": "#CF3E2D",
                    "data": [
                        3.73,
                        2.0,
                        2.03,
                        1.7,
                        2.12,
                        1.77,
                        1.54,
                        1.57,
                        1.62,
                        2.05,
                        2.34,
                        2.05,
                        1.93,
                        2.14,
                        2.47,
                        2.14,
                        2.22,
                        2.17,
                        2.54,
                        2.29,
                        2.33,
                        2.64,
                        2.82,
                        2.86,
                        2.87,
                        3.24,
                        3.36,
                        3.4,
                        3.4,
                        3.53,
                        4.21,
                        4.0,
                        4.04,
                        4.23,
                        4.13,
                        4.37,
                        4.2,
                        4.71,
                        5.08,
                        5.03,
                        5.26,
                        5.41,
                        5.67,
                        5.34,
                        5.12
                    ],
                    "name": "Among all",
                    "type": "spline",
                    "yAxis": 1
                }
            ],
            "height_ratio": 66.66666666666666,
            "label_x": "",
            "label_y": "",
            "label_y_secondary": "",
            "title": "",
            "x_categories": [
                "2008",
                "2008",
                "2008",
                "2008",
                "2009",
                "2009",
                "2009",
                "2009",
                "2010",
                "2010",
                "2010",
                "2010",
                "2011",
                "2011",
                "2011",
                "2011",
                "2012",
                "2012",
                "2012",
                "2012",
                "2013",
                "2013",
                "2013",
                "2013",
                "2014",
                "2014",
                "2014",
                "2014",
                "2015",
                "2015",
                "2015",
                "2015",
                "2016",
                "2016",
                "2016",
                "2016",
                "2017",
                "2017",
                "2017",
                "2017",
                "2018",
                "2018",
                "2018",
                "2018",
                "2019"
            ]
        },
        "RubyGems_women-bar": {
            "data": [
                {
                    "color": "#CF3E2D",
                    "data": [
                        10,
                        11,
                        16,
                        17,
                        27,
                        25,
                        24,
                        30,
                        36,
                        49,
                        68,
                        71,
                        82,
                        107,
                        141,
                        132,
                        183,
                        183,
                        241,
                        209,
                        274,
                        313,
                        365,
                        380,
                        410,
                        454,
                        469,
                        482,
                        514,
                        526,
                        585,
                        560,
                        603,
                        587,
                        552,
                        570,
                        562,
                        601,
                        625,
                        602,
                        631,
                        613,
                        594,
                        563,
                        514
                    ],
                    "name": "Women",
                    "type": "column",
                    "yAxis": 1
                }
            ],
            "height_ratio": 66.66666666666666,
            "label_x": "",
            "label_y": "",
            "label_y_secondary": "",
            "title": "",
            "x_categories": [
                "2008",
                "2008",
                "2008",
                "2008",
                "2009",
                "2009",
                "2009",
                "2009",
                "2010",
                "2010",
                "2010",
                "2010",
                "2011",
                "2011",
                "2011",
                "2011",
                "2012",
                "2012",
                "2012",
                "2012",
                "2013",
                "2013",
                "2013",
                "2013",
                "2014",
                "2014",
                "2014",
                "2014",
                "2015",
                "2015",
                "2015",
                "2015",
                "2016",
                "2016",
                "2016",
                "2016",
                "2017",
                "2017",
                "2017",
                "2017",
                "2018",
                "2018",
                "2018",
                "2018",
                "2019"
            ]
        }
    }
};
var data_pie = {
    "Contributor": {
        "2008": {
            "data": [
                {
                    "name": "Puppet",
                    "y": 10,
                    "z": 0.0
                },
                {
                    "name": "Pub",
                    "y": 1,
                    "z": 0.0
                },
                {
                    "name": "PlatformIO",
                    "y": 3,
                    "z": 0.0
                },
                {
                    "name": "Hex",
                    "y": 15,
                    "z": 0.0
                },
                {
                    "name": "CocoaPods",
                    "y": 111,
                    "z": 0.0
                },
                {
                    "name": "Clojars",
                    "y": 104,
                    "z": 0.0
                },
                {
                    "name": "Cargo",
                    "y": 1,
                    "z": 0.0
                },
                {
                    "name": "CRAN",
                    "y": 89,
                    "z": 0.0
                },
                {
                    "name": "Atom",
                    "y": 0,
                    "z": 0
                },
                {
                    "name": "Packagist",
                    "y": 1224,
                    "z": 0.57
                },
                {
                    "name": "NuGet",
                    "y": 676,
                    "z": 0.74
                },
                {
                    "name": "Meteor",
                    "y": 73,
                    "z": 1.37
                },
                {
                    "name": "Hackage",
                    "y": 270,
                    "z": 1.48
                },
                {
                    "name": "Pypi",
                    "y": 2068,
                    "z": 1.6
                },
                {
                    "name": "RubyGems",
                    "y": 3216,
                    "z": 1.68
                },
                {
                    "name": "Maven",
                    "y": 2100,
                    "z": 1.81
                },
                {
                    "name": "NPM",
                    "y": 1670,
                    "z": 1.92
                },
                {
                    "name": "Bower",
                    "y": 559,
                    "z": 1.97
                },
                {
                    "name": "Bower",
                    "y": 559,
                    "z": 1.97
                },
                {
                    "name": "Go",
                    "y": 84,
                    "z": 2.38
                },
                {
                    "name": "CPAN",
                    "y": 520,
                    "z": 2.69
                },
                {
                    "name": "CPAN",
                    "y": 520,
                    "z": 2.69
                }
            ],
            "subtitle": "2008",
            "title": "Contributors by Ecosystem Size and % Women"
        },
        "2009": {
            "data": [
                {
                    "name": "Puppet",
                    "y": 21,
                    "z": 0.0
                },
                {
                    "name": "Pub",
                    "y": 1,
                    "z": 0.0
                },
                {
                    "name": "PlatformIO",
                    "y": 22,
                    "z": 0.0
                },
                {
                    "name": "Hex",
                    "y": 69,
                    "z": 0.0
                },
                {
                    "name": "Cargo",
                    "y": 18,
                    "z": 0.0
                },
                {
                    "name": "CRAN",
                    "y": 128,
                    "z": 0.0
                },
                {
                    "name": "Atom",
                    "y": 0,
                    "z": 0
                },
                {
                    "name": "CocoaPods",
                    "y": 344,
                    "z": 0.58
                },
                {
                    "name": "Go",
                    "y": 315,
                    "z": 0.95
                },
                {
                    "name": "NuGet",
                    "y": 1125,
                    "z": 0.98
                },
                {
                    "name": "Packagist",
                    "y": 2038,
                    "z": 1.08
                },
                {
                    "name": "RubyGems",
                    "y": 7412,
                    "z": 1.43
                },
                {
                    "name": "Pypi",
                    "y": 3716,
                    "z": 1.72
                },
                {
                    "name": "Clojars",
                    "y": 399,
                    "z": 1.75
                },
                {
                    "name": "Maven",
                    "y": 3442,
                    "z": 1.8
                },
                {
                    "name": "Hackage",
                    "y": 431,
                    "z": 1.86
                },
                {
                    "name": "NPM",
                    "y": 2566,
                    "z": 1.99
                },
                {
                    "name": "Bower",
                    "y": 1078,
                    "z": 2.23
                },
                {
                    "name": "Bower",
                    "y": 1078,
                    "z": 2.23
                },
                {
                    "name": "CPAN",
                    "y": 803,
                    "z": 2.99
                },
                {
                    "name": "CPAN",
                    "y": 803,
                    "z": 2.99
                },
                {
                    "name": "Meteor",
                    "y": 95,
                    "z": 5.26
                },
                {
                    "name": "Meteor",
                    "y": 95,
                    "z": 5.26
                }
            ],
            "subtitle": "2009",
            "title": "Contributors by Ecosystem Size and % Women"
        },
        "2010": {
            "data": [
                {
                    "name": "Pub",
                    "y": 0,
                    "z": 0
                },
                {
                    "name": "Cargo",
                    "y": 29,
                    "z": 0.0
                },
                {
                    "name": "CRAN",
                    "y": 212,
                    "z": 0.0
                },
                {
                    "name": "Atom",
                    "y": 1,
                    "z": 0.0
                },
                {
                    "name": "Packagist",
                    "y": 3759,
                    "z": 1.04
                },
                {
                    "name": "NuGet",
                    "y": 2247,
                    "z": 1.29
                },
                {
                    "name": "Hex",
                    "y": 194,
                    "z": 1.55
                },
                {
                    "name": "NPM",
                    "y": 6422,
                    "z": 1.67
                },
                {
                    "name": "Hackage",
                    "y": 714,
                    "z": 1.68
                },
                {
                    "name": "RubyGems",
                    "y": 13094,
                    "z": 1.71
                },
                {
                    "name": "Bower",
                    "y": 3902,
                    "z": 1.74
                },
                {
                    "name": "Bower",
                    "y": 3902,
                    "z": 1.74
                },
                {
                    "name": "CocoaPods",
                    "y": 899,
                    "z": 1.78
                },
                {
                    "name": "Maven",
                    "y": 6687,
                    "z": 1.81
                },
                {
                    "name": "Pypi",
                    "y": 6820,
                    "z": 2.02
                },
                {
                    "name": "Clojars",
                    "y": 1314,
                    "z": 2.21
                },
                {
                    "name": "Go",
                    "y": 840,
                    "z": 2.26
                },
                {
                    "name": "Meteor",
                    "y": 187,
                    "z": 2.67
                },
                {
                    "name": "CPAN",
                    "y": 1131,
                    "z": 2.92
                },
                {
                    "name": "CPAN",
                    "y": 1131,
                    "z": 2.92
                },
                {
                    "name": "Puppet",
                    "y": 63,
                    "z": 4.76
                },
                {
                    "name": "PlatformIO",
                    "y": 41,
                    "z": 9.76
                },
                {
                    "name": "PlatformIO",
                    "y": 41,
                    "z": 9.76
                }
            ],
            "subtitle": "2010",
            "title": "Contributors by Ecosystem Size and % Women"
        },
        "2011": {
            "data": [
                {
                    "name": "Pub",
                    "y": 1,
                    "z": 0.0
                },
                {
                    "name": "Cargo",
                    "y": 70,
                    "z": 0.0
                },
                {
                    "name": "Atom",
                    "y": 1,
                    "z": 0.0
                },
                {
                    "name": "Packagist",
                    "y": 9519,
                    "z": 1.1
                },
                {
                    "name": "Hackage",
                    "y": 1178,
                    "z": 1.1
                },
                {
                    "name": "Hex",
                    "y": 425,
                    "z": 1.18
                },
                {
                    "name": "NuGet",
                    "y": 5582,
                    "z": 1.29
                },
                {
                    "name": "NPM",
                    "y": 19110,
                    "z": 1.55
                },
                {
                    "name": "Clojars",
                    "y": 2355,
                    "z": 1.61
                },
                {
                    "name": "Bower",
                    "y": 11699,
                    "z": 1.67
                },
                {
                    "name": "Bower",
                    "y": 11699,
                    "z": 1.67
                },
                {
                    "name": "Maven",
                    "y": 14532,
                    "z": 1.7
                },
                {
                    "name": "Meteor",
                    "y": 579,
                    "z": 1.73
                },
                {
                    "name": "CRAN",
                    "y": 289,
                    "z": 1.73
                },
                {
                    "name": "RubyGems",
                    "y": 25134,
                    "z": 1.84
                },
                {
                    "name": "CocoaPods",
                    "y": 3034,
                    "z": 1.85
                },
                {
                    "name": "Pypi",
                    "y": 13216,
                    "z": 1.87
                },
                {
                    "name": "Go",
                    "y": 2133,
                    "z": 2.02
                },
                {
                    "name": "Puppet",
                    "y": 246,
                    "z": 2.03
                },
                {
                    "name": "PlatformIO",
                    "y": 130,
                    "z": 3.85
                },
                {
                    "name": "CPAN",
                    "y": 1598,
                    "z": 3.88
                },
                {
                    "name": "CPAN",
                    "y": 1598,
                    "z": 3.88
                }
            ],
            "subtitle": "2011",
            "title": "Contributors by Ecosystem Size and % Women"
        },
        "2012": {
            "data": [
                {
                    "name": "Cargo",
                    "y": 170,
                    "z": 0.59
                },
                {
                    "name": "Hex",
                    "y": 745,
                    "z": 1.21
                },
                {
                    "name": "Puppet",
                    "y": 1122,
                    "z": 1.25
                },
                {
                    "name": "NuGet",
                    "y": 12067,
                    "z": 1.36
                },
                {
                    "name": "Packagist",
                    "y": 22309,
                    "z": 1.45
                },
                {
                    "name": "Clojars",
                    "y": 4412,
                    "z": 1.47
                },
                {
                    "name": "CocoaPods",
                    "y": 7865,
                    "z": 1.56
                },
                {
                    "name": "NPM",
                    "y": 42917,
                    "z": 1.58
                },
                {
                    "name": "Bower",
                    "y": 25754,
                    "z": 1.63
                },
                {
                    "name": "Meteor",
                    "y": 2096,
                    "z": 1.72
                },
                {
                    "name": "Maven",
                    "y": 28072,
                    "z": 1.77
                },
                {
                    "name": "Hackage",
                    "y": 2121,
                    "z": 1.79
                },
                {
                    "name": "Go",
                    "y": 5894,
                    "z": 1.87
                },
                {
                    "name": "RubyGems",
                    "y": 42935,
                    "z": 1.9
                },
                {
                    "name": "Pypi",
                    "y": 25360,
                    "z": 1.96
                },
                {
                    "name": "PlatformIO",
                    "y": 374,
                    "z": 2.94
                },
                {
                    "name": "Pub",
                    "y": 163,
                    "z": 3.07
                },
                {
                    "name": "CPAN",
                    "y": 1996,
                    "z": 3.11
                },
                {
                    "name": "CRAN",
                    "y": 594,
                    "z": 3.37
                },
                {
                    "name": "Atom",
                    "y": 112,
                    "z": 4.46
                }
            ],
            "subtitle": "2012",
            "title": "Contributors by Ecosystem Size and % Women"
        },
        "2013": {
            "data": [
                {
                    "name": "Hex",
                    "y": 1216,
                    "z": 1.15
                },
                {
                    "name": "Puppet",
                    "y": 3088,
                    "z": 1.36
                },
                {
                    "name": "Cargo",
                    "y": 328,
                    "z": 1.52
                },
                {
                    "name": "CocoaPods",
                    "y": 15472,
                    "z": 1.54
                },
                {
                    "name": "NuGet",
                    "y": 23446,
                    "z": 1.58
                },
                {
                    "name": "Packagist",
                    "y": 44920,
                    "z": 1.71
                },
                {
                    "name": "Go",
                    "y": 16992,
                    "z": 1.79
                },
                {
                    "name": "Clojars",
                    "y": 6823,
                    "z": 1.86
                },
                {
                    "name": "PlatformIO",
                    "y": 694,
                    "z": 1.87
                },
                {
                    "name": "Bower",
                    "y": 53670,
                    "z": 1.87
                },
                {
                    "name": "NPM",
                    "y": 86797,
                    "z": 1.88
                },
                {
                    "name": "Hackage",
                    "y": 2868,
                    "z": 1.95
                },
                {
                    "name": "Maven",
                    "y": 50218,
                    "z": 1.99
                },
                {
                    "name": "Atom",
                    "y": 339,
                    "z": 2.06
                },
                {
                    "name": "RubyGems",
                    "y": 62161,
                    "z": 2.14
                },
                {
                    "name": "Meteor",
                    "y": 6853,
                    "z": 2.16
                },
                {
                    "name": "Pypi",
                    "y": 43300,
                    "z": 2.25
                },
                {
                    "name": "Pub",
                    "y": 726,
                    "z": 3.03
                },
                {
                    "name": "CRAN",
                    "y": 1288,
                    "z": 3.18
                },
                {
                    "name": "CPAN",
                    "y": 2759,
                    "z": 3.33
                },
                {
                    "name": "CPAN",
                    "y": 2759,
                    "z": 3.33
                }
            ],
            "subtitle": "2013",
            "title": "Contributors by Ecosystem Size and % Women"
        },
        "2014": {
            "data": [
                {
                    "name": "Hex",
                    "y": 2013,
                    "z": 1.19
                },
                {
                    "name": "Puppet",
                    "y": 5070,
                    "z": 1.44
                },
                {
                    "name": "NuGet",
                    "y": 35799,
                    "z": 1.7
                },
                {
                    "name": "Clojars",
                    "y": 9321,
                    "z": 1.7
                },
                {
                    "name": "Atom",
                    "y": 3525,
                    "z": 1.73
                },
                {
                    "name": "PlatformIO",
                    "y": 1257,
                    "z": 1.83
                },
                {
                    "name": "Packagist",
                    "y": 68554,
                    "z": 1.84
                },
                {
                    "name": "Go",
                    "y": 38519,
                    "z": 2.02
                },
                {
                    "name": "CocoaPods",
                    "y": 23675,
                    "z": 2.02
                },
                {
                    "name": "Meteor",
                    "y": 13489,
                    "z": 2.12
                },
                {
                    "name": "Hackage",
                    "y": 4334,
                    "z": 2.12
                },
                {
                    "name": "NPM",
                    "y": 145724,
                    "z": 2.21
                },
                {
                    "name": "Maven",
                    "y": 74904,
                    "z": 2.24
                },
                {
                    "name": "Bower",
                    "y": 83565,
                    "z": 2.26
                },
                {
                    "name": "Bower",
                    "y": 83565,
                    "z": 2.26
                },
                {
                    "name": "RubyGems",
                    "y": 69922,
                    "z": 2.6
                },
                {
                    "name": "Pypi",
                    "y": 63379,
                    "z": 2.63
                },
                {
                    "name": "Pub",
                    "y": 1333,
                    "z": 2.63
                },
                {
                    "name": "Cargo",
                    "y": 1723,
                    "z": 2.84
                },
                {
                    "name": "CPAN",
                    "y": 3068,
                    "z": 2.97
                },
                {
                    "name": "CPAN",
                    "y": 3068,
                    "z": 2.97
                },
                {
                    "name": "CRAN",
                    "y": 2574,
                    "z": 4.12
                },
                {
                    "name": "CRAN",
                    "y": 2574,
                    "z": 4.12
                }
            ],
            "subtitle": "2014",
            "title": "Contributors by Ecosystem Size and % Women"
        },
        "2015": {
            "data": [
                {
                    "name": "Puppet",
                    "y": 6085,
                    "z": 1.59
                },
                {
                    "name": "PlatformIO",
                    "y": 2435,
                    "z": 1.77
                },
                {
                    "name": "Clojars",
                    "y": 11791,
                    "z": 1.81
                },
                {
                    "name": "Packagist",
                    "y": 91412,
                    "z": 1.93
                },
                {
                    "name": "Atom",
                    "y": 7770,
                    "z": 1.94
                },
                {
                    "name": "NuGet",
                    "y": 47731,
                    "z": 1.96
                },
                {
                    "name": "Hackage",
                    "y": 5179,
                    "z": 1.97
                },
                {
                    "name": "Hex",
                    "y": 3634,
                    "z": 2.06
                },
                {
                    "name": "CocoaPods",
                    "y": 35443,
                    "z": 2.14
                },
                {
                    "name": "Meteor",
                    "y": 19357,
                    "z": 2.22
                },
                {
                    "name": "Go",
                    "y": 63442,
                    "z": 2.25
                },
                {
                    "name": "Cargo",
                    "y": 4825,
                    "z": 2.42
                },
                {
                    "name": "Maven",
                    "y": 98947,
                    "z": 2.45
                },
                {
                    "name": "Bower",
                    "y": 110499,
                    "z": 2.51
                },
                {
                    "name": "Bower",
                    "y": 110499,
                    "z": 2.51
                },
                {
                    "name": "Pub",
                    "y": 1911,
                    "z": 2.56
                },
                {
                    "name": "NPM",
                    "y": 220059,
                    "z": 2.59
                },
                {
                    "name": "CPAN",
                    "y": 3256,
                    "z": 2.73
                },
                {
                    "name": "CPAN",
                    "y": 3256,
                    "z": 2.73
                },
                {
                    "name": "Pypi",
                    "y": 85646,
                    "z": 2.82
                },
                {
                    "name": "RubyGems",
                    "y": 73175,
                    "z": 2.99
                },
                {
                    "name": "CRAN",
                    "y": 4312,
                    "z": 4.15
                },
                {
                    "name": "CRAN",
                    "y": 4312,
                    "z": 4.15
                }
            ],
            "subtitle": "2015",
            "title": "Contributors by Ecosystem Size and % Women"
        },
        "2016": {
            "data": [
                {
                    "name": "Puppet",
                    "y": 5874,
                    "z": 1.77
                },
                {
                    "name": "PlatformIO",
                    "y": 3959,
                    "z": 1.77
                },
                {
                    "name": "Packagist",
                    "y": 107750,
                    "z": 2.0
                },
                {
                    "name": "Hex",
                    "y": 6501,
                    "z": 2.11
                },
                {
                    "name": "Hackage",
                    "y": 5165,
                    "z": 2.11
                },
                {
                    "name": "Cargo",
                    "y": 7589,
                    "z": 2.12
                },
                {
                    "name": "Atom",
                    "y": 8553,
                    "z": 2.13
                },
                {
                    "name": "NuGet",
                    "y": 54960,
                    "z": 2.16
                },
                {
                    "name": "CocoaPods",
                    "y": 47713,
                    "z": 2.35
                },
                {
                    "name": "Clojars",
                    "y": 12820,
                    "z": 2.36
                },
                {
                    "name": "Go",
                    "y": 72321,
                    "z": 2.5
                },
                {
                    "name": "Pub",
                    "y": 1964,
                    "z": 2.7
                },
                {
                    "name": "Meteor",
                    "y": 15384,
                    "z": 2.76
                },
                {
                    "name": "Bower",
                    "y": 107349,
                    "z": 2.77
                },
                {
                    "name": "Bower",
                    "y": 107349,
                    "z": 2.77
                },
                {
                    "name": "Maven",
                    "y": 110201,
                    "z": 2.78
                },
                {
                    "name": "NPM",
                    "y": 293952,
                    "z": 2.88
                },
                {
                    "name": "Pypi",
                    "y": 107400,
                    "z": 3.05
                },
                {
                    "name": "CPAN",
                    "y": 2922,
                    "z": 3.05
                },
                {
                    "name": "CPAN",
                    "y": 2922,
                    "z": 3.05
                },
                {
                    "name": "RubyGems",
                    "y": 69744,
                    "z": 3.31
                },
                {
                    "name": "CRAN",
                    "y": 5969,
                    "z": 4.29
                },
                {
                    "name": "CRAN",
                    "y": 5969,
                    "z": 4.29
                }
            ],
            "subtitle": "2016",
            "title": "Contributors by Ecosystem Size and % Women"
        },
        "2017": {
            "data": [
                {
                    "name": "PlatformIO",
                    "y": 4894,
                    "z": 1.74
                },
                {
                    "name": "Packagist",
                    "y": 122018,
                    "z": 2.02
                },
                {
                    "name": "Puppet",
                    "y": 5082,
                    "z": 2.16
                },
                {
                    "name": "NuGet",
                    "y": 62438,
                    "z": 2.18
                },
                {
                    "name": "Hackage",
                    "y": 5551,
                    "z": 2.22
                },
                {
                    "name": "Hex",
                    "y": 8377,
                    "z": 2.26
                },
                {
                    "name": "Atom",
                    "y": 8858,
                    "z": 2.53
                },
                {
                    "name": "Cargo",
                    "y": 12263,
                    "z": 2.56
                },
                {
                    "name": "CocoaPods",
                    "y": 52063,
                    "z": 2.6
                },
                {
                    "name": "CPAN",
                    "y": 2659,
                    "z": 2.63
                },
                {
                    "name": "Clojars",
                    "y": 13313,
                    "z": 2.67
                },
                {
                    "name": "Go",
                    "y": 83664,
                    "z": 2.79
                },
                {
                    "name": "Meteor",
                    "y": 9533,
                    "z": 2.96
                },
                {
                    "name": "Bower",
                    "y": 93886,
                    "z": 3.0
                },
                {
                    "name": "Bower",
                    "y": 93886,
                    "z": 3.0
                },
                {
                    "name": "Pub",
                    "y": 2721,
                    "z": 3.09
                },
                {
                    "name": "Maven",
                    "y": 119276,
                    "z": 3.13
                },
                {
                    "name": "NPM",
                    "y": 370830,
                    "z": 3.16
                },
                {
                    "name": "Pypi",
                    "y": 139362,
                    "z": 3.34
                },
                {
                    "name": "RubyGems",
                    "y": 65275,
                    "z": 3.66
                },
                {
                    "name": "CRAN",
                    "y": 7971,
                    "z": 5.65
                },
                {
                    "name": "CRAN",
                    "y": 7971,
                    "z": 5.65
                }
            ],
            "subtitle": "2017",
            "title": "Contributors by Ecosystem Size and % Women"
        },
        "2018": {
            "data": [
                {
                    "name": "PlatformIO",
                    "y": 6150,
                    "z": 1.43
                },
                {
                    "name": "Hex",
                    "y": 8594,
                    "z": 2.13
                },
                {
                    "name": "Packagist",
                    "y": 126235,
                    "z": 2.14
                },
                {
                    "name": "NuGet",
                    "y": 66748,
                    "z": 2.23
                },
                {
                    "name": "Pub",
                    "y": 6331,
                    "z": 2.5
                },
                {
                    "name": "Puppet",
                    "y": 4702,
                    "z": 2.53
                },
                {
                    "name": "Hackage",
                    "y": 5955,
                    "z": 2.64
                },
                {
                    "name": "CocoaPods",
                    "y": 51165,
                    "z": 2.72
                },
                {
                    "name": "Cargo",
                    "y": 18440,
                    "z": 2.73
                },
                {
                    "name": "Atom",
                    "y": 5661,
                    "z": 2.79
                },
                {
                    "name": "Go",
                    "y": 100341,
                    "z": 2.84
                },
                {
                    "name": "CPAN",
                    "y": 2376,
                    "z": 2.86
                },
                {
                    "name": "Clojars",
                    "y": 11801,
                    "z": 2.9
                },
                {
                    "name": "Meteor",
                    "y": 5930,
                    "z": 3.07
                },
                {
                    "name": "Maven",
                    "y": 112999,
                    "z": 3.27
                },
                {
                    "name": "Bower",
                    "y": 72442,
                    "z": 3.28
                },
                {
                    "name": "Bower",
                    "y": 72442,
                    "z": 3.28
                },
                {
                    "name": "NPM",
                    "y": 427996,
                    "z": 3.34
                },
                {
                    "name": "Pypi",
                    "y": 178898,
                    "z": 3.53
                },
                {
                    "name": "RubyGems",
                    "y": 59595,
                    "z": 4.03
                },
                {
                    "name": "CRAN",
                    "y": 9574,
                    "z": 6.55
                },
                {
                    "name": "CRAN",
                    "y": 9574,
                    "z": 6.55
                }
            ],
            "subtitle": "2018",
            "title": "Contributors by Ecosystem Size and % Women"
        },
        "2019": {
            "data": [
                {
                    "name": "PlatformIO",
                    "y": 1650,
                    "z": 1.76
                },
                {
                    "name": "Packagist",
                    "y": 31059,
                    "z": 2.18
                },
                {
                    "name": "NuGet",
                    "y": 17283,
                    "z": 2.26
                },
                {
                    "name": "Pub",
                    "y": 2869,
                    "z": 2.37
                },
                {
                    "name": "CPAN",
                    "y": 504,
                    "z": 2.38
                },
                {
                    "name": "Hex",
                    "y": 2092,
                    "z": 2.39
                },
                {
                    "name": "Puppet",
                    "y": 980,
                    "z": 2.45
                },
                {
                    "name": "Atom",
                    "y": 938,
                    "z": 2.45
                },
                {
                    "name": "CocoaPods",
                    "y": 12014,
                    "z": 2.61
                },
                {
                    "name": "Go",
                    "y": 25670,
                    "z": 2.77
                },
                {
                    "name": "Cargo",
                    "y": 5949,
                    "z": 3.03
                },
                {
                    "name": "Hackage",
                    "y": 1417,
                    "z": 3.11
                },
                {
                    "name": "Clojars",
                    "y": 2699,
                    "z": 3.15
                },
                {
                    "name": "Meteor",
                    "y": 1166,
                    "z": 3.34
                },
                {
                    "name": "Maven",
                    "y": 25964,
                    "z": 3.37
                },
                {
                    "name": "NPM",
                    "y": 109115,
                    "z": 3.38
                },
                {
                    "name": "Bower",
                    "y": 14609,
                    "z": 3.59
                },
                {
                    "name": "Bower",
                    "y": 14609,
                    "z": 3.59
                },
                {
                    "name": "Pypi",
                    "y": 48861,
                    "z": 3.6
                },
                {
                    "name": "RubyGems",
                    "y": 13638,
                    "z": 3.77
                },
                {
                    "name": "CRAN",
                    "y": 2545,
                    "z": 6.95
                },
                {
                    "name": "CRAN",
                    "y": 2545,
                    "z": 6.95
                }
            ],
            "subtitle": "2019",
            "title": "Contributors by Ecosystem Size and % Women"
        }
    }
};
var data_bar = {
    "Contributor": {
        "male_female": {
            "data": [
                {
                    "color": "#de2d26",
                    "data": [
                        125997,
                        811,
                        15073,
                        706,
                        1861,
                        1331,
                        1722,
                        5850,
                        10395,
                        758,
                        689,
                        17426,
                        1849,
                        49869,
                        6621,
                        12293,
                        371,
                        474,
                        591,
                        22041,
                        14611
                    ],
                    "name": "Women",
                    "type": "column"
                },
                {
                    "color": "#f29d4b",
                    "data": [
                        3176436,
                        25889,
                        410331,
                        18048,
                        24748,
                        37638,
                        58463,
                        159478,
                        276983,
                        28017,
                        26863,
                        450703,
                        54396,
                        1165826,
                        228637,
                        423368,
                        14054,
                        12186,
                        25171,
                        498373,
                        385729
                    ],
                    "name": "Men",
                    "type": "column"
                }
            ],
            "height_ratio": 46.15384615384615,
            "label_x": "Languages",
            "label_y": "Total Number of Contributors",
            "title": "Active Contributors All Languages 2008-3 - 2019-3",
            "x_categories": [
                "All",
                "Atom",
                "Bower",
                "CPAN",
                "CRAN",
                "Cargo",
                "Clojars",
                "CocoaPods",
                "Go",
                "Hackage",
                "Hex",
                "Maven",
                "Meteor",
                "NPM",
                "NuGet",
                "Packagist",
                "PlatformIO",
                "Pub",
                "Puppet",
                "Pypi",
                "RubyGems"
            ]
        }
    }
};
var data_stack = {
    "Contributor": {
        "data": [
            {
                "data": [
                    NaN,
                    NaN,
                    NaN,
                    NaN,
                    NaN,
                    NaN,
                    NaN,
                    NaN,
                    NaN,
                    NaN,
                    0.0,
                    NaN,
                    NaN,
                    NaN,
                    0.0,
                    NaN,
                    14.29,
                    7.14,
                    3.85,
                    3.08,
                    1.22,
                    2.56,
                    2.13,
                    2.35,
                    1.79,
                    1.97,
                    1.5,
                    1.67,
                    1.92,
                    1.87,
                    1.77,
                    2.21,
                    1.8,
                    2.34,
                    1.71,
                    2.66,
                    2.59,
                    2.47,
                    2.5,
                    2.54,
                    2.61,
                    3.44,
                    2.86,
                    2.17,
                    2.45
                ],
                "name": "Atom"
            },
            {
                "data": [
                    1.09,
                    2.34,
                    1.94,
                    2.17,
                    2.26,
                    3.83,
                    1.93,
                    1.38,
                    1.07,
                    2.22,
                    1.92,
                    1.63,
                    1.72,
                    1.5,
                    1.75,
                    1.69,
                    1.34,
                    1.89,
                    1.6,
                    1.66,
                    1.85,
                    1.69,
                    1.98,
                    1.93,
                    2.02,
                    2.33,
                    2.37,
                    2.29,
                    2.41,
                    2.49,
                    2.59,
                    2.53,
                    2.63,
                    2.8,
                    2.83,
                    2.83,
                    2.82,
                    3.08,
                    2.95,
                    3.19,
                    3.05,
                    3.36,
                    3.37,
                    3.4,
                    3.59
                ],
                "name": "Bower"
            },
            {
                "data": [
                    4.17,
                    2.29,
                    2.8,
                    2.0,
                    2.29,
                    2.09,
                    3.12,
                    4.23,
                    2.69,
                    2.22,
                    3.51,
                    3.16,
                    4.56,
                    3.15,
                    3.49,
                    4.29,
                    3.4,
                    3.51,
                    2.44,
                    3.07,
                    3.04,
                    3.35,
                    3.45,
                    3.47,
                    3.13,
                    3.24,
                    2.81,
                    2.7,
                    2.54,
                    3.2,
                    2.62,
                    2.6,
                    2.78,
                    3.05,
                    3.42,
                    2.95,
                    3.06,
                    2.88,
                    2.13,
                    2.42,
                    2.89,
                    3.39,
                    2.7,
                    2.41,
                    2.38
                ],
                "name": "CPAN"
            },
            {
                "data": [
                    0.0,
                    0.0,
                    0.0,
                    0.0,
                    0.0,
                    0.0,
                    0.0,
                    0.0,
                    0.0,
                    0.0,
                    0.0,
                    0.0,
                    1.89,
                    1.67,
                    1.3,
                    2.02,
                    2.52,
                    4.32,
                    3.39,
                    3.14,
                    3.63,
                    2.73,
                    3.13,
                    3.28,
                    3.51,
                    3.72,
                    4.32,
                    4.66,
                    4.14,
                    4.32,
                    4.29,
                    3.86,
                    3.7,
                    4.5,
                    4.34,
                    4.52,
                    5.04,
                    5.71,
                    5.98,
                    5.77,
                    5.87,
                    6.81,
                    6.8,
                    6.68,
                    6.95
                ],
                "name": "CRAN"
            },
            {
                "data": [
                    NaN,
                    NaN,
                    NaN,
                    0.0,
                    0.0,
                    0.0,
                    0.0,
                    0.0,
                    0.0,
                    0.0,
                    0.0,
                    0.0,
                    0.0,
                    0.0,
                    0.0,
                    0.0,
                    0.0,
                    2.86,
                    0.0,
                    0.0,
                    0.0,
                    0.0,
                    2.0,
                    2.4,
                    3.9,
                    3.4,
                    2.47,
                    2.66,
                    1.83,
                    2.54,
                    2.57,
                    2.65,
                    2.5,
                    1.8,
                    2.08,
                    2.14,
                    1.88,
                    2.48,
                    3.03,
                    2.73,
                    2.59,
                    2.93,
                    2.92,
                    2.52,
                    3.03
                ],
                "name": "Cargo"
            },
            {
                "data": [
                    0.0,
                    0.0,
                    0.0,
                    0.0,
                    2.17,
                    1.3,
                    0.97,
                    2.31,
                    2.72,
                    2.16,
                    2.75,
                    1.44,
                    1.92,
                    1.38,
                    1.77,
                    1.45,
                    1.35,
                    1.43,
                    1.64,
                    1.45,
                    2.14,
                    2.04,
                    1.66,
                    1.68,
                    1.67,
                    1.56,
                    1.9,
                    1.64,
                    1.84,
                    1.68,
                    1.87,
                    1.83,
                    2.18,
                    2.32,
                    2.52,
                    2.41,
                    2.45,
                    2.88,
                    2.79,
                    2.58,
                    2.8,
                    2.77,
                    3.19,
                    2.84,
                    3.15
                ],
                "name": "Clojars"
            },
            {
                "data": [
                    0.0,
                    0.0,
                    0.0,
                    0.0,
                    0.0,
                    0.0,
                    1.08,
                    0.85,
                    0.75,
                    2.31,
                    1.17,
                    2.39,
                    1.7,
                    2.24,
                    1.5,
                    1.95,
                    1.63,
                    1.37,
                    1.46,
                    1.76,
                    1.6,
                    1.24,
                    1.55,
                    1.7,
                    1.89,
                    1.95,
                    2.12,
                    2.09,
                    2.14,
                    2.19,
                    2.03,
                    2.2,
                    2.39,
                    2.2,
                    2.43,
                    2.37,
                    2.68,
                    2.63,
                    2.46,
                    2.63,
                    2.58,
                    2.74,
                    2.75,
                    2.8,
                    2.61
                ],
                "name": "CocoaPods"
            },
            {
                "data": [
                    6.67,
                    0.0,
                    3.57,
                    0.0,
                    0.0,
                    1.82,
                    0.0,
                    1.16,
                    2.99,
                    2.56,
                    1.96,
                    1.91,
                    1.69,
                    2.16,
                    2.12,
                    2.0,
                    2.19,
                    2.08,
                    1.74,
                    1.69,
                    1.68,
                    1.89,
                    1.84,
                    1.74,
                    1.91,
                    1.9,
                    2.07,
                    2.15,
                    2.17,
                    2.13,
                    2.3,
                    2.36,
                    2.4,
                    2.53,
                    2.53,
                    2.55,
                    2.49,
                    2.76,
                    3.05,
                    2.86,
                    2.77,
                    2.85,
                    2.9,
                    2.86,
                    2.77
                ],
                "name": "Go"
            },
            {
                "data": [
                    1.72,
                    1.79,
                    1.49,
                    1.12,
                    1.77,
                    2.06,
                    2.02,
                    1.64,
                    0.0,
                    1.8,
                    1.1,
                    3.12,
                    0.41,
                    1.75,
                    1.27,
                    0.9,
                    1.47,
                    2.05,
                    1.55,
                    2.08,
                    1.92,
                    1.48,
                    2.0,
                    2.33,
                    2.13,
                    1.95,
                    2.04,
                    2.37,
                    1.66,
                    2.37,
                    1.82,
                    2.01,
                    1.84,
                    2.09,
                    2.28,
                    2.24,
                    2.05,
                    2.31,
                    1.76,
                    2.72,
                    2.96,
                    2.45,
                    2.64,
                    2.49,
                    3.11
                ],
                "name": "Hackage"
            },
            {
                "data": [
                    0.0,
                    0.0,
                    0.0,
                    0.0,
                    0.0,
                    0.0,
                    0.0,
                    0.0,
                    3.7,
                    2.86,
                    1.35,
                    0.0,
                    2.17,
                    1.16,
                    1.72,
                    0.0,
                    0.56,
                    1.18,
                    1.61,
                    1.44,
                    1.68,
                    1.42,
                    0.3,
                    1.37,
                    1.5,
                    0.65,
                    1.44,
                    1.17,
                    1.65,
                    1.9,
                    2.27,
                    2.23,
                    2.05,
                    2.4,
                    2.11,
                    1.9,
                    2.25,
                    2.01,
                    2.04,
                    2.71,
                    2.06,
                    2.11,
                    2.09,
                    2.25,
                    2.39
                ],
                "name": "Hex"
            },
            {
                "data": [
                    1.84,
                    1.79,
                    2.17,
                    1.48,
                    1.51,
                    2.0,
                    1.65,
                    1.97,
                    1.73,
                    1.78,
                    1.69,
                    1.97,
                    1.75,
                    1.59,
                    1.67,
                    1.78,
                    1.52,
                    1.64,
                    1.95,
                    1.87,
                    1.9,
                    1.86,
                    2.07,
                    2.07,
                    2.26,
                    2.22,
                    2.32,
                    2.16,
                    2.27,
                    2.46,
                    2.57,
                    2.47,
                    2.76,
                    2.81,
                    2.86,
                    2.69,
                    2.87,
                    3.04,
                    3.25,
                    3.36,
                    3.15,
                    3.21,
                    3.42,
                    3.31,
                    3.37
                ],
                "name": "Maven"
            },
            {
                "data": [
                    0.0,
                    0.0,
                    0.0,
                    4.55,
                    4.0,
                    9.09,
                    4.17,
                    4.17,
                    3.85,
                    3.33,
                    2.99,
                    1.56,
                    3.41,
                    1.67,
                    1.46,
                    1.28,
                    1.01,
                    1.52,
                    1.16,
                    2.59,
                    2.51,
                    1.98,
                    2.13,
                    2.13,
                    2.09,
                    2.09,
                    2.21,
                    2.09,
                    1.8,
                    2.29,
                    2.52,
                    2.27,
                    2.6,
                    2.81,
                    2.91,
                    2.78,
                    2.8,
                    2.89,
                    2.94,
                    3.29,
                    2.77,
                    2.68,
                    3.71,
                    3.22,
                    3.34
                ],
                "name": "Meteor"
            },
            {
                "data": [
                    2.29,
                    1.43,
                    1.85,
                    2.19,
                    1.59,
                    2.29,
                    2.4,
                    1.75,
                    1.21,
                    1.83,
                    1.78,
                    1.68,
                    1.69,
                    1.42,
                    1.65,
                    1.49,
                    1.4,
                    1.59,
                    1.69,
                    1.6,
                    1.72,
                    1.72,
                    2.01,
                    1.98,
                    2.01,
                    2.16,
                    2.34,
                    2.29,
                    2.4,
                    2.62,
                    2.61,
                    2.69,
                    2.76,
                    2.83,
                    2.98,
                    2.92,
                    3.02,
                    3.14,
                    3.23,
                    3.22,
                    3.19,
                    3.34,
                    3.43,
                    3.39,
                    3.38
                ],
                "name": "NPM"
            },
            {
                "data": [
                    0.85,
                    1.54,
                    0.53,
                    0.41,
                    1.22,
                    1.27,
                    1.03,
                    0.57,
                    0.9,
                    1.55,
                    1.34,
                    1.3,
                    1.28,
                    1.27,
                    1.59,
                    1.04,
                    0.99,
                    1.05,
                    1.47,
                    1.73,
                    1.51,
                    1.41,
                    1.65,
                    1.7,
                    1.71,
                    1.54,
                    1.83,
                    1.69,
                    1.72,
                    1.88,
                    2.11,
                    2.13,
                    2.01,
                    2.23,
                    2.19,
                    2.21,
                    2.04,
                    2.18,
                    2.32,
                    2.18,
                    2.25,
                    2.25,
                    2.11,
                    2.29,
                    2.26
                ],
                "name": "NuGet"
            },
            {
                "data": [
                    0.67,
                    0.0,
                    0.64,
                    0.91,
                    1.0,
                    1.24,
                    1.43,
                    0.67,
                    0.98,
                    1.22,
                    1.1,
                    0.9,
                    1.04,
                    0.83,
                    0.98,
                    1.41,
                    1.31,
                    1.46,
                    1.43,
                    1.56,
                    1.72,
                    1.61,
                    1.7,
                    1.77,
                    1.78,
                    1.72,
                    1.89,
                    1.94,
                    1.81,
                    1.97,
                    2.0,
                    1.95,
                    1.89,
                    2.01,
                    2.05,
                    2.03,
                    2.04,
                    2.01,
                    1.93,
                    2.1,
                    2.05,
                    2.24,
                    2.08,
                    2.21,
                    2.18
                ],
                "name": "Packagist"
            },
            {
                "data": [
                    NaN,
                    0.0,
                    NaN,
                    0.0,
                    0.0,
                    0.0,
                    0.0,
                    0.0,
                    11.11,
                    20.0,
                    10.0,
                    5.88,
                    5.26,
                    4.35,
                    2.86,
                    3.77,
                    1.45,
                    4.35,
                    3.19,
                    2.52,
                    1.44,
                    1.32,
                    1.12,
                    3.12,
                    1.78,
                    1.61,
                    2.22,
                    1.71,
                    1.04,
                    2.29,
                    1.96,
                    1.68,
                    1.75,
                    1.07,
                    1.73,
                    2.42,
                    1.94,
                    1.84,
                    1.27,
                    1.88,
                    1.49,
                    1.73,
                    1.06,
                    1.47,
                    1.76
                ],
                "name": "PlatformIO"
            },
            {
                "data": [
                    0.0,
                    NaN,
                    NaN,
                    NaN,
                    NaN,
                    0.0,
                    NaN,
                    NaN,
                    NaN,
                    NaN,
                    NaN,
                    NaN,
                    NaN,
                    NaN,
                    NaN,
                    0.0,
                    0.0,
                    0.0,
                    1.89,
                    4.71,
                    2.36,
                    2.26,
                    3.35,
                    3.7,
                    2.82,
                    2.3,
                    2.72,
                    2.65,
                    2.03,
                    2.95,
                    2.35,
                    2.9,
                    2.46,
                    3.15,
                    3.02,
                    2.18,
                    3.22,
                    3.36,
                    2.75,
                    3.05,
                    3.16,
                    2.65,
                    1.94,
                    2.6,
                    2.37
                ],
                "name": "Pub"
            },
            {
                "data": [
                    0.0,
                    0.0,
                    0.0,
                    0.0,
                    0.0,
                    0.0,
                    0.0,
                    0.0,
                    0.0,
                    6.67,
                    4.17,
                    7.69,
                    3.85,
                    2.0,
                    1.3,
                    2.15,
                    1.72,
                    0.88,
                    1.62,
                    0.97,
                    1.45,
                    1.28,
                    1.64,
                    1.12,
                    0.9,
                    1.4,
                    1.79,
                    1.56,
                    1.29,
                    2.03,
                    1.67,
                    1.4,
                    1.69,
                    1.61,
                    1.68,
                    2.16,
                    1.9,
                    1.87,
                    2.03,
                    2.92,
                    2.6,
                    2.38,
                    2.67,
                    2.47,
                    2.45
                ],
                "name": "Puppet"
            },
            {
                "data": [
                    1.55,
                    1.85,
                    1.71,
                    1.31,
                    1.94,
                    1.69,
                    2.01,
                    1.34,
                    1.45,
                    2.13,
                    2.32,
                    2.07,
                    1.73,
                    1.87,
                    2.0,
                    1.84,
                    1.74,
                    2.0,
                    2.21,
                    1.85,
                    2.09,
                    2.34,
                    2.28,
                    2.27,
                    2.59,
                    2.62,
                    2.63,
                    2.69,
                    2.73,
                    2.69,
                    2.94,
                    2.92,
                    2.78,
                    3.01,
                    3.12,
                    3.26,
                    3.21,
                    3.25,
                    3.41,
                    3.46,
                    3.41,
                    3.5,
                    3.65,
                    3.54,
                    3.6
                ],
                "name": "Pypi"
            },
            {
                "data": [
                    2.57,
                    1.6,
                    1.7,
                    1.42,
                    1.77,
                    1.47,
                    1.28,
                    1.3,
                    1.35,
                    1.72,
                    1.97,
                    1.72,
                    1.63,
                    1.8,
                    2.08,
                    1.79,
                    1.84,
                    1.8,
                    2.06,
                    1.87,
                    1.89,
                    2.12,
                    2.25,
                    2.29,
                    2.33,
                    2.63,
                    2.71,
                    2.71,
                    2.7,
                    2.8,
                    3.32,
                    3.16,
                    3.22,
                    3.36,
                    3.28,
                    3.42,
                    3.28,
                    3.65,
                    3.93,
                    3.82,
                    3.97,
                    4.05,
                    4.15,
                    3.95,
                    3.77
                ],
                "name": "RubyGems"
            }
        ],
        "height_ratio": 69.23076923076923,
        "label_y": "Women in Projects (%)",
        "subtitle": "2008-3 - 2019-3",
        "title": "Percentage of Women Across Languages ",
        "x_categories": [
            "2008-3",
            "2008-6",
            "2008-9",
            "2008-12",
            "2009-3",
            "2009-6",
            "2009-9",
            "2009-12",
            "2010-3",
            "2010-6",
            "2010-9",
            "2010-12",
            "2011-3",
            "2011-6",
            "2011-9",
            "2011-12",
            "2012-3",
            "2012-6",
            "2012-9",
            "2012-12",
            "2013-3",
            "2013-6",
            "2013-9",
            "2013-12",
            "2014-3",
            "2014-6",
            "2014-9",
            "2014-12",
            "2015-3",
            "2015-6",
            "2015-9",
            "2015-12",
            "2016-3",
            "2016-6",
            "2016-9",
            "2016-12",
            "2017-3",
            "2017-6",
            "2017-9",
            "2017-12",
            "2018-3",
            "2018-6",
            "2018-9",
            "2018-12",
            "2019-3"
        ]
    }
};
var data_percent = {
    "Contributor": {
        "data": [
            {
                "data": [
                    671,
                    735,
                    871,
                    935,
                    1125,
                    1182,
                    1285,
                    1499,
                    1752,
                    1872,
                    2280,
                    2686,
                    3138,
                    3813,
                    4454,
                    5087,
                    7056,
                    7665,
                    9901,
                    10365,
                    14119,
                    15865,
                    19211,
                    21473,
                    24790,
                    26845,
                    30222,
                    33001,
                    38836,
                    41655,
                    43303,
                    47673,
                    52313,
                    53820,
                    55655,
                    60419,
                    64837,
                    69074,
                    73321,
                    77060,
                    81058,
                    83739,
                    87407,
                    92051,
                    91846
                ],
                "name": "Unknown"
            },
            {
                "data": [
                    1309,
                    1848,
                    2237,
                    2602,
                    3264,
                    3537,
                    3939,
                    4816,
                    5897,
                    6541,
                    8107,
                    9753,
                    12311,
                    15188,
                    17844,
                    20464,
                    27075,
                    29406,
                    34929,
                    36568,
                    47195,
                    51517,
                    58783,
                    64011,
                    74125,
                    78745,
                    84447,
                    90500,
                    103799,
                    108830,
                    111221,
                    117966,
                    129231,
                    129819,
                    130713,
                    135715,
                    146357,
                    147191,
                    150865,
                    156176,
                    162510,
                    161787,
                    160435,
                    164689,
                    162174
                ],
                "name": "Male"
            },
            {
                "data": [
                    39,
                    40,
                    53,
                    50,
                    73,
                    80,
                    89,
                    95,
                    112,
                    155,
                    195,
                    216,
                    270,
                    321,
                    401,
                    449,
                    563,
                    661,
                    857,
                    851,
                    1168,
                    1319,
                    1604,
                    1776,
                    2149,
                    2413,
                    2738,
                    2942,
                    3413,
                    3821,
                    4103,
                    4336,
                    4866,
                    5130,
                    5350,
                    5654,
                    6131,
                    6572,
                    7022,
                    7340,
                    7633,
                    7992,
                    8185,
                    8408,
                    8362
                ],
                "name": "Female"
            }
        ],
        "height_ratio": 69.23076923076923,
        "label_y": "Percent",
        "subtitle": "2008-3 - 2019-3",
        "title": "% OSS Contributors by Gender ",
        "x_categories": [
            "2008-3",
            "2008-6",
            "2008-9",
            "2008-12",
            "2009-3",
            "2009-6",
            "2009-9",
            "2009-12",
            "2010-3",
            "2010-6",
            "2010-9",
            "2010-12",
            "2011-3",
            "2011-6",
            "2011-9",
            "2011-12",
            "2012-3",
            "2012-6",
            "2012-9",
            "2012-12",
            "2013-3",
            "2013-6",
            "2013-9",
            "2013-12",
            "2014-3",
            "2014-6",
            "2014-9",
            "2014-12",
            "2015-3",
            "2015-6",
            "2015-9",
            "2015-12",
            "2016-3",
            "2016-6",
            "2016-9",
            "2016-12",
            "2017-3",
            "2017-6",
            "2017-9",
            "2017-12",
            "2018-3",
            "2018-6",
            "2018-9",
            "2018-12",
            "2019-3"
        ]
    }
};
var data_dumbbell = {
    "Contributor": {
        "data": [
            {
                "high": 7.69,
                "low": 0.0,
                "name": "Puppet"
            },
            {
                "high": 4.71,
                "low": 0.0,
                "name": "Pub"
            },
            {
                "high": 20.0,
                "low": 0.0,
                "name": "PlatformIO"
            },
            {
                "high": 2.24,
                "low": 0.0,
                "name": "Packagist"
            },
            {
                "high": 9.09,
                "low": 0.0,
                "name": "Meteor"
            },
            {
                "high": 3.7,
                "low": 0.0,
                "name": "Hex"
            },
            {
                "high": 3.12,
                "low": 0.0,
                "name": "Hackage"
            },
            {
                "high": 6.67,
                "low": 0.0,
                "name": "Go"
            },
            {
                "high": 2.8,
                "low": 0.0,
                "name": "CocoaPods"
            },
            {
                "high": 3.19,
                "low": 0.0,
                "name": "Clojars"
            },
            {
                "high": 3.9,
                "low": 0.0,
                "name": "Cargo"
            },
            {
                "high": 6.95,
                "low": 0.0,
                "name": "CRAN"
            },
            {
                "high": 14.29,
                "low": 0.0,
                "name": "Atom"
            },
            {
                "high": 14.29,
                "low": 0.0,
                "name": "Atom"
            },
            {
                "high": 2.32,
                "low": 0.41,
                "name": "NuGet"
            },
            {
                "high": 3.83,
                "low": 1.07,
                "name": "Bower"
            },
            {
                "high": 3.83,
                "low": 1.07,
                "name": "Bower"
            },
            {
                "high": 3.43,
                "low": 1.21,
                "name": "NPM"
            },
            {
                "high": 4.15,
                "low": 1.28,
                "name": "RubyGems"
            },
            {
                "high": 3.65,
                "low": 1.31,
                "name": "Pypi"
            },
            {
                "high": 3.42,
                "low": 1.48,
                "name": "Maven"
            },
            {
                "high": 4.56,
                "low": 2.0,
                "name": "CPAN"
            },
            {
                "high": 4.56,
                "low": 2.0,
                "name": "CPAN"
            }
        ],
        "height_ratio": 69.23076923076923,
        "label_y": "Percentage of Women (%)",
        "subtitle": "2008-3 - 2019-3",
        "title": "Min and Max % Women in Ecosystems 2008-2019"
    }
};
export { data, data_pie, data_bar, data_stack, data_percent, data_dumbbell };
